(function () {
    'use strict';

    angular
        .module('inspinia', ['ngAnimate',
            'ngCookies',
            'ngTouch',
            'ngSanitize',
            'ngMessages',
            'ngAria',
            'ngResource',
            'ui.router',
            'ui.bootstrap',
            'wj',
            'rx',
            'chart.js',
            'datePicker',
            'isteven-multi-select',
            'ngFileUpload'
        ]);
})();

'use strict';

angular.module('inspinia')
  .controller('userListController', function($scope,
    usersService,
    toolboxService,
    authenticationService) {

    var ul = this;
    var evtkey = 'userListController';

    ul.showSpinner = true;
    ul.isSuperAdmin = false;

    ul.$onInit = function() {

      ul.showSpinner = true;

      usersService.getAll()
        .then(function(data) {
          startUpGrid(data);
        }, function(error) {
          console.log(error);
        });

        authenticationService.isSuperAdmin().then(function(b) {
          ul.isSuperAdmin = b;
        });
    };

    ul.initGrid = function(sender, args) {
      var flex = sender;
      flex.rows.defaultSize = 32;
      flex.columnHeaders.rows.defaultSize = 36;

      ul.flexGridFilter = new wijmo.grid.filter.FlexGridFilter(flex);

      ul.flexGridFilter.filterChanged.addHandler(function(s) {
        ul.flex.select(-1, -1);
        ul.data.filter = null;
      });

      ul.flexGridFilter.filterApplied.addHandler(function(s) {
        ul.flex.select(0, 0);
      });

    };

    ul.editUser = function(user) {

      toolboxService.setOptions({
        title: 'Edit User: ' + user.UserName,
        content: '<user-edit new-user="false" user=\'' + JSON.stringify(user) + '\'></user-edit>',
        show: true,
        from: evtkey,
        wrapperClass: 'smallWidth'
      });
    };

    ul.addUser = function() {

      toolboxService.setOptions({
        title: 'Add User',
        content: '<user-edit new-user="true" user=""></user-edit>',
        show: true,
        from: evtkey,
        wrapperClass: 'smallWidth'
      });
    }

    ul.deleteUser = function(user) {            
      toolboxService.setOptions({
        title: 'Delete User: ' + user.UserName,        
        content: '<user-delete user-name="' + user.UserName + '"></user-delete>',
        show: true,
        from: evtkey,
        wrapperClass: 'smallWidth'
      });
    };

    ul.changePassword = function(user) {
      toolboxService.setOptions({
        title: 'Change Password: ' + user.UserName,
        content: '<user-password user=\'' + JSON.stringify(user) + '\'></user-password>',
        show: true,
        from: evtkey,
        wrapperClass: 'smallWidth'
      });
    };

    ul.loginHistory = function(companyId, userName) {
      toolboxService.setOptions({
        title: 'Login History',
        content: '<login-history company-id="' + companyId + '" user-name=\''+ JSON.stringify(userName) + '\'"></login-history>',
        show: true,
        from: evtkey,
        wrapperClass: 'extWidth'
      });
    };

    ul.download = function() {
      // Save the flexGrid to xlsx file.
      // issue not export all rows
      // Disable pagination / export / enable again
      var paging = {
        pageSize: ul.flex.itemsSource.pageSize,
        pageIndex: ul.flex.itemsSource.pageIndex,
        currentItem: ul.flex.itemsSource.currentItem
      };

      ul.flex.itemsSource.pageSize = ul.flex.itemsSource.totalItemCount;

      wijmo.grid.xlsx.FlexGridXlsxConverter.save(
        ul.flex,
        {
          includeColumnHeaders: true,
          includeColumns: function(column) {
            return column.binding !== null;
          }
        },
        "users-list.xlsx"
      );

      ul.flex.itemsSource.pageSize = paging.pageSize;
      ul.flex.itemsSource.moveToPage(paging.pageIndex);
      ul.flex.itemsSource.currentItem = paging.currentItem;
    };

    function startUpGrid(data) {

      var cv = new wijmo.collections.CollectionView(data);
      ul.data = cv;
      ul.showSpinner = false;
    }

  });

'use strict';

angular.module('inspinia')
  .component('userList', {
    templateUrl: 'app/components/user-list/user-list.html',
    controller: 'userListController',
    controllerAs: 'ul'
  });

(function() {
  'use strict';

  function toolboxLink($scope, $element, $attrs) {
    var dynamicContainer =
      $element.find('dynamic-content');

    $scope.toolbox.getOptions().subscribe(function(options) {

      if (options.content) {
        dynamicContainer.html(options.content);
        $scope.compile(dynamicContainer.contents())($scope);
      }
    });

  }

  angular.module('inspinia')
    .directive('toolbox', function() {
      return {
        scope: {
          options: '='
        },
        restrict: 'E',
        link: toolboxLink,
        controller: 'toolboxController',
        templateUrl: 'app/components/toolbox/toolbox.html'
      }
    });

})();

'use strict';

angular.module('inspinia')
  .controller('toolboxController', function($scope, $compile, toolboxService) {

    $scope.toolbox = toolboxService;
    $scope.localOptions = angular.extend({
      show: false,
      wrapperClass: null
    }, $scope.options);
    $scope.compile = $compile;

    toolboxService.getOptions().subscribe(function(options) {
      $scope.localOptions = options;
    });

  });

'use strict';

angular.module('inspinia')
  .controller('viewDetailController', function($scope) {

    var vd = this;

    vd.$onInit = function() {

      vd.childColumns = 12 - this.parentColumns;
      vd.showDetail = this.showInStartUp;

      vd.setCurrentColumns();
    };

    vd.setCurrentColumns = function() {
      vd.currentColumns = 12;
      if (vd.showDetail) {
        vd.currentColumns = vd.parentColumns;
      }
    }

    vd.toggleView = function(elm) {
      vd.showDetail = !vd.showDetail;
      vd.setCurrentColumns();
      //console.log(elm.target)
    }
  });

'use strict';

angular.module('inspinia')
  .component('viewDetail', {
    templateUrl: 'app/components/view-detail/view-detail.html',
    controller: 'viewDetailController',
    controllerAs: 'vd',
    bindings: {
      parentColumns: '<',
      showInStartUp: '<'
    },
    transclude: {
      'parent': 'viewDetailParent',
      'child': 'viewDetailChild'
    },
  });

'use strict';

angular.module('inspinia')
  .controller('userDeleteController', function(usersService, feedbackMessage, toolboxService) {

    var ud = this;

    ud.delete = function() {        
        usersService.delete(ud.userName).then(function(data) {
            ud.processResponse(data);
        });
    }

    ud.processResponse = function(data) {        
        feedbackMessage.showMessage(data.Message, (data.Status === "OK") ? 'success' : 'error');
        if (data.Status === "OK") {
            toolboxService.hide();
            location.reload(); // Reload screen to update changes
        }
      }

    ud.cancel = function() {
      toolboxService.hide();
    }
});
'use strict';

angular.module('inspinia')
  .component('userDelete', {
    templateUrl: 'app/components/user-delete/user-delete.html',
    controller: 'userDeleteController',
    controllerAs: 'ud',
    bindings: {
        userName: '@'
      }
  });
'use strict';

angular.module('inspinia')
  .controller('userPasswordController', function(usersService, feedbackMessage, toolboxService) {

    var up = this;
    up.confirmPassword = null;

    up.update = function() {
      usersService.changePassword(up.user).then(function(data) {        
        if (!data) {
          feedbackMessage.showMessage('Oh no something has gone wrong!', 'error');
        }
        else if (data.Status === 'OK') {
            feedbackMessage.showMessage(data.Message, 'success');
        }
        else {
            feedbackMessage.showMessage(data.Message, 'warning');
        }
      })
      .catch(function (error) {         
        var errorMessage = "Internal Server Error";
        if(error && error.data && error.data.ExceptionMessage) {
          errorMessage = error.data.ExceptionMessage;
        }
        feedbackMessage.showMessage(errorMessage, 'error'); 
      });
    }

    up.cancel = function() {
      toolboxService.hide();
    }
  });

'use strict';

angular.module('inspinia')
  .component('userPassword', {
    templateUrl: 'app/components/user-password/user-password.html',
    controller: 'userPasswordController',
    controllerAs: 'up',
    bindings: {
      user: '<'
    }
  });

'use strict';

angular.module('inspinia')
  .controller('statsGraphController', function() {
    var sg = this;
    sg.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      tooltips: {
        enabled: false
      },
      plugins: {
        datalabels: false   
      }
    };
  });

'use strict';

angular.module('inspinia')
  .component('statsGraph', {
    templateUrl: 'app/components/stats-graph/stats-graph.html',
    controller: 'statsGraphController',
    controllerAs: 'sg',
    bindings: {
      graphData: '<',
      externalOptions: '=?'
    }
  });

'use strict';

angular.module('inspinia')
  .controller('userEditController', function(companyService, usersService, authenticationService, feedbackMessage, toolboxService) {

    var ue = this;

    ue.showSpinner = true;
    ue.additionalCompanies = [];
    ue.isSuperAdmin = false;

    ue.roles = [];

    ue.$onInit = function() {

      ue.showSpinner = true;
      
      authenticationService.isSuperAdmin()
        .then(function(d) {
          ue.isSuperAdmin = d;

          usersService.listRoles()
            .then(function(data) {
              // SuperAdmin users can only be set in the DB. 
              // Regular administrators can't create users with a SuperAdmin role.
              if(ue.isSuperAdmin) {
                ue.roles = data;
              } else {
                var roles = [];
                for (var i = 0; i < data.length; i++) {
                  if(data[i] != 'SuperAdmin') {
                    roles.push(data[i]);
                  }
                }
                ue.roles = roles;
              }
            });
        });

      companyService.getAll()
        .then(function(data) {
          ue.companyList = data;
          ue.additionalCompanyList = data;

          if (data && !ue.newUser) {
            ue.selectedCompany = data.find(function(company) {
              return company.CompanyID == ue.user.CompanyID;
            });

            // Set additional companies
            ue.changeCompany(ue.selectedCompany);

            for (var i = 0; i < ue.user.AdditionalCompanies.length; i++) {
              for (var j = 0; j < data.length; j++) {
                if (ue.user.AdditionalCompanies[i] == data[j].CompanyID)
                  ue.additionalCompanies.push(data[j]);
              }
            }
          }
        }, function(error) {
          console.log(error);
        });

      ue.showSpinner = false;
    };

    ue.changeCompany = function(company) {
      // Exclude current company from additional companies list
      var lst = angular.copy(ue.companyList);
      if (company) {
        for (var i = 0; i < ue.companyList.length; i++) {
          if (ue.companyList[i].CompanyID == company.CompanyID) {
            lst.splice(i, 1);
            break;
          }
        }
      }

      ue.additionalCompanyList = lst;
    }


    ue.update = function() {
      if (ue.selectedCompany) {
        ue.user.CompanyID = ue.selectedCompany.CompanyID;
      } else {
        ue.user.CompanyID = -1;
      }

      ue.user.AdditionalCompanies = [];

      for (var i = 0; i < ue.additionalCompanies.length; i++) {
        ue.user.AdditionalCompanies.push(ue.additionalCompanies[i].CompanyID);
      }
      
      if (ue.newUser) {
        usersService.create(ue.user).then(function(data) {
          ue.processResponse(data);
        });
      } else {
        usersService.update(ue.user).then(function(data) {
          ue.processResponse(data);
        });
      }
    }

    ue.processResponse = function(data) {
      feedbackMessage.showMessage(data.Message, (data.Status === "OK") ? 'success' : 'error');
      if (data.Status === "OK") {
        toolboxService.hide();
        location.reload(); // Reload screen to update changes
      }
    }

    ue.cancel = function() {
      toolboxService.hide();
    }
  });
  
'use strict';

angular.module('inspinia')
  .component('userEdit', {
    templateUrl: 'app/components/user-edit/user-edit.html',
    controller: 'userEditController',
    controllerAs: 'ue',
    bindings: {
      user: '<',
      newUser: '<'
    }
  });

'use strict';

angular.module('inspinia')
  .controller('userSettingsController', function(companyService, authenticationService) {
    var uc = this;

    uc.$onInit = function() {
      getUserData();
      companyService.getActualCompany().subscribe(function(company) {
        getUserData();
        //getCompanyName();
      });

    };

    // get the user's name and last name
    function getUserData() {
      authenticationService.getUserData().then(function(data) {

        uc.name = data.FirstName + ' ' + data.LastName;
        uc.isAdmin = data.IsAdmin;
        uc.isEmployee = data.IsEmployee;
      });
    }

    // get the company's name
    /*
    function getCompanyName() {
        companyService.get().then(function (data) {
            uc.companyName = data.CompanyFullName;
        });
    }*/

  });

'use strict';

angular.module('inspinia')
  .component('userSettings', {
    templateUrl: 'app/components/user/user.html',
    controller: 'userSettingsController',
    controllerAs: 'uc'
  });

(function () {
    'use strict';

    function tooltipLink($scope, $element, $attrs) {

        var tooltip = angular.element('<i class="fa fa-commenting-o"></i>');
        $element.append(tooltip);

        $element.addClass('sk-tooltip');

        var el = $element[0];
        $scope.$watch(function () {
            return !$scope.inHeight ? el.scrollWidth : el.scrollHeight;
        }, function () {

            var check = (el.offsetWidth < el.scrollWidth);

            if ($scope.inHeight) {
                check = (el.offsetHeight < el.scrollHeight);
            }

            if (check) {
                $element.addClass('on');
                $element.attr('title', $scope.tooltipTextOverflow);
                tooltip.attr('title', $scope.tooltipTextOverflow);
            } else {
                $element.removeClass('on');
                $element.removeAttr('title');
                tooltip.removeAttr('title');
            }
            });

        $scope.$watch('tooltipTextOverflow', function (value) {
            var check = (el.offsetWidth < el.scrollWidth);
            
            if ($scope.inHeight) {
                check = (el.offsetHeight < el.scrollHeight);
            }
            
            if (value && check) {
                $element.attr('title', value);
                tooltip.attr('title', value);
            }
        });
        
    }

    angular.module('inspinia')
        .directive('tooltipTextOverflow', function () {
            return {
                scope: {
                    tooltipTextOverflow: '=',
                    inHeight: '='
                },
                replace: false,
                restrict: 'A',
                link: tooltipLink
            }
        });

})();
'use strict';

angular.module('inspinia')
  .controller('statsPanelController', function() {});

'use strict';

angular.module('inspinia')
  .component('statsPanel', {
    templateUrl: 'app/components/stats-panel/stats-panel.html',
    controller: 'statsPanelController',
    controllerAs: 'panel',
    bindings: {
      title: '@',
      asOfDate: '<',
      total: '@',
      totalType: '@',
      totalCaption: '@',
      graphData: '<',
      showSpinner: '<',
      externalOptions: '=?'
    }
  });

"use strict";

angular
  .module("inspinia")
  .controller("totalPremiumDueController", function ($scope, policiesService, borrowersService, companyService) {
    var tpd = this;
    tpd.showShareInfo = false;

    function subscribeToActualBorrower() {
      // Subscribe to global variable: Portfolio
      borrowersService.getActualBorrower().subscribe(function (borrower) {
        tpd.showSpinner = true;
        var policyStatus = policiesService.getCurrentPolicyStatus().value;

        if (borrower && policyStatus) {
          policiesService
            .getTotalPremiumDue(borrower.BorrowerID, policyStatus.value)
            .then(function (res) {
              if (res.length > 0) {
                // Format data
                res.map(function (x) {                  
                  var i =  findMonthIndex(tpd.graphData, x.ForecastDate);

                  if (i >= 0) {
                    tpd.graphData[i].year = moment(x.ForecastDate).format("yyyy");
                    tpd.graphData[i].month = moment(x.ForecastDate).format("MMM");
                    tpd.graphData[i].amount = x.Amount;
                    tpd.graphData[i].isActive = false;
                    tpd.graphData[i].tooltip =  getTooltipInfo(x.ForecastDate)
                    
                    // fractionality 
                    var monthTotal = x.ABDTotal + x.CFHTotal + x.NiranTotal + x.PHTTotal;
                    var phtTotal = x.PHTTotal + x.ABDTotal + x.NiranTotal;
                    tpd.graphData[i].cfhPercent =  parseFloat(x.CFHTotal/monthTotal) * 100;
                    tpd.graphData[i].phtPercent =  parseFloat(phtTotal.toFixed(4)/monthTotal) * 100;
                  }
                })

                // Set initial values
                tpd.total = tpd.graphData[0].amount;
                tpd.graphData[0].isActive = true;
                tpd.cfhPercent = tpd.graphData[0].cfhPercent;
                tpd.phtPercent = tpd.graphData[0].phtPercent;
              } else {
                setInitialData();
              }
              tpd.showSpinner = false;
            });
        }

        tpd.showShareInfo = false;
        companyService.showShareInfo().then(function(b) {        
          tpd.showShareInfo = b;
        });
      });
    }

    function subscribeToPolicyStatus() {
      // Subscribe to global variable: Policy Status
      policiesService.getCurrentPolicyStatus().subscribe(function (policyStatus) {
        tpd.showSpinner = true;
        var borrower = borrowersService.getActualBorrower().value;

        if (policyStatus && borrower) {
          policiesService
            .getTotalPremiumDue(borrower.BorrowerID, policyStatus.value)
            .then(function (res) {
              if (res.length > 0) {
                // Format data
                res.map(function (x, i) {                  
                  var i =  findMonthIndex(tpd.graphData, x.ForecastDate);

                  if (i >= 0) {
                    tpd.graphData[i].year = moment(x.ForecastDate).format("yyyy");
                    tpd.graphData[i].month = moment(x.ForecastDate).format("MMM");
                    tpd.graphData[i].amount = x.Amount;
                    tpd.graphData[i].isActive = false;
                    tpd.graphData[i].tooltip =  getTooltipInfo(x.ForecastDate)                    
                    
                    // fractionality
                    var monthTotal = x.ABDTotal + x.CFHTotal + x.NiranTotal + x.PHTTotal;
                    var phtTotal = x.PHTTotal + x.ABDTotal + x.NiranTotal;
                    tpd.graphData[i].cfhPercent =  parseFloat(x.CFHTotal/monthTotal) * 100;
                    tpd.graphData[i].phtPercent =  parseFloat(phtTotal.toFixed(4)/monthTotal) * 100;
                  }
                })
                
                // Set initial values
                tpd.total = tpd.graphData[0].amount;
                tpd.graphData[0].isActive = true;
                tpd.cfhPercent = tpd.graphData[0].cfhPercent;
                tpd.phtPercent = tpd.graphData[0].phtPercent;
              } else {
                setInitialData();
              }
              tpd.showSpinner = false;
            });
        }
      });
    }

    function getTooltipInfo(d) {
      return moment(d).format("MMM") + " " + moment(d).format("YYYY") ;
    }

    function findMonthIndex(items, forecastDate) {
      var index = -1;
      for (var i = 0; i < items.length; ++i) {
          if (items[i].month === moment(forecastDate).format("MMM")) {
              index = i;
              break;
          }
        }
                
        return index;
    }

    function setInitialData() {
      tpd.title = "Total Premium Due";
      tpd.total = 0;
      tpd.asOfDate = moment().format("MM/DD/YYYY");
      tpd.graphData = [];

      var months = (new Date).getMonth() + 1;
      for (var i = months; i < months + 12; i++) {
        tpd.graphData.push({
          year: moment().format("yyyy"),
          month: moment().month(i).format("MMM"),
          amount: 0,
          isActive: i === months ? true : false
        })
      }
    }

    tpd.$onInit = function () {
      tpd.showSpinner = true;
      setInitialData();

      subscribeToActualBorrower();
      subscribeToPolicyStatus();
    }

    tpd.toggleActive = function (e) {
      tpd.graphData.map(function (x) { x.isActive = false });
      tpd.graphData[e.currentTarget.id].isActive = true;
      tpd.total = tpd.graphData[e.currentTarget.id].amount;
      tpd.cfhPercent = tpd.graphData[e.currentTarget.id].cfhPercent;
      tpd.phtPercent = tpd.graphData[e.currentTarget.id].phtPercent;
    }
  });

'use strict';

angular.module('inspinia')
  .component('totalPremiumDue', {
    templateUrl: 'app/components/total-premium-due/total-premium-due.html',
    controller: 'totalPremiumDueController',
    controllerAs: 'tpd'
  });

(function() {
  'use strict';

  function spinnerLink($scope, $element, $attrs) {

    var skSpinner = angular.element('<div class="sk-spinner sk-spinner-fading-circle"/>');
    skSpinner.append('<div class="sk-circle1 sk-circle"/>');
    skSpinner.append('<div class="sk-circle2 sk-circle"/>');
    skSpinner.append('<div class="sk-circle3 sk-circle"/>');
    skSpinner.append('<div class="sk-circle4 sk-circle"/>');
    skSpinner.append('<div class="sk-circle5 sk-circle"/>');
    skSpinner.append('<div class="sk-circle6 sk-circle"/>');
    skSpinner.append('<div class="sk-circle7 sk-circle"/>');
    skSpinner.append('<div class="sk-circle8 sk-circle"/>');
    skSpinner.append('<div class="sk-circle9 sk-circle"/>');
    skSpinner.append('<div class="sk-circle10 sk-circle"/>');
    skSpinner.append('<div class="sk-circle11 sk-circle"/>');
    skSpinner.append('<div class="sk-circle12 sk-circle"/>');
    $element.append(skSpinner);

    $scope.$watch('spinner', function(value) {
      if (value) {
        $element.addClass('sk-loading');
      } else {
        $element.removeClass('sk-loading');
      }
    });
  }

  angular.module('inspinia')
    .directive('spinner', function() {
      return {
        scope: {
          spinner: '='
        },
        replace: false,
        restrict: 'A',
        link: spinnerLink
      }
    });

})();

"use strict";

angular
  .module("inspinia")
  .controller("statusPoliciesDetailController", function(
    $scope,
    policiesService,
    ServicesConstants
  ) {
    var spd = this;
    spd.statusTypes = ServicesConstants.Status;
    spd.status = this.statusType;
    spd.borrowerId = this.borrowerId;

    spd.showSpinner = true;

    spd.$onInit = function() {
      var policyStatus = policiesService.getCurrentPolicyStatus().value;

      policiesService
        .getByStatusBorrower(spd.status, spd.borrowerId, policyStatus.value)
        .then(
          function(data) {
            var cv = new wijmo.collections.CollectionView(data);
            // cv.pageSize = 18;
            spd.data = cv;

            spd.showSpinner = false;
          },
          function(error) {
            console.log(error);
          }
        );
    };

    spd.initGrid = function(sender, args) {
      var flex = sender;
      flex.rows.defaultSize = 32;
      flex.columnHeaders.rows.defaultSize = 36;

      flex.columnFooters.rows.push(new wijmo.grid.Row());
      flex.columnFooters.rows.push(new wijmo.grid.GroupRow());
    };
  });

'use strict';

angular.module('inspinia')
  .component('statusPoliciesDetail', {
    templateUrl: 'app/components/status-policies-detail/status-policies-detail.html',
    controller: 'statusPoliciesDetailController',
    controllerAs: 'spd',
    bindings: {
      statusType: '@',
      borrowerId: '@'
    },
  });

"use strict";

angular
  .module("inspinia")
  .controller("statusPoliciesListController", function(
    $scope,
    policiesService,
    borrowersService,
    toolboxService
  ) {
    var spl = this;
    var evtkey = "statusPoliciesListController";

    spl.showSpinner = true;
    spl.borrowerID = null;
    var currentStatus = null;

    function startUpGrid(data) {
      var cv = new wijmo.collections.CollectionView(data);

      spl.data = cv;
      spl.data.asOfDate = new Date(); // replace for real asOfDate

      cv.currentChanged.addHandler(function() {
        if (cv.currentItem) {
          toolboxService.setOptions({
            title: cv.currentItem.Status,
            content:
              '<status-policies-detail borrower-id="' +
              spl.borrowerID +
              '" status-type="' +
              cv.currentItem.Status +
              '"></status-policies-detail>',
            show: true,
            from: evtkey,
            wrapperClass: "largeWidth"
          });
        }
      });
    }

    function subscribeToActualBorrower() {
      borrowersService.getActualBorrower().subscribe(function(borrower) {
        spl.showSpinner = true;
        var policyStatus = policiesService.getCurrentPolicyStatus();
        if (borrower && policyStatus.value !== undefined) {
          spl.borrowerID = borrower.BorrowerID;
          policiesService
            .GetPoliciesGroupByStatus(
              borrower.BorrowerID,
              policyStatus.value.value
            )
            .then(
              function(data) {
                startUpGrid(data);
                spl.data.refresh();

                spl.showSpinner = false;
              },
              function(error) {
                console.log(error);
              }
            );
        }
      });
    }

    function subscribeToPolicyStatus() {
      policiesService
        .getCurrentPolicyStatus()
        .subscribe(function(policyStatus) {
          spl.showSpinner = true;
          var borrower = borrowersService.getActualBorrower();
          if (policyStatus && borrower.value !== undefined) {
            policiesService
              .GetPoliciesGroupByStatus(
                borrower.value.BorrowerID,
                policyStatus.value
              )
              .then(
                function(data) {
                  startUpGrid(data);
                  spl.data.refresh();
                  spl.showSpinner = false;
                },
                function(error) {
                  console.log(error);
                }
              );
          }
        });
    }

    spl.$onInit = function() {
      subscribeToActualBorrower();
      subscribeToPolicyStatus();
    };

    spl.onLoadedRows = function(flex) {
      setTimeout(function() {
        flex.select(-1, -1);
      }, 50);
    };

    spl.initGrid = function(sender, args) {
      var flex = sender;
      flex.rows.defaultSize = 32;
      flex.columnHeaders.rows.defaultSize = 36;
      flex.columnFooters.rows.push(new wijmo.grid.GroupRow());
    };

    spl.cellClick = function(sender) {
      var newValue = sender.Status;

      if (currentStatus === sender.Status) {
        newValue = null;
        spl.flex.select(-1, -1);
        toolboxService.hide();
      }

      currentStatus = newValue;
    };

    toolboxService.getOptions().subscribe(function(options) {
      var clear = options.from && options.from === evtkey && !options.show;

      if (clear) {
        spl.flex.select(-1, -1);
        currentStatus = null;
      }
    });
  });

'use strict';

angular.module('inspinia')
  .component('statusPoliciesList', {
    templateUrl: 'app/components/status-policies-list/status-policies-list.html',
    controller: 'statusPoliciesListController',
    controllerAs: 'spl'
  });

"use strict";

angular
  .module("inspinia")
  .controller("statsPanelsListController", function(
    borrowersService,
    policiesService,
    companyService,
    $filter
  ) {
    var panels = this;
    panels.showSpinner = false;

    function subscribeToActualBorrower() {
      borrowersService.getActualBorrower().subscribe(function(borrower) {
        panels.showSpinner = true;
        var policyStatus = policiesService.getCurrentPolicyStatus();
        if (borrower && policyStatus.value !== undefined) {
          policiesService
            .getTotals(borrower.BorrowerID, policyStatus.value.value)
            .then(
              function(data) {
                if (data.total > 0) {
                  panels.updateData(data);
                } else {
                  panels.setInitialData();
                }
                panels.showSpinner = false;
              },
              function(error) {
                console.log(error);
              }
            );
        }

        panels.showShareInfo = false;
        companyService.showShareInfo().then(function(b) {        
          panels.showShareInfo = b;
        });
      });
    }

    function subscribeToPolicyStatus() {
      policiesService
        .getCurrentPolicyStatus()
        .subscribe(function(policyStatus) {
          panels.showSpinner = true;
          var borrower = borrowersService.getActualBorrower();
          if (policyStatus && borrower.value !== undefined) {
            policiesService
              .getTotals(borrower.value.BorrowerID, policyStatus.value)
              .then(
                function(data) {
                  if (data.total > 0) {
                    panels.updateData(data);
                  } else {
                    panels.setInitialData();
                  }
                  panels.showSpinner = false;
                },
                function(error) {
                  console.log(error);
                }
              );
          }
        });
    }

    panels.$onInit = function() {
      panels.setInitialData();

      subscribeToPolicyStatus();
      subscribeToActualBorrower();
    };

    panels.setInitialData = function() {
      panels.policyCount = {
        title: "Policy Count",
        total: 0,
        totalType: "number",
        totalCaption: "Current",
        graphData: [
          {
            title: "Male",
            labels: ["Yes", "No"],
            data: [0, 100],
            colors: ["#3299CC", "#E6E6E6"]
          },
          {
            title: "Female",
            labels: ["Yes", "No"],
            data: [0, 100],
            colors: ["#55CEA5", "#E6E6E6"]
          }
        ]
      };
      panels.deathBenefit = {
        title: "Death Benefit",
        total: 0,
        totalType: "currency",
        totalCaption: "Total",
        graphData: [
          {
            labels: ["CFH", "PHT"],
            data: [0, 100],
            colors: ["#E6E6E6", "#3299CC"]
          }
        ]
      };
      panels.nextPremiumDue = {
        title: "Next Premium Due",
        asOfDate: null,
        total: 0,
        totalType: "currency",
        totalCaption: "Total"
      };
      panels.pendingClaims = {
        title: "Pending Claims",
        asOfDate: null,
        total: 0,
        totalType: "currency",
        totalCaption: "Total for " + 0 + " Policies",
        graphData: [
          {
            labels: ["CFH", "PHT"],
            data: [0, 100],
            colors: ["#E6E6E6", "#3299CC"]
          }
        ]
      };
    };

    panels.deathBenefitChartOptions = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },        
      legend: {
          display: false
      },
      tooltips: {
        enabled: true,
        callbacks: {
          label: function(tooltipItem, data) {
            var label = data['labels'][tooltipItem['index']] ;
            return (label == 'PHT') 
                      ? $filter('currency')(panels.deathBenefit.deathBenefitPHTCombined, '$', 2)
                      : $filter('currency')(panels.deathBenefit.deathBenefitCFH, '$', 2);
          }
        }
      }, 
      layout: {
        padding: 25
      },
      plugins: {
        datalabels: {
          align: 'end',
          anchor: 'end',
          backgroundColor: null,
          borderColor: null,
          borderRadius: 0,
          borderWidth: 0,
          color: '#777',
          font: {
            size: 11
          },
          offset: 5,
          padding: 0,
          formatter: function(value, context) {
            return (context.chart.data.labels[context.dataIndex] + '\n' + parseFloat(value * 100).toFixed(2) + '%') || null;
          }
        }
      }
  };

  panels.pendingClaimsChartOptions = {
    elements: {
      arc: {
        borderWidth: 0
      }
    },        
    legend: {
        display: false
    },
    tooltips: {
      enabled: true,
      callbacks: {
        label: function(tooltipItem, data) {
          var label = data['labels'][tooltipItem['index']] ;
          return (label == 'PHT') 
                    ? $filter('currency')(panels.pendingClaims.pendingClaimPHTCombined, '$', 2)
                    : $filter('currency')(panels.pendingClaims.pendingClaimCFH, '$', 2);
        }
      }
    }, 
    layout: {
      padding: 25
    },
    plugins: {
      datalabels: {
        align: 'end',
        anchor: 'end',
        backgroundColor: null,
        borderColor: null,
        borderRadius: 0,
        borderWidth: 0,
        color: '#777',
        font: {
          size: 11
        },
        offset: 5,
        padding: 0,
        formatter: function(value, context) {
          return (context.chart.data.labels[context.dataIndex] + '\n' + parseFloat(value * 100).toFixed(2) + '%') || null;
        }
      }
    }
};

    panels.updateData = function(data) {
      panels.policyCount.total = data.totalInForce;
      panels.policyCount.totalCaption = "Current";
      panels.policyCount.graphData[0].data = [
        data.male / data.total,
        1 - data.male / data.total
      ];
      panels.policyCount.graphData[1].data = [
        data.female / data.total,
        1 - data.female / data.total
      ];
      panels.deathBenefit.deathBenefitCFH = data.deathBenefitCFH;
      panels.deathBenefit.deathBenefitPHTCombined = data.deathBenefitPHTCombined;
      panels.deathBenefit.graphData[0].data = [
        data.deathBenefitCFH / data.deathBenefitFractionalityTotal,
        data.deathBenefitPHTCombined / data.deathBenefitFractionalityTotal
      ];
      panels.deathBenefit.total = data.deathBenefit;
      panels.nextPremiumDue.total = data.nextPremiumDue;
      panels.nextPremiumDue.asOfDate = new Date(); // replace for real asOfDate
      panels.pendingClaims.total = data.pendingClaims;
      panels.pendingClaims.asOfDate = new Date(); // replace for real asOfDate
      panels.pendingClaims.totalCaption =
        "Total for " + data.pendingClaimsTotal + " Policies";
      
      panels.pendingClaims.pendingClaimCFH = data.pendingClaimCFH;
      panels.pendingClaims.pendingClaimPHTCombined = data.pendingClaimPHTCombined;
      panels.pendingClaims.graphData[0].data = [
        data.pendingClaimCFH / data.pendingClaimFractionalityTotal,
        data.pendingClaimPHTCombined / data.pendingClaimFractionalityTotal
      ];
    };
  });

'use strict';

angular.module('inspinia')
  .component('statsPanelsList', {
    templateUrl: 'app/components/stats-panels-list/stats-panels-list.html',
    controller: 'statsPanelsListController',
    controllerAs: 'panels'
  });

"use strict";

angular
  .module("inspinia")
  .controller("lifeExpectanciesController", function(
    policiesService,
    lifeExpectanciesService,
    reportUtilService,
    documentsService,
    borrowersService
  ) {
    var le = this;
    var columnsDate = "LEDate";

    le.showSpinner = true;

    le.$onInit = function() {
      policiesService.getActualPolicy().subscribe(function(policy) {
        le.showSpinner = true;

        if (policy) {
          lifeExpectanciesService.getByPolicy(policy).then(
            function(expectancies) {
              var cv = new wijmo.collections.CollectionView(expectancies, {
                sortConverter: reportUtilService.sortConverter(columnsDate)
              });
              le.data = cv;
              le.showSpinner = false;
            },
            function(error) {
              console.log(error);
            }
          );
        } else {
          le.showSpinner = false;
        }
      });
    };

    le.initGrid = function(sender, args) {
      var flex = sender;

      le.flexGridFilter = new wijmo.grid.filter.FlexGridFilter(flex);

      le.flexGridFilter.filterChanged.addHandler(function(s) {
        le.flex.select(-1, -1);
        le.data.filter = null;
      });
    };

    le.download = function(documentId) {
      documentsService
        .GetDocument({
          DocumentId: documentId,
          BorrowerId: borrowersService.getCurrentBorrower().BorrowerID
        })
        .then(function(data) {
          if (data.ExistsFile) {
            documentsService.Download(documentId).then(function(file) {
              var blob = new Blob([file], {
                type: data.DocType
              });
              var fileName = data.FileName;
              saveAs(blob, fileName);
            });
          } else {
            alert("File not found");
          }
        });
    };
  });

'use strict';

angular.module('inspinia')
  .component('lifeExpectancies', {
    templateUrl: 'app/components/life-expectancies/life-expectancies.html',
    controller: 'lifeExpectanciesController',
    controllerAs: 'le'
  });

'use strict';

angular.module('inspinia')
  .controller('portfolioPoliciesDetailController', function($scope, policiesService, borrowersService, $window, configService, companyService) {

    var ppd = this;
    ppd.showShareInfo = false;
    ppd.borrowerId = null;

    ppd.$onInit = function() {

      policiesService.getActualPolicy().subscribe(function(data) {
        ppd.policy = data;
        ppd.showSpinner = false;

        companyService.showShareInfo().then(function(b) {        
          ppd.showShareInfo = b;
        });
      });

      policiesService.onBeforeGetData().subscribe(function(options) {
        ppd.policy = {};
        ppd.showSpinner = (true && (options != "All"));
      });

      borrowersService.getActualBorrower().subscribe(function (borrower) {
        if (borrower) {
          ppd.borrowerId = borrower.BorrowerID;
        }
      });
    };

    ppd.values = function(id) {
      $window.open(configService.baseURL + '/Reports/GetCashValueDetailPDF?premID=' + id);
    } 

    ppd.stream = function(policyId, policyNumber) {
      var policyStatus = policiesService.getCurrentPolicyStatus().value;
      $window.open(configService.baseURL + '/Policies/GetStreamExcel?id=' + ppd.borrowerId + "&policyId=" + policyId + "&policyNumber=" + policyNumber + "&active=" + policyStatus.value);
    }

    ppd.register = function(policyId, policyNumber) {
      var policyStatus = policiesService.getCurrentPolicyStatus().value;
      $window.open(configService.baseURL + '/Policies/GetRegisterExcel?id=' + ppd.borrowerId + "&policyId=" + policyId + "&policyNumber=" + policyNumber + "&active=" + policyStatus.value);
    }

  });

'use strict';

angular.module('inspinia')
  .component('portfolioPoliciesDetail', {
    templateUrl: 'app/components/portfolio-policies-detail/portfolio-policies-detail.html',
    controller: 'portfolioPoliciesDetailController',
    controllerAs: 'ppd'
  });

'use strict';

angular.module('inspinia')
  .controller('premiumHistoryController', function(policiesService, premiumService, borrowersService, $filter) {
    var ph = this;

    ph.showSpinner = true;

    ph.$onInit = function() {

      policiesService.getActualPolicy().subscribe(function(policy) {

        ph.showSpinner = true;

        if (policy) {

          policy.borrower = borrowersService.getCurrentBorrower();
          premiumService.getByPolicy(policy).then(function(premium) {
            var cv = new wijmo.collections.CollectionView($filter('orderBy')(premium, 'DATE_ADDL_PREM_PAID', true));
            ph.data = cv;
            ph.showSpinner = false;
          }, function(error) {
            console.log(error);
          });
        } else {
          ph.showSpinner = false;
        }
      });

    };

    ph.initGrid = function(sender, args) {
      var flex = sender;
      flex.columnFooters.rows.push(new wijmo.grid.GroupRow());
    };
  });

'use strict';

angular.module('inspinia')
  .component('premiumHistory', {
    templateUrl: 'app/components/premium-history/premium-history.html',
    controller: 'premiumHistoryController',
    controllerAs: 'ph'
  });

"use strict";

angular
  .module("inspinia")
  .controller("premiumHistoryReportController", function(
    $scope,
    borrowersService,
    reportsService,
    reportUtilService,
    policiesService,
    $filter
  ) {
    var phr = this;

    phr.showSpinner = true;

    function subscribeToActualBorrower() {
      borrowersService.getActualBorrower().subscribe(function(borrower) {
        var policyStatus = policiesService.getCurrentPolicyStatus().value;
        if (borrower && policyStatus) {
          reportsService
            .getPremiumPayments(borrower, policyStatus.value)
            .then(function(data) {
              startUpGrid(data);
            });
        }
      });
    }

    function subscribeToCurrentPolicyStatus() {
      policiesService
        .getCurrentPolicyStatus()
        .subscribe(function(policyStatus) {
          var borrower = borrowersService.getActualBorrower().value;
          if (policyStatus && borrower) {
            reportsService
              .getPremiumPayments(borrower, policyStatus.value)
              .then(function(data) {
                startUpGrid(data);
              });
          }
        });
    }

    phr.$onInit = function() {
      phr.showSpinner = true;
      subscribeToActualBorrower();
      subscribeToCurrentPolicyStatus();
    };

    function startUpGrid(data) {
      var formattedData = [];

      for (var i = 0; i < data.length; i++) {
        formattedData.push(data[i]);
        formattedData[i].DATE_ADDL_PREM_PAID = $filter("date")(
          data[i].DATE_ADDL_PREM_PAID,
          "MM/dd/yyyy"
        );
      }

      var cv = new wijmo.collections.CollectionView(formattedData, {
        sortComparer: reportUtilService.sortComparerAlphanumeric
      });
      // var pageWrapperHeight = document.getElementById('page-wrapper').clientHeight;
      // cv.pageSize = (pageWrapperHeight / 57) - ((pageWrapperHeight / 57) % 1);
      phr.data = cv;
      phr.showSpinner = false;

      $scope.$watch("phr.filter", function(n, o) {
        reportUtilService.filterByInput({
          flexGridFilter: phr.flexGridFilter,
          flex: phr.flex,
          search: n
        });
      });
    }

    phr.initGrid = function(sender, args) {
      var flex = sender;

      phr.flexGridFilter = new wijmo.grid.filter.FlexGridFilter(flex);

      phr.flexGridFilter.filterChanged.addHandler(function(s) {
        phr.data.filter = null;
      });
    };

    phr.download = function() {
      // Save the flexGrid to xlsx file.
      // issue not export all rows
      // Disable pagination / export / enable again
      var paging = {
        pageSize: phr.flex.itemsSource.pageSize,
        pageIndex: phr.flex.itemsSource.pageIndex,
        currentItem: phr.flex.itemsSource.currentItem
      };

      phr.flex.itemsSource.pageSize = phr.flex.itemsSource.totalItemCount;

      wijmo.grid.xlsx.FlexGridXlsxConverter.save(
        phr.flex,
        {
          includeColumnHeaders: true
        },
        "premium-payment-history-report.xlsx"
      );

      phr.flex.itemsSource.pageSize = paging.pageSize;
      phr.flex.itemsSource.moveToPage(paging.pageIndex);
      phr.flex.itemsSource.currentItem = paging.currentItem;
    };
  });

'use strict';

angular.module('inspinia')
  .component('premiumHistoryReport', {
    templateUrl: 'app/components/premium-history-report/premium-history-report.html',
    controller: 'premiumHistoryReportController',
    controllerAs: 'phr'
  });

"use strict";

angular
  .module("inspinia")
  .controller("policyStatusDisclaimerController", function (
    $scope,
    policiesService
  ) {
    var psd = this;

    var statuses = [
      { id: 0, description: "Active", value: true },
      { id: 1, description: "Inactive", value: false }
    ];

    psd.$onInit = function () {
      policiesService
        .getCurrentPolicyStatus()
        .subscribe(function (policyStatus) {
          psd.policyStatus = policyStatus;
        });
    };

    psd.togglePolicyStatus = function () {
      var status = statuses.find(function (x) {
        if (x.value !== psd.policyStatus.value) return x;
      });

      policiesService.setPolicyStatus(status);
    };
  });

"use strict";

angular.module("inspinia").component("policyStatusDisclaimer", {
  templateUrl:
    "app/components/policy-status-disclaimer/policy-status-disclaimer.html",
  controller: "policyStatusDisclaimerController",
  controllerAs: "psd"
});

"use strict";

angular
  .module("inspinia")
  .controller("portfolioPoliciesListController", function(
    $scope,
    $filter,
    $timeout,
    policiesService,
    borrowersService,
    reportUtilService,
    companyService
  ) {
    var ppl = this;
    var columnsDate = "PolicyDate,DOB";

    ppl.cv = null;
    ppl.showShareInfo = false;
    ppl.showSpinner = true;

    function startUpGrid(data) {
      companyService.showShareInfo().then(function(b) {        
        ppl.showShareInfo = b;
      });

      var formattedData = [];
      for (var i = 0; i < data.length; i++) {
        formattedData.push(data[i]);
        formattedData[i].PolicyDate = $filter("date")(
          formattedData[i].PolicyDate,
          "MM/dd/yyyy"
        );
        formattedData[i].DOB = $filter("date")(
          formattedData[i].DOB,
          "MM/dd/yyyy"
        );

        formattedData[i].CallDate = $filter("date")(
          formattedData[i].CallDate,
          "MM/dd/yyyy"
        );
        formattedData[i].COI_DeductionDate = $filter("date")(
          formattedData[i].COI_DeductionDate,
          "MM/dd/yyyy"
        );
        formattedData[i].CoiCeaseDate = $filter("date")(
          formattedData[i].CoiCeaseDate,
          "MM/dd/yyyy"
        );
        formattedData[i].Age = Math.floor(formattedData[i].Age);
      }

      if (ppl.cv) {
        ppl.cv.currentChanged.removeHandler(changed);
      }

      ppl.cv = new wijmo.collections.CollectionView(formattedData, {
        sortConverter: reportUtilService.sortConverter(columnsDate),
        sortComparer: reportUtilService.sortComparerAlphanumeric
      });

      ppl.items = data;

      // cv.pageSize = 8;
      ppl.data = ppl.cv;
      ppl.showSpinner = false;

      
      $timeout(function() {
        if (ppl.flex) {
          ppl.flex.autoSizeColumn(0);
        }
      }, 0);

      var changed = function() {
        if (ppl.cv.currentItem) {
          policiesService.setActualPolicy({
            id: ppl.cv.currentItem.POLICIESID
          });
        }
      };

      ppl.cv.currentChanged.addHandler(changed);

      $scope.$watch("ppl.filter", function(n, o) {
        $timeout(function () {
          reportUtilService.filterByInput({
            flexGridFilter: ppl.flexGridFilter,
            flex: ppl.flex,
            search: n
          });
        }, 200);
      });
    }

    function subscribeToPolicyStatus() {
      policiesService
        .getCurrentPolicyStatus()
        .subscribe(function(policyStatus) {
          ppl.showSpinner = true;
          var borrower = borrowersService.getActualBorrower();
          if (policyStatus && borrower.value !== undefined) {
            policiesService
              .getByBorrower(borrower.value.BorrowerID, policyStatus.value)
              .then(
                function(data) {
                  startUpGrid(data);

                  if (data.length > 0) {
                    policiesService.setActualPolicy({
                      id: data[0].POLICIESID
                    });
                  }
                },
                function(error) {
                  console.log(error);
                }
              );
          }
        });
    }

    function subscribeToActualBorrower() {
      borrowersService.getActualBorrower().subscribe(function(borrower) {
        ppl.showSpinner = true;
        var policyStatus = policiesService.getCurrentPolicyStatus();
        if (borrower && policyStatus.value !== undefined) {
          policiesService
            .getByBorrower(borrower.BorrowerID, policyStatus.value.value)
            .then(
              function(data) {
                startUpGrid(data);

                if (data.length > 0) {
                  policiesService.setActualPolicy({
                    id: data[0].POLICIESID
                  });
                }
              },
              function(error) {
                console.log(error);
              }
            );
        }
      });
    }

    ppl.$onInit = function() {
      subscribeToActualBorrower();
      subscribeToPolicyStatus();
    };

    ppl.initGrid = function(sender, args) {
      var flex = sender;
      flex.rows.defaultSize = 32;
      flex.columnHeaders.rows.defaultSize = 36;
      flex.columnFooters.rows.push(new wijmo.grid.GroupRow());

      ppl.flexGridFilter = new wijmo.grid.filter.FlexGridFilter(flex);

      ppl.flexGridFilter.filterChanged.addHandler(function(s) {
        ppl.flex.select(-1, -1);
        ppl.data.filter = null;
      });

      ppl.flexGridFilter.filterApplied.addHandler(function(s) {
        ppl.flex.select(0, 0);
      });
    };

    ppl.download = function() {
      ppl.showSpinner = true;
      // Save the flexGrid to xlsx file.
      // issue not export all rows
      // Disable pagination / export / enable again
      var paging = {
        pageSize: ppl.flex.itemsSource.pageSize,
        pageIndex: ppl.flex.itemsSource.pageIndex,
        currentItem: ppl.flex.itemsSource.currentItem
      };

      ppl.flex.itemsSource.pageSize = ppl.flex.itemsSource.totalItemCount;

      var locColumns = [];
      var locSelected = ppl.flex.selectedRows[0].index;

      for (var i = 0; i < ppl.flex.columns.length; i++) {
        locColumns.push(ppl.flex.columns[i].visible);
        ppl.flex.columns[i].visible = true;
      }

      ppl.flex.select(-1, -1);

      wijmo.grid.xlsx.FlexGridXlsxConverter.save(
        ppl.flex,
        {
          includeColumnHeaders: true
        },
        "portfolio-policies.xlsx"
      );

      ppl.flex.itemsSource.pageSize = paging.pageSize;
      ppl.flex.itemsSource.moveToPage(paging.pageIndex);
      ppl.flex.itemsSource.currentItem = paging.currentItem;

      for (var i = 0; i < ppl.flex.columns.length; i++) {
        ppl.flex.columns[i].visible = locColumns[i];
      }

      ppl.flex.select(locSelected, 0);

      ppl.showSpinner = false;
    };
  });

'use strict';

angular.module('inspinia')
  .component('portfolioPoliciesList', {
    templateUrl: 'app/components/portfolio-policies-list/portfolio-policies-list.html',
    controller: 'portfolioPoliciesListController',
    controllerAs: 'ppl'
  });

"use strict";

angular
  .module("inspinia")
  .controller("portfolioDocumentsController", function(
    $scope,
    borrowersService,
    reportUtilService,
    policiesService,
    documentsService
  ) {
    var pd = this;

    pd.showSpinner = true;

    function subscribeToActualBorrower() {
      pd.showSpinner = true;

      borrowersService.getActualBorrower().subscribe(function(borrower) {
        var policyStatus = policiesService.getCurrentPolicyStatus();

        if (borrower && policyStatus.value !== undefined) {
          documentsService
            .GetDocumentsByCompanyUI(borrower, policyStatus.value.value, pd.clientDocuments)
            .then(
              function(data) {
                startUpGrid(data);
              },
              function(error) {
                console.log(error);
              }
            );
        }
      });
    }

    function subscribeToPolicyStatus() {
      pd.showSpinner = true;

      policiesService
        .getCurrentPolicyStatus()
        .subscribe(function(policyStatus) {
          var borrower = borrowersService.getActualBorrower();
          if (policyStatus && borrower.value !== undefined) {
            documentsService
              .GetDocumentsByCompanyUI(borrower.value, policyStatus.value, pd.clientDocuments)
              .then(
                function(data) {
                  startUpGrid(data);
                },
                function(error) {
                  console.log(error);
                }
              );
          }
        });
    }

    pd.$onInit = function() {
      pd.showSpinner = true;
      subscribeToActualBorrower();
      subscribeToPolicyStatus();
    };

    function startUpGrid(data) {
      
      var formattedData = [];
      for (var i = 0; i < data.length; i++) {
        formattedData.push(data[i]);
        formattedData[i].SyncDate = new Date(data[i].SyncDate);
        formattedData[i].DocumentDate = new Date(data[i].DocumentDate);
      }
      var cv = new wijmo.collections.CollectionView(formattedData);
      // var pageWrapperHeight = document.getElementById('page-wrapper').clientHeight;
      // cv.pageSize = (pageWrapperHeight / 53) - ((pageWrapperHeight / 53) % 1);
      pd.data = cv;
      pd.showSpinner = false;

      $scope.$watch("pd.filter", function(n, o) {
        reportUtilService.filterByInput({
          flexGridFilter: pd.flexGridFilter,
          flex: pd.flex,
          search: n
        });
      });
    }

    pd.initGrid = function(sender, args) {
      var flex = sender;

      pd.flexGridFilter = new wijmo.grid.filter.FlexGridFilter(flex);

      pd.flexGridFilter.filterChanged.addHandler(function(s) {
        pd.data.filter = null;
      });
    };

    pd.download = function(documentId) {
      documentsService
        .GetDocument({
          DocumentId: documentId,
          BorrowerId: borrowersService.getCurrentBorrower().BorrowerID
        })
        .then(function(data) {
          if (data.ExistsFile) {
            documentsService.Download(documentId).then(function(file) {
              var blob = new Blob([file], {
                type: data.DocType
              });
              var fileName = data.FileName;
              saveAs(blob, fileName);
            });
          } else {
            alert("File not found");
          }
        });
    };
  });

'use strict';

angular.module('inspinia')
  .component('portfolioDocuments', {
    templateUrl: 'app/components/portfolio-documents/portfolio-documents.html',
    controller: 'portfolioDocumentsController',
    controllerAs: 'pd',
    bindings: {
      clientDocuments: '<'
    }
  });

"use strict";

angular
  .module("inspinia")
  .controller("policyInvestorShareController", function(
    borrowersService,
    policiesService
  ) {
    var pinvshare = this;
    pinvshare.showSpinner = false;

    pinvshare.options = {
        elements: {
          arc: {
            borderWidth: 0
          }
        },        
        legend: {
            display: false
        },
        tooltips: {
          enabled: true,
          callbacks: {
            label: function(tooltipItem, data) {
              return data['labels'][tooltipItem['index']] + ': ' + data['datasets'][0]['data'][tooltipItem['index']] + '%';
            }
          }
        }, 
        layout: {
          padding: 32
        },
        plugins: {
          datalabels: {
            align: 'end',
            anchor: 'end',
            backgroundColor: null,
            borderColor: null,
            borderRadius: 0,
            borderWidth: 0,
            color: '#777',
            font: {
              size: 12
            },
            offset: 5,
            padding: 0,
            formatter: function(value, context) {
              return (context.chart.data.labels[context.dataIndex] + '\n' + value + '%') || null;
            }
          }
        },
        fullHeight: true,
        responsive: true,
        maintainAspectRatio: true
    };

    function subscribeToPolicyStatus() {
        policiesService
          .getCurrentPolicyStatus()
          .subscribe(function(policyStatus) {
            pinvshare.showSpinner = true;
            var borrower = borrowersService.getActualBorrower();
            if (policyStatus && borrower.value !== undefined) {
              policiesService
                .getTotalInvestorsSharesByBorrower(borrower.value.BorrowerID, policyStatus.value)
                .then(
                  function(data) {
                    setGraphInfo(data);
                  },
                  function(error) {
                    console.log(error);
                  }
                );
            }
          });
      }
  
      function subscribeToActualBorrower() {
        borrowersService.getActualBorrower().subscribe(function(borrower) {
        pinvshare.showSpinner = true;
          var policyStatus = policiesService.getCurrentPolicyStatus();
          if (borrower && policyStatus.value !== undefined) {
            policiesService
              .getTotalInvestorsSharesByBorrower(borrower.BorrowerID, policyStatus.value.value)
              .then(
                function(data) {
                    setGraphInfo(data);
                },
                function(error) {
                  console.log(error);
                }
              );
          }
        });
      }
  
      pinvshare.$onInit = function() {
        setGraphInfo(null);
        subscribeToActualBorrower();
        subscribeToPolicyStatus();
      };

      function setGraphInfo(data) {
            if(!data) {
                data = {
                    NiranTotalPercent: 0,
                    CFHTotalPercent: 0,
                    ABDTotalPercent: 0,
                    PHTTotalPercent: 0,
                    PHTAndABDTotalPercent: 0
                };
            }

            pinvshare.graphData = [
                { 
                    labels: ["NIRAN", "CFH", "PHT"],
                    data: [data.NiranTotalPercent, data.CFHTotalPercent, data.PHTAndABDTotalPercent],
                    colors: ["#3299CC", "#55CEA5", "#305496"]
                }
        ]

        pinvshare.showSpinner = false;
      };
  });

'use strict';

angular.module('inspinia')
  .component('policyInvestorShare', {
    templateUrl: 'app/components/policy-investor-share/policy-investor-share.html',
    controller: 'policyInvestorShareController',
    controllerAs: 'pinvshare'
  });

"use strict";

angular
  .module("inspinia")
  .controller("policyStatusSelectorController", function (
    $scope,
    policiesService,
    toolboxService
  ) {
    var psc = this;

    psc.statuses = [
      { id: 0, description: "Active", value: true },
      { id: 1, description: "Inactive", value: false }
    ];

    psc.setStatus = function (status) {
      policiesService.setPolicyStatus(status);
      toolboxService.hide();
    };

    psc.$onInit = function () {
      psc.setStatus(psc.statuses[0]);

      policiesService
        .getCurrentPolicyStatus()
        .subscribe(function (policyStatus) {
          psc.currentStatus = policyStatus.description;
        });
    };
  });

"use strict";

angular.module("inspinia").component("policyStatusSelector", {
  templateUrl:
    "app/components/policy-status-selector/policy-status-selector.html",
  controller: "policyStatusSelectorController",
  controllerAs: "psc"
});

'use strict';

angular.module('inspinia')
  .controller('menuController', function(companyService, usersService, authenticationService) {
    var mc = this;
    mc.userHasMultipleClients = false;

    mc.$onInit = function() {
      getUserData();
      companyService.getActualCompany().subscribe(function(company) {
        getUserData();
      });

    };

    function getUserData() {
      authenticationService.getUserData().then(function(data) {
        mc.isAdmin = data.IsAdmin;
        mc.isEmployee = data.IsEmployee;

        usersService.hasMultipleClients().then(function(b) {
          mc.userHasMultipleClients = b && !mc.isAdmin;
        });
        
        authenticationService.isInRole('CarrierRatingEditor').then(function(isEditor) {
          mc.isEditor = isEditor;
        });
        
      });
    }
  });

'use strict';

angular.module('inspinia')
  .component('menuNscp', {
    templateUrl: 'app/components/menu/menu.html',
    controller: 'menuController',
    controllerAs: 'mc'
  });

'use strict';

angular.module('inspinia')
  .controller('loginHistoryController', function(logService) {

    var lh = this;

    lh.showSpinner = true;

    lh.$onInit = function() {
      lh.showSpinner = true;

      logService.getHistory(lh.companyId, lh.userName ? lh.userName : '').then(function(data) {
        var formattedData = [];
        for (var i = 0; i < data.length; i++) {
          formattedData.push(data[i]);
          formattedData[i].LogDateLocalTime = new Date(data[i].LogDateLocalTime);
        }
        startUpGrid(formattedData);
      });
    };

    function startUpGrid(data) {
      var cv = new wijmo.collections.CollectionView(data);

      lh.data = cv;
      lh.showSpinner = false;
    }

    lh.initGrid = function(sender, args) {
      var flex = sender;

      lh.flexGridFilter = new wijmo.grid.filter.FlexGridFilter(flex);
    };


  });

'use strict';

angular.module('inspinia')
  .component('loginHistory', {
    templateUrl: 'app/components/login-history/login-history.html',
    controller: 'loginHistoryController',
    controllerAs: 'lh',
    bindings: {
      companyId: '<',
      userName: '<?'
    }
  });

"use strict";

angular
  .module("inspinia")
  .controller("policyReportController", function(
    $scope,
    borrowersService,
    reportsService,
    reportUtilService,
    policiesService,
    $filter
  ) {
    var pr = this;

    pr.showSpinner = true;

    function subscribeToActualBorrower() {
      borrowersService.getActualBorrower().subscribe(function(borrower) {
        var policyStatus = policiesService.getCurrentPolicyStatus().value;
        if (borrower && policyStatus !== undefined) {
          reportsService
            .getPolicyCV(borrower, policyStatus.value)
            .then(function(data) {
              startUpGrid(data);
            });
        }
      });
    }

    function subscribeToPolicyStatus() {
      policiesService
        .getCurrentPolicyStatus()
        .subscribe(function(policyStatus) {
          var borrower = borrowersService.getActualBorrower().value;
          if (policyStatus && borrower !== undefined) {
            reportsService
              .getPolicyCV(borrower, policyStatus.value)
              .then(function(data) {
                startUpGrid(data);
              });
          }
        });
    }

    pr.$onInit = function() {
      pr.showSpinner = true;

      subscribeToActualBorrower();
      subscribeToPolicyStatus();
    };

    function startUpGrid(data) {
      var formattedData = [];
      var amountArrayFields = [
        "DeathBenefit",
        "CurrentDeathBenefit",
        "CURRENT_CASH_VALUE",
        "CURRENT_SURRENDER_VALUE"
      ];
      for (var i = 0; i < data.length; i++) {
        formattedData.push(data[i]);
        formattedData[i].SOURCE_OF_INFORMATION_D = $filter("date")(
          data[i].SOURCE_OF_INFORMATION_D,
          "MM/dd/yyyy"
        );
        formattedData[i].LAST_COI_DATE = $filter("date")(
          data[i].LAST_COI_DATE,
          "MM/dd/yyyy"
        );
        formattedData[i].AniversaryDate = $filter("date")(
          formattedData[i].AniversaryDate,
          "MM/dd/yyyy"
        );
        formattedData[i].RevisedPolicyDate = $filter("date")(
          formattedData[i].RevisedPolicyDate,
          "MM/dd/yyyy"
        );
        formattedData[i].PremiumDueDate = $filter("date")(
          formattedData[i].PremiumDueDate,
          "MM/dd/yyyy"
        );
        formattedData[i].GraceBeginDate = $filter("date")(
          formattedData[i].GraceBeginDate,
          "MM/dd/yyyy"
        );
        formattedData[i].GraceEndDate = $filter("date")(
          formattedData[i].GraceEndDate,
          "MM/dd/yyyy"
        );
        formattedData[i].LapseDate = $filter("date")(
          formattedData[i].LapseDate,
          "MM/dd/yyyy"
        );
        formattedData[i].AmountPaidDate = $filter("date")(
          formattedData[i].AmountPaidDate,
          "MM/dd/yyyy"
        );

        for (var property in formattedData[i]) {
          if (formattedData[i].hasOwnProperty(property)) {
            if (amountArrayFields.indexOf(property) === -1)
              formattedData[i][property] = $filter("hyphen")(data[i][property]);
          }
        }
      }

      var columnsDate = "SOURCE_OF_INFORMATION_D,LAST_COI_DATE ";
      var cv = new wijmo.collections.CollectionView(formattedData, {
        sortConverter: reportUtilService.sortConverter(columnsDate),
        sortComparer: reportUtilService.sortComparerAlphanumeric
      });
      // var pageWrapperHeight = document.getElementById('page-wrapper').clientHeight;
      // cv.pageSize = (pageWrapperHeight / 57) - ((pageWrapperHeight / 57) % 1);
      pr.data = cv;
      pr.showSpinner = false;

      $scope.$watch("pr.filter", function(n, o) {
        reportUtilService.filterByInput({
          flexGridFilter: pr.flexGridFilter,
          flex: pr.flex,
          search: n
        });
      });
    }

    pr.initGrid = function(sender, args) {
      var flex = sender;

      pr.flexGridFilter = new wijmo.grid.filter.FlexGridFilter(flex);

      pr.flexGridFilter.filterChanged.addHandler(function(s) {
        pr.data.filter = null;
      });
    };

    pr.download = function() {
      // Save the flexGrid to xlsx file.
      // issue not export all rows
      // Disable pagination / export / enable again
      var paging = {
        pageSize: pr.flex.itemsSource.pageSize,
        pageIndex: pr.flex.itemsSource.pageIndex,
        currentItem: pr.flex.itemsSource.currentItem
      };

      pr.flex.itemsSource.pageSize = pr.flex.itemsSource.totalItemCount;

      wijmo.grid.xlsx.FlexGridXlsxConverter.save(
        pr.flex,
        {
          includeColumnHeaders: true
        },
        "policy-cv-csv-report.xlsx"
      );

      pr.flex.itemsSource.pageSize = paging.pageSize;
      pr.flex.itemsSource.moveToPage(paging.pageIndex);
      pr.flex.itemsSource.currentItem = paging.currentItem;
    };
  });

'use strict';

angular.module('inspinia')
  .component('policyReport', {
    templateUrl: 'app/components/policy-report/policy-report.html',
    controller: 'policyReportController',
    controllerAs: 'pr'
  });

"use strict";

angular
  .module("inspinia")
  .controller("insuredTrackingReportController", function(
    $scope,
    borrowersService,
    reportsService,
    reportUtilService,
    policiesService,
    $filter
  ) {
    var ler = this;

    ler.showSpinner = true;

    function subscribeToActualBorrower() {
      borrowersService.getActualBorrower().subscribe(function(borrower) {
        var policyStatus = policiesService.getCurrentPolicyStatus().value;
        if (borrower && policyStatus !== undefined) {
          reportsService
            .getInsuredTracking(borrower, policyStatus.value)
            .then(
              function(data) {
                startUpGrid(data);
              },
              function(error) {
                console.log(error);
              }
            );
        }
      });
    }

    function subscribeToPolicyStatus() {
      policiesService
        .getCurrentPolicyStatus()
        .subscribe(function(policyStatus) {
          var borrower = borrowersService.getActualBorrower().value;
          if (policyStatus && borrower !== undefined) {
            reportsService
              .getInsuredTracking(borrower, policyStatus.value)
              .then(
                function(data) {
                  startUpGrid(data);
                },
                function(error) {
                  console.log(error);
                }
              );
          }
        });
    }

    ler.$onInit = function() {
      ler.showSpinner = true;
      ler.providersColumns = [];
      subscribeToActualBorrower();
      subscribeToPolicyStatus();
    };

    function startUpGrid(data) {
      var formattedData = [];
      for (var i = 0; i < data.length; i++) {
        formattedData.push(data[i]);

        // Format DateOfConfirm as Date
        if(formattedData[i].DateOfConfirm != null)
          formattedData[i].DateOfConfirm = new Date(formattedData[i].DateOfConfirm);

        formattedData[i].MostRecentAttemptDate = $filter("date")(
          data[i].MostRecentAttemptDate,
          "MM/dd/yyyy"
        );
      }

      var cv = new wijmo.collections.CollectionView(formattedData, {
        sortComparer: reportUtilService.sortComparerAlphanumeric
      });

      ler.data = cv;
      ler.showSpinner = false;

      $scope.$watch("ler.filter", function(n, o) {
        reportUtilService.filterByInput({
          flexGridFilter: ler.flexGridFilter,
          flex: ler.flex,
          search: n
        });
      });
    }

    ler.initGrid = function(sender, args) {
      var flex = sender;

      ler.flexGridFilter = new wijmo.grid.filter.FlexGridFilter(flex);

      ler.flexGridFilter.filterChanged.addHandler(function(s) {
        ler.flex.select(-1, -1);
        ler.data.filter = null;
      });

      ler.flexGridFilter.filterApplied.addHandler(function(s) {
        ler.flex.select(0, 0);
      });
    };

    ler.download = function() {
      // Save the flexGrid to xlsx file.
      // issue not export all rows
      // Disable pagination / export / enable again
      var paging = {
        pageSize: ler.flex.itemsSource.pageSize,
        pageIndex: ler.flex.itemsSource.pageIndex,
        currentItem: ler.flex.itemsSource.currentItem
      };

      ler.flex.itemsSource.pageSize = ler.flex.itemsSource.totalItemCount;

      wijmo.grid.xlsx.FlexGridXlsxConverter.save(
        ler.flex,
        {
          includeColumnHeaders: true
        },
        "insured-tracking-report.xlsx"
      );

      ler.flex.itemsSource.pageSize = paging.pageSize;
      ler.flex.itemsSource.moveToPage(paging.pageIndex);
      ler.flex.itemsSource.currentItem = paging.currentItem;
    };
  });

'use strict';

angular.module('inspinia')
  .component('insuredTrackingReport', {
    templateUrl: 'app/components/insured-tracking-report/insured-tracking-report.html',
    controller: 'insuredTrackingReportController',
    controllerAs: 'ler'
  });

"use strict";

angular
  .module("inspinia")
  .controller("policiesListController", function(policiesService) {
    var plc = this;

    plc.showSpinner = true;

    plc.$onInit = function() {
      plc.showSpinner = true;
      var policyStatus = policiesService.getCurrentPolicyStatus().value;

      policiesService
        .GetPoliciesByCompany(plc.companyId, policyStatus.value)
        .then(function(data) {
          startUpGrid(data);
        });
    };

    function startUpGrid(data) {
      var cv = new wijmo.collections.CollectionView(data);

      plc.data = cv;
      plc.showSpinner = false;
    }

    plc.initGrid = function(sender, args) {
      var flex = sender;

      plc.flexGridFilter = new wijmo.grid.filter.FlexGridFilter(flex);
    };
  });

'use strict';

angular.module('inspinia')
  .component('policiesList', {
    templateUrl: 'app/components/policies-list/policies-list.html',
    controller: 'policiesListController',
    controllerAs: 'plc',
    bindings: {
      companyId: '<'
    }
  });

"use strict";

angular
  .module("inspinia")
  .controller("leReportController", function(
    $scope,
    borrowersService,
    reportsService,
    reportUtilService,
    policiesService,
    $filter
  ) {
    var ler = this;

    ler.showSpinner = true;

    function subscribeToActualBorrower() {
      borrowersService.getActualBorrower().subscribe(function(borrower) {
        var policyStatus = policiesService.getCurrentPolicyStatus().value;
        if (borrower && policyStatus !== undefined) {
          reportsService
            .getLEbyPolicyBorrower(borrower, policyStatus.value)
            .then(
              function(data) {
                startUpGrid(data);
              },
              function(error) {
                console.log(error);
              }
            );
        }
      });
    }

    function subscribeToPolicyStatus() {
      policiesService
        .getCurrentPolicyStatus()
        .subscribe(function(policyStatus) {
          var borrower = borrowersService.getActualBorrower().value;
          if (policyStatus && borrower !== undefined) {
            reportsService
              .getLEbyPolicyBorrower(borrower, policyStatus.value)
              .then(
                function(data) {
                  startUpGrid(data);
                },
                function(error) {
                  console.log(error);
                }
              );
          }
        });
    }

    ler.$onInit = function() {
      ler.showSpinner = true;
      subscribeToActualBorrower();
      subscribeToPolicyStatus();
    };

    function startUpGrid(data) {
      var formattedData = [];
      ler.providersColumns = [];
      
      for (var i = 0; i < data.Data.length; i++) {
        formattedData.push(data.Data[i]);
        formattedData[i].Policy.DOB = $filter("date")(
          data.Data[i].Policy.DOB,
          "MM/dd/yyyy"
        );
        formattedData[i].Policy.GENDER = $filter("capitalize")(
          data.Data[i].Policy.GENDER
        );
      }
      setProvidersColumns(data.Providers);
      setProvidersLeData(formattedData, data.Providers);

      var columnsDate =
        "Policy.DOB," +
        ler.providersColumns
          .filter(function(c) {
            return c.indexOf("Date") !== -1;
          })
          .join(",");

      var cv = new wijmo.collections.CollectionView(formattedData, {
        sortConverter: reportUtilService.sortConverter(columnsDate),
        sortComparer: reportUtilService.sortComparerAlphanumeric
      });
      // var pageWrapperHeight = document.getElementById('page-wrapper').clientHeight;
      // cv.pageSize = (pageWrapperHeight / 53) - ((pageWrapperHeight / 53) % 1);
      ler.data = cv;
      ler.showSpinner = false;

      $scope.$watch("ler.filter", function(n, o) {
        reportUtilService.filterByInput({
          flexGridFilter: ler.flexGridFilter,
          flex: ler.flex,
          search: n
        });
      });
      
    }

    ler.initGrid = function(sender, args) {
      var flex = sender;

      ler.flexGridFilter = new wijmo.grid.filter.FlexGridFilter(flex);

      ler.flexGridFilter.filterChanged.addHandler(function(s) {
        ler.flex.select(-1, -1);
        ler.data.filter = null;
      });

      ler.flexGridFilter.filterApplied.addHandler(function(s) {
        ler.flex.select(0, 0);
      });
    };

    function setProvidersColumns(providers) {
      angular.forEach(providers, function(provider, key) {
        ler.providersColumns.push(provider + " Date");
        ler.providersColumns.push(provider + " 50% LE");
        ler.providersColumns.push(provider + " Multiplier");
      });
    }

    function setProvidersLeData(data, providers) {
      angular.forEach(data, function(row, key) {
        var providersTmp = providers.slice(0);
        angular.forEach(row.LEvalues, function(leValue, key) {
          var i = providersTmp.indexOf(leValue.Company);
          if (i != -1) {
            providersTmp.splice(i, 1);
          }
          var dateFixed = $filter("fixdate")(leValue.LEDate);
          row[leValue.Company + " Date"] =
            dateFixed === "-"
              ? dateFixed
              : $filter("date")(dateFixed, "MM/dd/yyyy");
          row[leValue.Company + " 50% LE"] = $filter("hyphen")(
            leValue.LIFEEXPECTANCY
          );
          row[leValue.Company + " Multiplier"] = $filter("hyphen")(
            parseFloat(leValue.COMPANYTABLE).toFixed(2)
          );
          row[leValue.Company + " Clinical Judgement"] = $filter("hyphen")(
            leValue.CLINICAL_JUDGMENT
          );
        });
        providersTmp.forEach(function(provider) {
          row[provider + " Date"] = "-";
          row[provider + " 50% LE"] = "-";
          row[provider + " Multiplier"] = "-";
          row[provider + " Clinical Judgement"] = "-";
        });
      });
    }

    ler.download = function() {
      // Save the flexGrid to xlsx file.
      // issue not export all rows
      // Disable pagination / export / enable again
      var paging = {
        pageSize: ler.flex.itemsSource.pageSize,
        pageIndex: ler.flex.itemsSource.pageIndex,
        currentItem: ler.flex.itemsSource.currentItem
      };

      ler.flex.itemsSource.pageSize = ler.flex.itemsSource.totalItemCount;

      wijmo.grid.xlsx.FlexGridXlsxConverter.save(
        ler.flex,
        {
          includeColumnHeaders: true
        },
        "le-report-by-policy.xlsx"
      );

      ler.flex.itemsSource.pageSize = paging.pageSize;
      ler.flex.itemsSource.moveToPage(paging.pageIndex);
      ler.flex.itemsSource.currentItem = paging.currentItem;
    };
    
  });

'use strict';

angular.module('inspinia')
  .component('leReport', {
    templateUrl: 'app/components/le-report/le-report.html',
    controller: 'leReportController',
    controllerAs: 'ler'
  });

"use strict";

angular
  .module("inspinia")
  .controller("leHistoryReportController", function(
    $scope,
    borrowersService,
    reportsService,
    reportUtilService,
    policiesService,
    $filter
  ) {
    var lehr = this;

    lehr.showSpinner = true;

    function subscribeToActualBorrower() {
      borrowersService.getActualBorrower().subscribe(function(borrower) {
        var policyStatus = policiesService.getCurrentPolicyStatus().value;
        if (borrower && policyStatus !== undefined) {
          reportsService
            .getLEHistoryReport(borrower, policyStatus.value)
            .then(function(data) {
              startUpGrid(data);
            });
        }
      });
    }

    function subscribeToCurrentPolicyStatus() {
      policiesService
        .getCurrentPolicyStatus()
        .subscribe(function(policyStatus) {
          var borrower = borrowersService.getActualBorrower().value;
          if (policyStatus && borrower !== undefined) {
            reportsService
              .getLEHistoryReport(borrower, policyStatus.value)
              .then(function(data) {
                startUpGrid(data);
              });
          }
        });
    }

    lehr.$onInit = function() {
      lehr.showSpinner = true;
      subscribeToActualBorrower();
      subscribeToCurrentPolicyStatus();
    };

    function startUpGrid(data) {
      var formattedData = [];

      for (var i = 0; i < data.length; i++) {
        formattedData.push(data[i]);
        formattedData[i].LEDate = $filter("date")(data[i].LEDate, "MM/dd/yyyy");
        formattedData[i].MEDIANLE = $filter("hyphen")(data[i].MEDIANLE);
        formattedData[i].LE85PERCENT = $filter("hyphen")(data[i].LE85PERCENT);
        formattedData[i].RECORDSFROM = $filter("hyphen")(data[i].RECORDSFROM);
        formattedData[i].RECORDSTO = $filter("hyphen")(data[i].RECORDSTO);
        formattedData[i].PRIMARYIMPAIRMENT = $filter("hyphen")(
          data[i].PRIMARYIMPAIRMENT
        );
      }

      var cv = new wijmo.collections.CollectionView(formattedData, {
        sortComparer: reportUtilService.sortComparerAlphanumeric
      });
      // var pageWrapperHeight = document.getElementById('page-wrapper').clientHeight;
      // cv.pageSize = (pageWrapperHeight / 57) - ((pageWrapperHeight / 57) % 1);
      lehr.data = cv;
      lehr.showSpinner = false;

      $scope.$watch("lehr.filter", function(n, o) {
        reportUtilService.filterByInput({
          flexGridFilter: lehr.flexGridFilter,
          flex: lehr.flex,
          search: n
        });
      });
    }

    lehr.initGrid = function(sender, args) {
      var flex = sender;

      lehr.flexGridFilter = new wijmo.grid.filter.FlexGridFilter(flex);

      lehr.flexGridFilter.filterChanged.addHandler(function(s) {
        lehr.data.filter = null;
      });
    };

    lehr.download = function() {
      // Save the flexGrid to xlsx file.
      // issue not export all rows
      // Disable pagination / export / enable again
      var paging = {
        pageSize: lehr.flex.itemsSource.pageSize,
        pageIndex: lehr.flex.itemsSource.pageIndex,
        currentItem: lehr.flex.itemsSource.currentItem
      };

      lehr.flex.itemsSource.pageSize = lehr.flex.itemsSource.totalItemCount;

      wijmo.grid.xlsx.FlexGridXlsxConverter.save(
        lehr.flex,
        {
          includeColumnHeaders: true
        },
        "le-history-report.xlsx"
      );

      lehr.flex.itemsSource.pageSize = paging.pageSize;
      lehr.flex.itemsSource.moveToPage(paging.pageIndex);
      lehr.flex.itemsSource.currentItem = paging.currentItem;
    };
  });

'use strict';

angular.module('inspinia')
  .component('leHistoryReport', {
    templateUrl: 'app/components/le-history-report/le-history-report.html',
    controller: 'leHistoryReportController',
    controllerAs: 'lehr'
  });

'use strict';

angular.module('inspinia')
  .controller('companySettingsController', function(companyService) {
    var cs = this;

    cs.$onInit = function() {

      cs.showSpinner = true;
      companyService.getSettings(cs.companyId).then(function(data) {
        cs.data = data;
        cs.showSpinner = false;
      });

    };
  });

'use strict';

angular.module('inspinia')
  .component('companySettings', {
    templateUrl: 'app/components/company-settings/company-settings.html',
    controller: 'companySettingsController',
    controllerAs: 'cs',
    bindings: {
      companyId: '<'
    }
  });

'use strict';

angular.module('inspinia')
  .controller('headerController', function(companyService,
    authenticationService,
    usersService,
    configService) {

    var hd = this;
    hd.userHasMultipleClients = false;

    hd.$onInit = function() {
      getUserData();
      getCompanyName();

      companyService.getActualCompany().subscribe(function(company) {
        getUserData();
        getCompanyName();
      });

    };

    hd.signOut = function() {

      authenticationService.signOut().then(function(data) {
        if (data) {
          window.location.assign(configService.goToLogin);
        }

      });
    };

    function getCompanyName() {
      companyService.get().then(function(data) {
        hd.companyName = data.CompanyFullName;
      });
    }

    function getUserData() {
      authenticationService.getUserData().then(function(data) {
        hd.isAdmin = data.IsAdmin;
        hd.isEmployee = data.IsEmployee;

        usersService.hasMultipleClients().then(function(b) {
          hd.userHasMultipleClients = b && !hd.isAdmin;
        });
      });
    }
  });

'use strict';

angular.module('inspinia')
  .component('headerNscp', {
    templateUrl: 'app/components/header/header.html',
    controller: 'headerController',
    controllerAs: 'hd'
  });

'use strict';

angular.module('inspinia')
  .controller('insuredInformationController', function(policiesService) {
    var ii = this;

    ii.$onInit = function() {

      policiesService.getActualPolicy().subscribe(function(data) {
        ii.data = data;
        ii.showSpinner = false;

        ii.Address = getAddress(data);
        ii.Address2 = getAddress2(data);

        ii.twoAddress = ii.Address + '<br />' + ii.Address2;

        ii.Phone = getPhone(data);
      });


      policiesService.onBeforeGetData().subscribe(function(options) {
        ii.showSpinner = true && (options != "All");
      });
    };

    ii.showAddressPopover = function() {
      angular.element('#address').popover('show');
    }

    ii.hideAddressPopover = function() {
      angular.element('#address').popover('hide');
    }

    var getAddress = function(data) {
      var ret = null;

      if (data) {
        if (data.Address1) {

          ret = data.Address1;
        }

        if (data.Address2) {

          if (ret) {
            ret = ret + ', ';
          }

          ret = ret + data.Address2;
        }
      }
      return ret;
    };

    var getAddress2 = function(data) {

      if (data) {
        return data.City +
          ', ' +
          data.State +
          ' ' +
          data.PostalCode;
      } else {
        return null;
      }
    };

    var getPhone = function(data) {
      var ret = '-';
      if (data) {
        if (data.HomePhone)
          return data.HomePhone;

        if (data.WorkPhone)
          return data.HomePhone;

        if (data.Mobile)
          return data.Mobile;
      }
      return ret;
    };
  });

'use strict';

angular.module('inspinia')
  .component('insuredInformation', {
    templateUrl: 'app/components/insured-information/insured-information.html',
    controller: 'insuredInformationController',
    controllerAs: 'ii'
  });

'use strict';

angular.module('inspinia')
  .controller('downloadDocumentsController', function($scope, $timeout, borrowersService, documentsService, policiesService) {
    var dd = this;
    dd.date = {
      from: moment(),
      to: moment()
    };
    dd.uploadedDate = 'all';

    dd.showSpinner = true;

    dd.$onInit = function() {

      dd.showSpinner = true;

      borrowersService.getActualBorrower().subscribe(function(borrower) {        
        dd.borrowerId = borrower.BorrowerID;        
        dd.loadDocumentTypes();
      });
    };

    $scope.$watch('dd.clientDocuments', function (newValue, oldValue, scope) {
      dd.loadDocumentTypes();
    });

    dd.loadDocumentTypes = function() {
      dd.showSpinner = true;
      var policyStatus = policiesService.getCurrentPolicyStatus().value;
      if(dd.borrowerId && policyStatus) {        
        documentsService.GetDocumentsTypes(dd.borrowerId, policyStatus.value, dd.clientDocuments)
            .then(function(data) {          
              $timeout(function(){ 
                dd.documentTypes = data;
                dd.showSpinner = false;  
              });    
            }, function(error) {
              console.log(error);
            });
      }
    }
    
    dd.download = function () {
      var policyStatus = policiesService.getCurrentPolicyStatus().value;

      documentsService.GetDocumentsZip({
        BorrowerId: dd.borrowerId,
        FileType: dd.selectedDocumentType,
        From: dd.uploadedDate === 'range' ? new Date(dd.date.from) : null,
        To: dd.uploadedDate === 'range' ? new Date(dd.date.to) : null,
        All: dd.uploadedDate === 'all' ? true : false,
        Active: policyStatus.value,
        ClientDocuments: dd.clientDocuments
      }).then(function(data) {
        var blob = new Blob([data], {
          type: 'application/zip'
        });
        var fileName = "documents.zip";
        saveAs(blob, fileName);
      });
    }

  });

'use strict';

angular.module('inspinia')
  .component('downloadDocuments', {
    templateUrl: 'app/components/download-documents/download-documents.html',
    controller: 'downloadDocumentsController',
    controllerAs: 'dd',
    bindings: {
      clientDocuments: '<'
    }
  });

'use strict';

angular.module('inspinia')
  .controller('companyReportController', function($scope,
    $location,
    cpCacheService,
    companyService,
    usersService,
    authenticationService,
    toolboxService) {

    var cr = this;
    var evtkey = 'companyReportController';

    cr.showSpinner = true;
    cr.isAdmin = false;
    cr.IsEmployee = false;

    cr.$onInit = function() {

      cr.showSpinner = true;

      authenticationService.getUserData().then(function(data) {
        cr.isAdmin = data.IsAdmin;
        cr.isEmployee = data.IsEmployee;

        if (cr.isAdmin || cr.isEmployee) {
          companyService.getAll()
            .then(function(data) {
              startUpGrid(data);
            }, function(error) {
              console.log(error);
            });
        } else {
          companyService.getByUser(false)
            .then(function(data) {
              startUpGrid(data);
            }, function(error) {
              console.log(error);
            });
        }
      });
    };

    cr.signInAsCompany = function(companyId) {

      var companies = [];
      companies.push(companyId);
      authenticationService.signInAsCompany(companies).then(function(data) {
        if (data) {

          cpCacheService.removeAll();
          companyService.setActualCompany();

          $location.path('/portal/portfolio');
        } else {
          console.log('TODO. show Message');
        }
      });
    };

    cr.policyList = function(companyId) {
      toolboxService.setOptions({
        title: 'Policies & Date Ranges',
        content: '<policies-list company-id="' + companyId + '"></policies-list>',
        show: true,
        from: evtkey,
        wrapperClass: 'extWidth'
      });
    };

    cr.logList = function(companyId) {
      toolboxService.setOptions({
        title: 'Login History',
        content: '<login-history company-id="' + companyId + '" user-name=""></login-history>',
        show: true,
        from: evtkey,
        wrapperClass: 'extWidth'
      });
    };

    cr.companySettings = function(companyId) {
      toolboxService.setOptions({
        title: 'Company Settings',
        content: '<company-settings company-id="' + companyId + '"></company-settings>',
        show: true,
        from: evtkey,
        wrapperClass: ''
      });
    };

    cr.download = function() {
      // Save the flexGrid to xlsx file.
      // issue not export all rows
      // Disable pagination / export / enable again
      var paging = {
        pageSize: cr.flex.itemsSource.pageSize,
        pageIndex: cr.flex.itemsSource.pageIndex,
        currentItem: cr.flex.itemsSource.currentItem
      };

      cr.flex.itemsSource.pageSize = cr.flex.itemsSource.totalItemCount;

      wijmo.grid.xlsx.FlexGridXlsxConverter.save(
        cr.flex,
        {
          includeColumnHeaders: true,
          includeColumns: function(column) {
            return column.binding !== null;
          }
        },
        "company-list.xlsx"
      );

      cr.flex.itemsSource.pageSize = paging.pageSize;
      cr.flex.itemsSource.moveToPage(paging.pageIndex);
      cr.flex.itemsSource.currentItem = paging.currentItem;
    };

    function startUpGrid(data) {

      var cv = new wijmo.collections.CollectionView(data);
      cr.data = cv;
      cr.showSpinner = false;
    }

  });

'use strict';

angular.module('inspinia')
  .component('companyReport', {
    templateUrl: 'app/components/company-report/company-report.html',
    controller: 'companyReportController',
    controllerAs: 'cr'
  });

'use strict';

angular.module('inspinia')
  .controller('carrierRatingFilesController', function($scope,
    toolboxService,
    reportsService,
    reportUtilService,
    configService) {
    
    var crf = this;
    var evtkey = 'carrierRatingFilesController';
    
    crf.allCarrierRatings = [];
    crf.showSpinner = true;
    crf.isEditor = false;

    crf.$onInit = function() {

      crf.showSpinner = true;
      
      reportsService.getCarrierRating().then(function(carrierRating) {
        crf.allCarrierRatings = carrierRating;
        
        var cv = new wijmo.collections.CollectionView(carrierRating, {
          groupDescriptions: ['Year']
        });
        
        var sd = new wijmo.collections.SortDescription("Year", false);
        cv.sortDescriptions.push(sd);
        crf.data = cv;
        crf.showSpinner = false;
      });

      $scope.$watch('crf.filter', function(n, o) {

        reportUtilService.filterByInput({
          flexGridFilter: crf.flexGridFilter,
          flex: crf.flex,
          search: n
        });

      });
    };

    crf.initGrid = function(sender, args) {
      var flex = sender;
      crf.flexGridFilter = new wijmo.grid.filter.FlexGridFilter(flex);

      crf.flexGridFilter.filterChanged.addHandler(function(s) {
        crf.data.filter = null;
      });

    };
        
    crf.getUrl = function(item) {
      return configService.baseURL + '/Documents/DownloadCarrierRating?carrierRatingReportId=' + item.CarrierRatingReportId;
    }

    crf.addQuarter = function() {

      toolboxService.setOptions({
        title: 'Add Quarter',
        content: '<carrier-rating-edit new-carrier-rating="true" carrier-rating="" all-carrier-ratings=\'' + JSON.stringify(crf.allCarrierRatings) + '\'></user-edit>',
        show: true,
        from: evtkey,
        wrapperClass: 'smallWidth'
      });
    }

    crf.deleteFile = function (item) {
      
      toolboxService.setOptions({
        title: 'Delete File: ' + '(' + item.Year + ' - 0' + item.Quarter + ') ' + item.FileName ,
        content: '<carrier-rating-delete document=\'' + JSON.stringify(item) + '\'></carrier-rating-delete>',
        show: true,
        from: evtkey,
        wrapperClass: 'smallWidth'
      });
    }
  });

'use strict';

angular.module('inspinia')
  .component('carrierRatingFiles', {
    templateUrl: 'app/components/carrier-rating-files/carrier-rating-files.html',
    controller: 'carrierRatingFilesController',
    controllerAs: 'crf',
    bindings: {
      addFeatureEdit: '<'
    }
  });

'use strict';

angular.module('inspinia')
  .controller('companySelectorController', function(companyService, authenticationService, usersService, cpCacheService, $location) {
    var cs = this;
    cs.showSpinner = true;
    cs.userCompanies = [];
    cs.clients = [];
    cs.selectedClients = [];
    cs.previousSelectedClients = [];
    
    cs.$onInit = function() {
        getUserData();
        authenticationService.getSignInAsCompany().subscribe(function(company) {
          if (company) {
            companyService.getByUser(true)
            .then(function(data) {

                authenticationService.getUserData().then(function(userData) {
                  cs.defaultCompany = userData.CompanyID;
                  cs.userCompanies = data;
                  cs.clients = [];
                  getCompanies();  
                });
            });
          }
        });
  
    };

    function getCompanies() {
        companyService.getByUser(true)
        .then(function(data) {

            cs.userCompanies = data;
            
            if(cs.isAdmin) {
                companyService.getAll()
                .then(function(data) {
                    loadCompanies(data);
    
                }, function(error) {
                    console.log(error);
                });
            } else {
              companyService.getByUser(false)
              .then(function(data) {
                loadCompanies(data);
              });      
            }

        }, function(error) {
            console.log(error);
        });
    }

    function loadCompanies(data) {
        cs.clients = [];
        for(var i = 0; i < data.length; i++)  {
          if(data[i].CompanyID !== -1) {
            cs.clients.push({ 
                        name: data[i].CompanyShortName,
                        marker: data[i].CompanyFullName, 
                        companyId: data[i].CompanyID, 
                        ticked: cs.userCompanies.findIndex(function (x) {
                            return x.CompanyID === data[i].CompanyID
                        }) > -1
                    });
          }
        }

        var noCompaniesSelected = cs.clients.filter(function(c) {
          return c.ticked === true;
        }).length === 0;

        // if the user doesn't have any company selected, 
        // we set the default company by default
        if (noCompaniesSelected) {
          cs.clients.forEach(function(c) {
            if(c.companyId === cs.defaultCompany) {
              c.ticked = true;
            }
          });
        }

        if(cs.clients.length > 0) {
            cs.company = cs.clients[0];
        }

        usersService.hasMultipleClients().then(function(b) {            
            cs.showSingleCompany = !b && !cs.isAdmin;
            cs.showSeveralCompanies = b || cs.isAdmin;
            
            cs.showSpinner = false;
          });
    }

    function getUserData() {      
        authenticationService.getUserData().then(function(data) {
          cs.isAdmin = data.IsAdmin;
          cs.isEmployee = data.IsEmployee;          
          cs.allowJoinCompanies = data.AllowJoinCompanies;
          cs.defaultCompany = data.CompanyID;

          getCompanies();
        });
      }

      cs.onClientSelection = function() {        
        
        if(!isEqual(cs.previousSelectedClients, cs.selectedClients)) {
          var companies = [];
          companies = cs.selectedClients.map(function (x) {
              return x.companyId;
          });

          cs.signInAsCompany(companies);
        }
      };

      cs.onReset = function() {
        cs.signInAsCompany([]);
      };

      cs.onOpen = function() {
        cs.previousSelectedClients = cs.selectedClients;
      };

      cs.signInAsCompany = function(companies) {
        authenticationService.signInAsCompany(companies).then(function(data) {            
            if (data) {
    
              cpCacheService.removeAll();
              companyService.setActualCompany();
              cs.showSpinner = true;
    
              $location.path('/portal/portfolio');
              
            } else {
              console.log('TODO. show Message');
            }
          });
      };
      
      function isEqual (value, other) {

        // Get the value type
        var type = Object.prototype.toString.call(value);
      
        // If the two objects are not the same type, return false
        if (type !== Object.prototype.toString.call(other)) return false;
      
        // If items are not an object or array, return false
        if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;
      
        // Compare the length of the length of the two items
        var valueLen = type === '[object Array]' ? value.length : Object.keys(value).length;
        var otherLen = type === '[object Array]' ? other.length : Object.keys(other).length;
        if (valueLen !== otherLen) return false;
      
        // Compare two items
        var compare = function (item1, item2) {
      
          // Get the object type
          var itemType = Object.prototype.toString.call(item1);
      
          // If an object or array, compare recursively
          if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
            if (!isEqual(item1, item2)) return false;
          }
      
          // Otherwise, do a simple comparison
          else {
      
            // If the two items are not the same type, return false
            if (itemType !== Object.prototype.toString.call(item2)) return false;
      
            // Else if it's a function, convert to a string and compare
            // Otherwise, just compare
            if (itemType === '[object Function]') {
              if (item1.toString() !== item2.toString()) return false;
            } else {
              if (item1 !== item2) return false;
            }
      
          }
        };
      
        // Compare properties
        if (type === '[object Array]') {
          for (var i = 0; i < valueLen; i++) {
            if (compare(value[i], other[i]) === false) return false;
          }
        } else {
          for (var key in value) {
            if (value.hasOwnProperty(key)) {
              if (compare(value[key], other[key]) === false) return false;
            }
          }
        }
      
        // If nothing failed, return true
        return true;
      };
  });
'use strict';

angular.module('inspinia')
  .component('companySelector', {
    templateUrl: 'app/components/company-selector/company-selector.html',
    controller: 'companySelectorController',
    controllerAs: 'cs'
  });
"use strict";

angular
  .module("inspinia")
  .controller("boxFolderController", function($scope,documentsService,$timeout,feedbackMessage) {
    var bf = this;
    
    bf.itemSelected = null;
    
    bf.getSize = function() {
      if (bf.itemSelected != null)
        return ' (' + filesize(bf.itemSelected.size, {base: 2, standard: "jedec"}) + ')';
      else
        return '';
    }
    
    bf.getName = function() {
      if (bf.itemSelected != null)
        return bf.itemSelected.name;
      else
        return 'No Folder Selected';
    }

    function filterItemByNames(response) {
      // Remove Modified By Name, for not shown on List of files
      if (response.data.item_collection && response.data.item_collection.entries) {
        response.data.item_collection.entries.forEach(function(item) {
          // Hack: In Box App it is showing the created_at, but the UI not. The UI have used modified_at
          if (item.type === 'file') {
            item.modified_at = item.created_at;
          }
                    
          if(item.modified_by) {
            item.modified_by.name = null;
          }
        });
      }
      return response;
    }

    function subscribeToActualBorrower() {
      var contentExplorer = new Box.ContentExplorer();
      
      $timeout(function(){ 
        contentExplorer.show(bf.config.FolderId,bf.config.Token,{
          container: "#box-content-explorer-" + bf.config.FolderId,
          canDownload: true,
          sortBy: 'date',
          sortDirection: 'DESC',
          responseInterceptor: filterItemByNames
        });
        
        contentExplorer.addListener('navigate', function(item) {
          // Check to allow download bf.config.FolderId === "0" is a User App
          var download = (item.parent != null) || ((bf.config.FolderId === "0") && (item.type === "folder") && (item.id !== "0"))
          if (download) {
            bf.itemSelected = item;
          } else {
            bf.itemSelected = null;
          }
          $scope.$apply();
        });
      });
    }
    
    bf.$onInit = function() {
      subscribeToActualBorrower();
    };
    
    bf.downloadAll = function() {
      documentsService.GetExternalZipFolder(bf.borrowerID, bf.config.CompanyId, bf.itemSelected.id).then(function(data) {
        if (!data) {
          feedbackMessage.showMessage("Couldn't download the folder.", 'error');
        } else {
          var blob = new Blob([data], {
            type: 'application/zip'
          });
          var fileName = "AllDocuments.zip";
          saveAs(blob, fileName);
        }
      });
    }
  });
  
'use strict';

angular.module('inspinia')
  .component('boxFolder', {
    templateUrl: 'app/components/box-folder/box-folder.html',
    controller: 'boxFolderController',
    controllerAs: 'bf',
    bindings: {
      config: '<',
      borrowerID: '<'
    }
  });

'use strict';

angular.module('inspinia')
  .controller('carrierRatingReportController', function($scope,
    reportsService,
    reportUtilService,
    $filter) {
    var crr = this;

  });

'use strict';

angular.module('inspinia')
  .component('carrierRatingReport', {
    templateUrl: 'app/components/carrier-rating-report/carrier-rating-report.html',
    controller: 'carrierRatingReportController',
    controllerAs: 'crr'
  });

'use strict';

angular.module('inspinia')
  .controller('borrowersSelectorController', function($scope,
    borrowersService,
    companyService,
    toolboxService) {

    var brs = this;
    var getBorrowers = function() {
      borrowersService.getAll().then(function(data) {
        brs.borrowers = [];
        brs.borrowers.push({
          BorrowerID: 'All',
          BorrowerName: 'All',
          TotalPolicies: 0
        });
  
        brs.borrowers = brs.borrowers.concat(data.filter(
          function(b) {
            return b.BorrowerID.length > 0;
          }));
        
        if (data.ActiveBorrowers) {
          data.forEach(function(borrower) {
            brs.borrowers[0].TotalPolicies += borrower.TotalPolicies;
          });
        }

        // If we need to restrict the borrowers for a user, we need to remove the all option
        if(data[0].RestrictBorrowersForUser) {
            brs.borrowers.splice(0, 1);
            // add Partial to show all borrowers restricted
            brs.borrowers.unshift({
                BorrowerID: 'all-restricted',
                BorrowerName: 'All',
                TotalPolicies: 0
            });
        }

        brs.setBorrower(brs.borrowers[0]);
        //borrowersService.setActualBorrower(brs.borrowers[0]);

      });
    };

    brs.borrowers = [];
    //brs.currentName = 'All';


    brs.$onInit = function() {
      companyService.getActualCompany().subscribe(function(company) {
        brs.initBorrower(company);
      });

      companyService.get().then(function(company) {
        brs.initBorrower(company);
      });
    };

    brs.initBorrower = function(company) {
      getBorrowers();
    }

    brs.setBorrower = function(borrower) {

      brs.currentName = borrower.BorrowerName;
      borrowersService.setActualBorrower(borrower);
      toolboxService.hide();
    }

  });


'use strict';

angular.module('inspinia')
  .component('borrowersSelector', {
    templateUrl: 'app/components/borrowers-selector/borrowers-selector.html',
    controller: 'borrowersSelectorController',
    controllerAs: 'brs'
  });

'use strict';

angular.module('inspinia')
  .controller('carrierRatingEditController', function(feedbackMessage, toolboxService, Upload, configService) {

    var cre = this;

    cre.showSpinner = true;

    cre.years = [];
    cre.quarterFile = null;
    cre.yearQuarter = null;
    cre.selectedDescription = null;
    
    cre.$onInit = function() {

      cre.showSpinner = true;
      
      cre.fillDropDown();
      
      cre.showSpinner = false;
    };


    cre.update = function() {
      
      if ((cre.yearQuarter == null) || (cre.quarterFile == null)) {
        return null;
      }
      
      cre.showSpinner = false;
      cre.uploadFiles();
    }

    cre.cancel = function() {
      toolboxService.hide();
    }
    
    cre.uploadFiles = function() {
      
      var data = {year: cre.yearQuarter.year, quarter: cre.yearQuarter.quarter};
      if (cre.selectedDescription) {
        data.description = cre.selectedDescription;
      }
      
      cre.showSpinner = true;
      cre.quarterFile.upload = Upload.upload({
            url: configService.baseURL + '/Documents/Upload',
            disableProgress: true,
            method: 'POST',
            data: data,
            file: cre.quarterFile, 
            headers: {
              "Content-Type": "multipart/form-data;"
          }
        }).success(function (data) {
          feedbackMessage.showMessage("Uploaded file", 'success');
          toolboxService.hide();
          location.reload(); // Reload screen to update changes
          cre.showSpinner = false;
        }).error(function(data){
          feedbackMessage.showMessage("This type of file is not supported. Couldn't upload the file.", 'error');
          cre.showSpinner = false;
        });
    }

    cre.fillDropDown = function () {
      var currentYear = new Date().getFullYear();
      
      // Get Year from and before to the current year
      for(var i=1; i<11; i++) { 
        // Get Quarters
        for(var j=1; j<5; j++) {
          
          // Before Years
          var year = currentYear - i;
          
          // Check if tuple, Year - Quarter, previous was added
          // For Previous Year
          var wasAdded = cre.allCarrierRatings.some(function(cr) {return (cr.Year ===  year) && (cr.Quarter === j)});
          
          // First it is current year, we need to add only one
          if(i == 1) {
            cre.years.push({year:currentYear, quarter: j,
            disabled:cre.allCarrierRatings.some(function(cr) {return (cr.Year ===  currentYear) && (cr.Quarter === j)}),
            description: 'Year (' + currentYear  + ') Quarter (' + j + ')'});
          }
          // Add Previous Years, order by Year Descending and Quarter Ascending
          cre.years.push({year:year, quarter: j, disabled: wasAdded, description: 'Year (' + year  + ') Quarter (' + (j) + ')'})
        }
      }
    
    }
  });
  
'use strict';

angular.module('inspinia')
  .component('carrierRatingEdit', {
    templateUrl: 'app/components/carrier-rating-edit/carrier-rating-edit.html',
    controller: 'carrierRatingEditController',
    controllerAs: 'cre',
    bindings: {
      carrierRating: '<',
      allCarrierRatings: '<',
      newCarrierRating: '<'
    }
  });

'use strict';

angular.module('inspinia')
  .controller('accountValuesController', function($rootScope, policiesService, premiumService, borrowersService, reportUtilService, configService, $window) {
    var av = this;
    var columnsDate = 'LAST_COI_DATE,InquiryDate';

    av.showSpinner = true;

    // allow to download files only when the full page is loaded, 
    // otherwise the page scrolls up when we click on the download icon. 
    Pace.on('done', function() {
      $rootScope.pageLoaded = true;
      wijmo.Control.invalidateAll();
    });
   
    av.$onInit = function() {

      policiesService.getActualPolicy().subscribe(function(policy) {
        av.showSpinner = true;

        if (policy) {
          policy.borrower = borrowersService.getCurrentBorrower();
          premiumService.getCashValuesByPolicy(policy).then(function(cashValues) {
            var cv = new wijmo.collections.CollectionView(cashValues, {
              sortConverter: reportUtilService.sortConverter(columnsDate)
            });
            av.data = cv;
            av.showSpinner = false;
          }, function(error) {
            console.log(error);
          });
        } else {
          av.showSpinner = false;
        }
      });

    };

    av.download = function(id) {
      $window.open(configService.baseURL + '/Reports/GetCashValueDetailPDF?premID=' + id);
    }

    av.getUrl = function(id) {
      return configService.baseURL + '/Reports/GetCashValueDetailPDF?premID=' + id;
    }
  });

'use strict';

angular.module('inspinia')
  .component('accountValues', {
    templateUrl: 'app/components/account-values/account-values.html',
    controller: 'accountValuesController',
    controllerAs: 'av'
  });

'use strict';

angular.module('inspinia')
  .controller('carrierRatingDeleteController', function(feedbackMessage, toolboxService, documentsService) {

    var crd = this;
    crd.showSpinner = false;
    
    crd.delete = function() {        
      crd.showSpinner = true;
      documentsService.DeleteCarrierRatingFile(crd.document).then(function(data) {
        crd.processResponse(data);
      });
    }

    crd.processResponse = function(data) {
      crd.showSpinner = false;
      feedbackMessage.showMessage(data.Message, (data.Status === "OK") ? 'success' : 'error');
      if (data.Status === "OK") {
          toolboxService.hide();
          location.reload(); // Reload screen to update changes
      }
    }

    crd.cancel = function() {
      toolboxService.hide();
    }
});
  
'use strict';

angular.module('inspinia')
  .component('carrierRatingDelete', {
    templateUrl: 'app/components/carrier-rating-delete/carrier-rating-delete.html',
    controller: 'carrierRatingDeleteController',
    controllerAs: 'crd',
    bindings: {
      document: '<'
    }
  });

'use strict';

angular.module('inspinia')
    .factory('usersService', function (apiService) {

    	return {
    		
            getAll: function () {

    			return apiService
                    .get(['Users', 'GetAll'], true);
            },
            listRoles: function () {

    			return apiService
                    .get(['Users', 'ListRoles'], true);
            },
            update: function (user) {

                return apiService
                    .post({
                        path: ['Users', 'Update'],
                        extOpts: user                        
                    }, true);
            },
            delete: function (userName) {

                return apiService
                    .post({
                        path: ['Users', 'Delete', userName],
                        query: userName                     
                    }, true);
            },
            changePassword: function (user) {

                return apiService
                    .post({
                        path: ['Users', 'ChangePassword'],
                        extOpts: user
                    });
            },
            create: function (user) {
                return apiService
                    .post({
                        path: ['Users', 'Create'],
                        extOpts: user
                    }, true);                    
            },
            hasMultipleClients: function () {
                return apiService
                    .get(['Users', 'HasMultipleClients'], true);
            }
    	};

    });

'use strict';

angular.module('inspinia')
    .factory('toolboxService', function () {

        var updateOptions = new Rx.Subject();
        var localOptions = {};
        return {
            getOptions: function () {
                return updateOptions;
            },
            show: function () {

                this.setOptions({ show: true });
            },
            hide: function() {

                this.setOptions({ show: false });
            },
            setOptions: function (options) {

                localOptions = angular.extend(localOptions, options);

                updateOptions.onNext(localOptions);
            },

        };
    });
"use strict";

angular.module("inspinia").factory("reportsService", function(apiService) {
  return {
    getCarrierRating: function() {
      return apiService.get(["Reports", "GetCarrierRating"]);
    },
    getPolicyCV: function(borrower, status) {
      return apiService.get({
        path: ["Reports", "GetPolicyCV"],
        query: { id: borrower.BorrowerID, active: status }
      });
    },
    getLEbyPolicyBorrower: function(borrower, status) {
      return apiService.get({
        path: ["Reports", "GetLEbyPolicyBorrower"],
        query: { id: borrower.BorrowerID, active: status }
      });
    },
    getLEHistoryReport: function(borrower, status) {
      return apiService.get({
        path: ["LifeExpectancies", "GetLEsByCompanyUI"],
        query: { id: borrower.BorrowerID, active: status }
      });
    },
    getPremiumPayments: function(borrower, status) {
      return apiService.get({
        path: ["Premium", "GetPremiumsByCompanyUI"],
        query: { id: borrower.BorrowerID, active: status }
      });
    },
    getInsuredTracking: function(borrower, status) {
      return apiService.get({
        path: ["Policies", "GetInsuredtrackingReport"],
        query: { id: borrower.BorrowerID, active: status }
      });
    },
  };
});

'use strict';

angular.module('inspinia')
    .factory('reportUtilService', function (apiService) {

        return {
            getFilterFunction: function (txtFilter) {

                var checker = function (item, filter, addOneLevel) {

                    for (var k in item) {
                        var val = item[k];
                        if (wijmo.isString(val)) {
                            if (val.toLowerCase().indexOf(filter) >= 0) {
                                return true;
                            }
                        } else if (addOneLevel && wijmo.isObject(val)) {
                            return checker(val, filter, false);
                        }
                    }
                    return false;
                };

                return function (item) {

                    if (!txtFilter) return true;
                    var filter = txtFilter.toLowerCase();

                    return checker(item, filter, true);
                }

            },
            filterByInput: function (options) {

                if (options.flexGridFilter) {
                    options.flexGridFilter.clear();
                }

                if (options.flex && options.flex.itemsSource) {
                    var data = options.flex.itemsSource;
                    options.flex.select(-1, -1);
                    data.filter = this.getFilterFunction(options.search);
                    data.refresh();
                    options.flex.select(0, 0);
                }
                /*options interface {
                    flexGridFilter,
                    data = itemsSource,
                    flex,
                    search
                }*/
            },
            sortConverter: function (columnsDate) {

                return function (sd, item, value) {
                    if (columnsDate.indexOf(sd.property) != -1) {
                        if (value === '-') {
                            value = new Date(null);
                        } else {
                            value = new Date(value);
                        }
                        
                    }
                    return value;
                }
            },
            sortComparerAlphanumeric: function (a, b) {
                return wijmo.isString(a) && wijmo.isString(b)
                  ? a.localeCompare(b, undefined, {
                    numeric: true,
                    sensitivity: 'base'
                  }) // custom comparer used for strings
                  : null; // use default comparer used for everything else
              }
        };
    });
'use strict';

angular.module('inspinia')
    .factory('rememberPasswordService', function (apiService) {

        return {
            forgotPassword: function (userOrEmail) {
                return apiService
                    .get({
                        path: ['users', 'forgotpassword'],
                        query: { userOrEmail: userOrEmail }
                    });

            },
            changeForgottenPassword: function(userData, token) {
                debugger;
                return apiService
                    .post({
                        path: ['users', 'changeForgottenPassword'],
                        extOpts: {
                            token: token,
                            userName: userData.userName,
                            newPassword: userData.newPassword,
                            newPasswordConfirm: userData.newPasswordConfirm,
                            passwordAnswer: userData.passwordAnswer
                        }
                    });
            }
        };
    });

'use strict';

angular.module('inspinia')
    .factory('premiumService', function (apiService) {

        return {
            getByPolicy: function (options) {

                return apiService
                    .get({
                        path: ['Premium', 'GetByPolicyUI'],
                        query: { BorrowerId: options.borrower.BorrowerID, PoliciesID: options.Id }
                    });
            },
            getCashValuesByPolicy: function (options) {

                return apiService
                    .get({
                        path: ['Premium', 'GetCashValuesByPolicy'],
                        query: { BorrowerId: options.borrower.BorrowerID, PoliciesID: options.Id }
                    });
            }
        };
    });
"use strict";

angular
  .module("inspinia")
  .factory("policiesService", function (
    $q,
    apiService,
    cpCacheService,
    ServicesConstants
  ) {
    var actualSubject = new Rx.BehaviorSubject();
    var policyStatus = new Rx.BehaviorSubject();
    var beforeGetData = new Rx.Subject();

    var totals = function (data) {
      var ret = {
        total: 0,
        totalInForce: 0,
        female: 0,
        male: 0,
        deathBenefit: 0,
        pendingClaims: 0,
        pendingClaimsTotal: 0,
        deathBenefitCFH: 0,
        deathBenefitPHTCombined: 0,
        deathBenefitFractionalityTotal: 0,
        pendingClaimCFH: 0,
        pendingClaimPHTCombined: 0,
        pendingClaimFractionalityTotal: 0
      };

      data.forEach(function (policy) {
        if (policy.GENDER === ServicesConstants.Gender["female"]) {
          ret.female++;
        } else {
          ret.male++;
        }

        ret.totalInForce++;
        ret.deathBenefit += policy.Total_Death_Benefit;
        ret.deathBenefitCFH += policy.CFHAmount;
        ret.deathBenefitPHTCombined += policy.PHTAmount + policy.ABDAmount + policy.NiranAmount;

        if (policy.Policy_Status === ServicesConstants.Status["pendingClaim"] && policy.Active) {
          ret.pendingClaimsTotal++;
          ret.pendingClaims += policy.Total_Death_Benefit;
          ret.pendingClaimCFH += policy.CFHAmount;
          ret.pendingClaimPHTCombined += policy.PHTAmount + policy.ABDAmount + policy.NiranAmount;
        }
      });

      ret.total = ret.female + ret.male;
      ret.deathBenefitFractionalityTotal = ret.deathBenefitCFH + ret.deathBenefitPHTCombined;
      ret.pendingClaimFractionalityTotal = ret.pendingClaimCFH + ret.pendingClaimPHTCombined;

      return ret;
    };

    return {
      getActualPolicy: function () {
        return actualSubject;
      },
      onBeforeGetData: function () {
        return beforeGetData;
      },
      setActualPolicy: function (options) {
        beforeGetData.onNext(options);

        apiService.get(["Policies", "GetCompanyPolicy", options.id]).then(
          function (data) {
            actualSubject.onNext(data);
          },
          function (error) {
            console.log(error);
          }
        );
      },
      getAll: function () {
        return this.getByBorrower("all");
      },
      getByBorrower: function (borrower, status) {
        beforeGetData.onNext(borrower);

        return apiService.get({
          path: ["Policies", "GetPoliciesByCompanyUI"],
          query: { id: borrower, active: status }
        });
      },
      getByStatusBorrower: function (status, borrower, active) {
        return apiService.get({
          path: ["Policies", "GetPoliciesByStatusCompanyUI"],
          query: { BorrowerId: borrower, Status: status, Active: active }
        });
      },
      GetPoliciesGroupByStatus: function (borrower, status) {
        beforeGetData.onNext(borrower);

        return apiService.get({
          path: ["Policies", "GetPoliciesGroupByStatusByCompanyUI"],
          query: { id: borrower, active: status }
        });
      },
      getTotals: function (borrower, status) {
        var defer = $q.defer();
        var options = {
          path: ["Policies", "GetPoliciesByCompanyUI"],
          query: { id: borrower, active: status }
        };

        // var key = "getTotals/" + options.join("/");
        // var cached = cpCacheService.get(key);

        // if (!cached) {
        //   apiService.get(options).then(function(data) {
        //     var result = totals(data);

        //     cpCacheService.put(key, result);
        //     defer.resolve(result);
        //   });
        // } else {
        //   defer.resolve(cached);
        // }

        apiService.get(options).then(function (data) {
          var result = totals(data, status);
          defer.resolve(result);
        });

        return defer.promise;
      },
      GetPoliciesByCompany: function (companyId, status) {
        return apiService.get({
          path: ["Policies", "GetAllPoliciesByCompanyUI"],
          query: { id: companyId, active: status }
        });
      },
      getCurrentPolicyStatus: function () {
        return policyStatus;
      },
      setPolicyStatus: function (status) {
        policyStatus.onNext(status);
      },
      getTotalPremiumDue: function (borrower, status) {
        var defer = $q.defer();
        var options = {
          path: ["Policies", "GetTotalPremiumDue"],
          query: { id: borrower, active: status }
        };

        apiService.get(options).then(function (data) {
          defer.resolve(data);
        });

        return defer.promise;
      },
      getTotalInvestorsSharesByBorrower: function(borrower, status) {
        beforeGetData.onNext(borrower);

        return apiService.get({
          path: ["Policies", "GetTotalInvestorsSharesByBorrower"],
          query: { id: borrower, active: status }
        });
      }
    };
  });

'use strict';

angular.module('inspinia')
    .factory('logService', function (apiService) {

        return {
            getHistory: function (companyId, userName) {
                return apiService.get({
                    path: ['Log', 'GetHistory'], 
                    query: { id: companyId, userName: userName }
                });
            }
        };
    });
'use strict';

angular.module('inspinia')
    .factory('lifeExpectanciesService', function (apiService) {

        return {
            getByPolicy: function (options) {

                return apiService
                    .get(['LifeExpectancies', 'GetByPolicyUI', options.Id]);

            }
        };
    });
'use strict'

angular.module('inspinia')
    .factory('feedbackMessage', function () {

        return {

        showMessage: function(message, type) {

            toastr.options = {
                "closeButton": true,
                "debug": false,
                "progressBar": false,
                "preventDuplicates": false,
                "positionClass": "toast-bottom-center",
                "onclick": null,
                "showDuration": "400",
                "timeOut": "7000",
                "extendedTimeOut": "100",
                "showEasing": "swing",
                "showMethod": "fadeIn",
                "hideMethod": "fadeOut"
            };

            toastr[type](message);
        },

        };
    });

"use strict";

angular.module("inspinia").factory("documentsService", function(apiService) {
  return {
    GetDocumentsByCompanyUI: function(borrower, status, clientDocuments) {
      return apiService.get({
        path: ["Documents", "GetDocumentsByCompanyUI"],
        query: { BorrowerId: borrower.BorrowerID, Active: status, ClientDocuments: clientDocuments }
      });
    },
    GetDocumentsTypes: function(borrowerId, status, clientDocuments) {
      return apiService.get({
        path: ["Documents", "GetDocumentsTypes"],
        query: { BorrowerId: borrowerId, Active: status, ClientDocuments: clientDocuments }
      });
    },
    GetDocumentsZip: function(filter) {
      return apiService.get({
        path: ["Documents", "GetDocumentsZip"],
        query: filter,
        extOpts: { responseType: "arraybuffer" }
      });
    },
    Download: function(id) {
      return apiService.get({
        path: ["Documents", "GetDownload", id],
        extOpts: { responseType: "arraybuffer" }
      });
    },
    GetDocument: function(filter) {
      return apiService.get({
        path: ["Documents", "GetDocument"],
        query: filter
      });
    },
    GetExternalConfig: function(borrowerID) {
      return apiService.get({
        path: ["Documents", "GetExternalConfig"],
        query: { BorrowerId: borrowerID }
      });
    },
    GetExternalZipFolder: function(borrowerID, companyID, folderId) {
      return apiService.get({
        path: ["Documents", "GetExternalZipFolder"],
        query: { BorrowerId: borrowerID, CompanyId: companyID, FolderId: folderId },
        extOpts: { responseType: "arraybuffer"}
      });
    },
    DeleteCarrierRatingFile: function(carrierRatingReport) {
      return apiService.post({
          path: ['Documents', 'DeleteCarrierRating'],
          extOpts: carrierRatingReport
      }, true);
    },
    GetExternalFileInfo: function(filerId, token) {
      //GET "https://api.box.com/2.0/files/12345" \-H "Authorization: Bearer <ACCESS_TOKEN>"
      var xhr = new XMLHttpRequest();
      var result;
  
      xhr.open('GET', 'https://api.box.com/2.0/files/' + filerId , false); // Set the third parameter to 'false' for synchronous request
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Authorization', 'Bearer ' + token);
      xhr.onreadystatechange = function() {
        //XMLHttpRequest.DONE
        if ((xhr.readyState === 4) && (xhr.status === 200)) {
          result = JSON.parse(xhr.responseText);
        }
      };
      xhr.send();
  
      return result;
    }
  };
});

'use strict';

angular.module('inspinia')
    .factory('cpCacheService', function ($cacheFactory) {
        return $cacheFactory('cpCacheService');

    });
'use strict';

angular.module('inspinia')
    .constant('ServicesConstants', {
        Status: {
            inForce: 'Goodstanding/Inforce',
            grace: 'Grace',
            pendingClaim: 'Pending Claim',
            dbReceived: 'Death Benefit Received',
            sold: 'Sold',
            lapsed: 'Lapsed'
        },
        Gender:{
            female: 'Female',
            male: 'Male'
        }
}); 
'use strict';

angular.module('inspinia')
    .factory('configService', function () {

        return {
            baseURL: '/api',
            goToLogin: 'index.html#/login'
        };
    });
 
'use strict';

angular.module('inspinia')
    .factory('configService', function () {

        return {
            baseURL: '/api',
            goToLogin: 'index.html#/login'
        };
    });
 
'use strict';

angular.module('inspinia')
    .factory('configService__', function () {

        //var URL = '//localhost:50509/api';
        return {
            baseURL: '//localhost:50509/api',
            goToLogin: 'index.html#/login'
        };
    });
'use strict';

angular.module('inspinia')
    .factory('companyService', function (apiService) {

        var actualSubject = new Rx.BehaviorSubject();
            
        return {
            getActualCompany: function () {
                return actualSubject;
            },
            setActualCompany: function () {
                this.get().then(function (data) {   
                    actualSubject.onNext(data);
                });
            },
            get: function () {

                return apiService
                    .get(['Companies', 'Get']);

            },
            getAll: function () {

                return apiService
                    .get(['Companies', 'GetAll']);

            },
            getSettings: function (companyId) {

                return apiService
                    .get(['Companies', 'GetSettings', companyId]);

            },
            getByUser: function (isShowing) {

                return apiService
                    .get({
                        path: ['Companies', 'GetByUser'],
                        query: { isShowing: isShowing }
                      }, true);
            },
            showShareInfo: function () {
                return apiService.get(['Companies', 'GetShowShareInfo']).then(function (data) {
                    return data;
                });
            },
        };
    });
"use strict";

angular.module("inspinia").factory("borrowersService", function(apiService) {
  var actualSubject = new Rx.BehaviorSubject();
  var current = null;
  return {
    getActualBorrower: function() {
      return actualSubject;
    },
    setActualBorrower: function(borrower) {
      current = borrower;
      actualSubject.onNext(borrower);
    },
    getCurrentBorrower: function() {
      return current;
    },
    getAll: function() {
      return apiService.get(["Users", "GetActiveBorrowers"]);
    }
  };
});

'use strict';

// Create a new object, that prototypically inherits from the Error constructor
function AuthenticationError(message) {
    this.name = 'AuthenticationError';
    this.message = message || 'User authentication required.';
}
AuthenticationError.prototype = Object.create(Error.prototype);
AuthenticationError.prototype.constructor = AuthenticationError;

angular.module('inspinia')
    .factory('authenticationService', function (apiService, cpCacheService) {

        var signInAsSubject = new Rx.BehaviorSubject();

        return {
            isAuthenticated: function () {

                return apiService
                    .get(['Authentication', 'GetIsAuthenticated'], true)
                    .then(function (data) {
                        if (data && (data === true))
                            return true;
                        // anonymous
                        throw new AuthenticationError();

                    }, function (error) {
                        // promise rejected, could log the error with: console.log('error', error);
                        throw new AuthenticationError(error);
                    });
            },
            getUserData: function () {

                return apiService
                    .get(['Authentication', 'Get'],true);
            },
            getSignInAsCompany: function () {
                return signInAsSubject;
            },
            signInAsCompany: function (comapanyIds) {
                return apiService
                    .get({path:['Authentication',
                        'SignInAsCompany'],
                        query: {
                            companies: comapanyIds
                          }}, true).then(function(data) {

                            signInAsSubject.onNext(data);
                            return data;
                          });
            },
            signIn: function (credentials) {

                return apiService
                    .post({
                        path: ['Authentication', 'SignIn'],
                        extOpts: credentials
                    });
            },
            signOut: function () {

                cpCacheService.removeAll();

                return apiService.post({
                    path: ['Authentication', 'SignOut']
                });
            },
            isAdmin: function () {

                return apiService
                    .get(['Authentication',
                        'IsAdmin'], true);
            },
            isSuperAdmin: function () {

                return apiService
                    .get(['Authentication',
                        'IsSuperAdmin'], true);
            },
            isInRole: function (role) {

                return apiService
                    .get({
                        path:['Authentication', 'isInRole'],
                        query: {
                            role: role
                        }}, true);
            }
        };
    });

'use strict';

angular.module('inspinia')
    .factory('apiService', function ($q,
        $http,
        $httpParamSerializer,
        cpCacheService,
        configService) {

        var URL = configService.baseURL;
        
        return {
            get: function (options, noCache) {

                var path = [];
                var query = {};
                var extOpts = {};

                if (!angular.isArray(options)) {
                    path = options.path;
                    query = options.query;
                    extOpts = options.extOpts;
                } else {
                    path = options;
                }

                var api_url = [];
                api_url.push(URL);
                api_url = api_url.concat(path);

                var key = path.join('/') + $httpParamSerializer(query);
                var data = cpCacheService.get(key);

                if (data && !noCache) {

                    var deferrer = $q.defer();
                    deferrer.resolve(data);

                    return deferrer.promise;

                } else {
                    var req = {
                        method: 'GET',
                        url: api_url.join('/'),
                        params: query
                    };

                    req = angular.extend(req, extOpts);
                    return $http(req)
                        .then(function (response) {
                            if (typeof response.data) {
                                cpCacheService.put(key, response.data);
                                return response.data;
                            } else {
                                // invalid response
                                return response;
                            }

                        }, function (response) {
                            // something went wrong

                            if (response && response.status && response.status === 401) {
                                window.location.assign(configService.goToLogin);
                            }
                            
                        });
                }
            },
            post: function (options) {

                var api_url = [];
                api_url.push(URL);
                api_url = api_url.concat(options.path);

                return $http.post(api_url.join('/'),
                    JSON.stringify(options.extOpts),
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                ).then(function (response) {
                        if (typeof response.data) {
                            return response.data;
                        } else {
                            // invalid response
                            return response;
                        }

                    }, function (response) {
                        // something went wrong
                        throw response;
                    });
            }
        };   
    });
'use strict';

angular.module('inspinia')
    .controller('MainController', function (companyService, borrowersService) {

    var main = this;
    main.showShareInfo = false;
    
    main.$onInit = function() {
      subscribeToActualBorrower();
    }

    function subscribeToActualBorrower() {      
      main.showShareInfo = false;

      borrowersService.getActualBorrower().subscribe(function(borrower) {        
        companyService.showShareInfo().then(function(b) {        
          main.showShareInfo = b;
        });
      });
    }
  });

'use strict';

angular.module('inspinia')
    .controller('LoginController', function ($scope, $state, $timeout, authenticationService) {

        var lc = this;
        var timer = null;

        $scope.$on('$destroy', function () {
            $timeout.cancel(timer);
        });

        lc.credentials = { UserName: null, Password: null };

        lc.showError = false;
        lc.error = null;

        lc.doLogin = function () {

            authenticationService.signIn(lc.credentials).then(function (data) {
                
                if (data) {
                    lc.showError = false;

                    if (data.IsAdmin || data.IsEmployee) {
                        $state.go('portal.admin.company');
                    } else {
                        $state.go('portal.portfolio');
                    }
                }
            }, function (data) {

                lc.showError = true;
                lc.error = 'Invalid user name or password. Please try again.';

                if (data.status === 401) {
                    lc.error = 'Account has been locked. Please contact your administrator or try logging in after few minutes';
                }

                if (timer) {
                    $timeout.cancel(timer);
                }

                timer = $timeout(
                    function () {
                        lc.showError = false;
                    },
                    4000
                );
            });
        };
    });

'use strict';

angular.module('inspinia')
    .controller('RememberPasswordController', function ($state, rememberPasswordService, feedbackMessage) {
        var rpc = this;

        rpc.userOrEmail = null;

        rpc.showError = false;
        rpc.error = null;
        rpc.showGoToLoginButton = false;

        rpc.rememberPassword = function () {
            if(!rpc.userOrEmail) {
                return;
            }
            
            rememberPasswordService.forgotPassword(rpc.userOrEmail)
                .then(function(data) {
                    if (!data) {
                        feedbackMessage.showMessage('Oh no something has gone wrong!', 'error');
                    }
                    else if (data.Status === 'OK') {
                        feedbackMessage.showMessage(data.Message, 'success');
                        rpc.showGoToLoginButton = true;
                    }
                    else {
                        feedbackMessage.showMessage(data.Message, 'warning');
                    }
                });
        };

        rpc.goToLogin = function() {
            $state.go('login');
        }
    });

'use strict';

angular.module('inspinia')
    .filter('telephone', function () {
        return function (tel) {
            if (!tel) { return ''; }

            var value = tel.toString().trim().replace(/^\+/, '');

            if (value.match(/[^0-9]/)) {
                return tel;
            }

            var country, city, number;

            switch (value.length) {
                case 10: // +1PPP####### -> C (PPP) ###-####
                    country = 1;
                    city = value.slice(0, 3);
                    number = value.slice(3);
                    break;

                case 11: // +CPPP####### -> CCC (PP) ###-####
                    country = value[0];
                    city = value.slice(1, 4);
                    number = value.slice(4);
                    break;

                case 12: // +CCCPP####### -> CCC (PP) ###-####
                    country = value.slice(0, 3);
                    city = value.slice(3, 5);
                    number = value.slice(5);
                    break;

                default:
                    return tel;
            }

            if (country == 1) {
                country = "";
            }

            number = number.slice(0, 3) + '-' + number.slice(3);

            return (country + " (" + city + ") " + number).trim();
        };
    });

'use strict';

angular.module('inspinia')
    .filter('hyphen', function () {
        return function (x) {
            return x ? x : '-';
        };
    })
    .filter('fixdate', function () {
        return function (input) {
            var date = new Date(input);
            var wrongYear = new Date('12-31-1969').getFullYear();
            return (date.getFullYear() !== wrongYear) ? date : '-';
        }
    })
    .filter('capitalize', function () {
        return function (input) {
            return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
        }
    });

'use strict';

angular.module('inspinia')
  .controller('documentManagementController', function($scope,$interval,
    documentsService,
    borrowersService) {

    var dm = this;
    dm.selectedTab = 'portfolio';
    dm.listExternalConfig = [];
    dm.borrowerID = null;
    dm.stopTime = null;

    $scope.$on('$destroy', function () {
      if (dm.stopTime != null) {
        $interval.cancel(dm.stopTime);
      };
    });
   
    dm.selectTab = function(selectedTab) {
        dm.selectedTab = selectedTab;
    };
    
    dm.getHeading = function(externalConfig) {
      // Add Company Name if exists more than one
      var countByType = dm.listExternalConfig.filter(function(extCfg) {
        return extCfg.FolderType === externalConfig.FolderType;
      }).length;

      return (countByType == 1) ? externalConfig.FolderTabName  : externalConfig.FolderTabName + " " + externalConfig.CompanyName;
    }
    
    dm.getToken = function(borrower) {    
      if (dm.stopTime != null) {
        $interval.cancel(dm.stopTime);
      };
      
      dm.updateToken(borrower);
      //Refresh token 30min
      dm.stopTime = $interval(function() {
        dm.updateToken(borrower);
      }, 30*60*1000);
    }
    
    dm.updateToken = function(borrower) {
      documentsService
        .GetExternalConfig(borrower.BorrowerID).then(function(data) {
          dm.listExternalConfig = data;
        },
        function(error) {
          console.log(error);
        });        
    }

    borrowersService.getActualBorrower().subscribe(function(borrower) {
      if (borrower) {
        dm.getToken(borrower);
      }
    });
    
  });

'use strict';

angular.module('inspinia')
    .controller('ChangePasswordController', function ($location, $state, rememberPasswordService, feedbackMessage) {
        var cpc = this;

        cpc.userData = {
            userName: null,
            newPassword: null,
            newPasswordConfirm: null
        }

        cpc.showError = false;
        cpc.error = null;
        cpc.showGoToLoginButton = false;

        cpc.$onInit = function() {

        }

        cpc.changePassword = function () {
            var token = $location.search().token ? $location.search().token : '';
            rememberPasswordService.changeForgottenPassword(cpc.userData, token)
                .then(function(data) {
                    if (!data) {
                        feedbackMessage.showMessage('Oh no something has gone wrong!', 'error');
                    }
                    else if (data.Status === 'OK') {
                        feedbackMessage.showMessage(data.Message, 'success');
                        cpc.showGoToLoginButton = true;
                    }
                    else {
                        feedbackMessage.showMessage(data.Message, 'warning');
                    }
                });
        };

        cpc.goToLogin = function() {
            $state.go('login');
        }
    });

/**
 * INSPINIA - Responsive Admin Theme
 * 2.7
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if(navbarHeight > wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if(navbarHeight < wrapperHeigh){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeight  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
      .module('inspinia')
      .config(routerConfig)
      .run(routerRun);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider

      .state('portal', {
          abstract: true,
          url: '/portal',
          templateUrl: 'app/components/common/content_top_navigation.html'
      })
      .state('login', {
            url: '/login',
            templateUrl: 'app/login/login.html',
            controller: 'LoginController',
            controllerAs: 'lc'
        })
      .state('remember-password', {
        url: '/remember-password',
        templateUrl: 'app/remember-password/remember-password.html',
        controller: 'RememberPasswordController',
        controllerAs: 'rpc'
      })
      .state('change-password', {
        url: '/change-password',
        templateUrl: 'app/change-password/change-password.html',
        controller: 'ChangePasswordController',
        controllerAs: 'cpc'
      })
      .state('portal.portfolio', {
        url: '/portfolio',
        templateUrl: 'app/main/main.html',
        data: { pageTitle: 'Portfolio' },
        resolve: {
            authorizationResolver: ['authenticationService',
                function (authenticationService) {
                    return authenticationService.isAuthenticated();
                }]
        }
      })
      .state('portal.insured', {
        url: '/insured',
        templateUrl: 'app/insured/insured.html',
        data: { pageTitle: 'Insured' },
        resolve: {
            authorizationResolver: ['authenticationService',
                function (authenticationService) {
                    return authenticationService.isAuthenticated();
                }]
        }
      })
      .state('portal.reports', {
        abstract: true,
        templateUrl: 'app/reports/reports.html',
        url: '/reports'
      })
      .state('portal.reports.carrier', {
        url: '/carrier',
        templateUrl: 'app/reports/carrier.html',
        data: { pageTitle: 'Carrier Rating Report' },
        resolve: {
            authorizationResolver: ['authenticationService',
                function (authenticationService) {
                    return authenticationService.isAuthenticated();
                }]
        }
      })
      .state('portal.reports.policy', {
        url: '/policy',
        templateUrl: 'app/reports/policy.html',
        data: { pageTitle: 'Policy CV/CSV Report' },
        resolve: {
            authorizationResolver: ['authenticationService',
                function (authenticationService) {
                    return authenticationService.isAuthenticated();
                }]
        }
      })
      .state('portal.reports.le', {
        url: '/le',
        templateUrl: 'app/reports/le.html',
        data: { pageTitle: 'LE Report by Policy' },
        resolve: {
            authorizationResolver: ['authenticationService',
                function (authenticationService) {
                    return authenticationService.isAuthenticated();
                }]
        }
      })
      .state('portal.reports.insured-tracking', {
        url: '/insured-tracking',
        templateUrl: 'app/reports/insured-tracking.html',
        data: { pageTitle: 'Insured Tracking' },
        resolve: {
            authorizationResolver: ['authenticationService',
                function (authenticationService) {
                    return authenticationService.isAuthenticated();
                }]
        }
      })      
      .state('portal.reports.le-history', {
        url: '/le-history',
        templateUrl: 'app/reports/le-history.html',
        data: { pageTitle: 'LE History Report' },
        resolve: {
            authorizationResolver: ['authenticationService',
                function (authenticationService) {
                    return authenticationService.isAuthenticated();
                }]
        }
      })
      .state('portal.reports.premium', {
        url: '/premium-payment',
        templateUrl: 'app/reports/premium-payment.html',
        data: { pageTitle: 'Premium Payment History Report' },
        resolve: {
            authorizationResolver: ['authenticationService',
                function (authenticationService) {
                    return authenticationService.isAuthenticated();
                }]
        }
      })
      .state('portal.document-management', {
        url: '/document-management',
        templateUrl: 'app/document-management/document-management.html',
        controller: 'documentManagementController',
        controllerAs: 'dm',
        data: { pageTitle: 'Document Management' },
        resolve: {
            authorizationResolver: ['authenticationService',
                function (authenticationService) {
                    return authenticationService.isAuthenticated();
                }]
        }
        })

        .state('portal.admin', {
            abstract: true,
            templateUrl: 'app/admin/admin.html',
            url: '/admin'
        })
        .state('portal.admin.company', {
            url: '/company-list',
            templateUrl: 'app/admin/company.html',
            data: { pageTitle: 'Company List' },
            resolve: {
                authorizationResolver: ['authenticationService',
                    function (authenticationService) {
                        return authenticationService.isAuthenticated();
                    }]
            }
        })
        .state('portal.admin.user-list', {
            url: '/user-list',
            templateUrl: 'app/admin/user-list.html',
            data: { pageTitle: 'User List' },
            resolve: {
                authorizationResolver: ['authenticationService',
                    function (authenticationService) {
                        return authenticationService.isAuthenticated();
                    }]
            }
        })
        .state('portal.admin.carrier-rating', {
          url: '/carrier-rating',
          templateUrl: 'app/admin/carrier-rating.html',
          data: { pageTitle: 'Carrier Rating Quarter' },
          resolve: {
              authorizationResolver: ['authenticationService',
                  function (authenticationService) {
                      return authenticationService.isAuthenticated();
                  }]
          }
        })
        .state('portal.company', {
            url: '/company-list',
            templateUrl: 'app/company-list/company-list.html',
            data: { pageTitle: 'Company' },
            resolve: {
                authorizationResolver: ['authenticationService',
                    function (authenticationService) {
                        return authenticationService.isAuthenticated();
                    }]
            }
        })
        .state('error404', {
          templateUrl: 'app/error404/error404.html',
          url: '/error404'
        })
      ;

    $urlRouterProvider.when('', '/portal/portfolio');

    $urlRouterProvider.otherwise(function($injector){
        var state = $injector.get('$state');
        state.go('error404');
    });
  }

  /** @ngInject */
  function routerRun($rootScope, $state, authenticationService) {

    $rootScope.$on( '$stateChangeStart', function(event, toState , toParams, fromState, fromParams) {

        if(toState.name === 'portal.portfolio') {
            if (authenticationService.isAuthenticated()) {
                return;
            }
            else {
                $state.go('login');
                event.preventDefault();
            }
        }
    });

    $rootScope.$on("$stateChangeError", function (evt, to, from, error) {

      if (error) {
          evt.preventDefault();
          $state.go('login');
          //window.location = "/login.aspx";
      }
    });

    $rootScope.$on('$stateChangeSuccess', function () {
      rg4js('trackEvent', {
          type: 'pageView',
          path: '/' + window.location.hash
      });
    });
  }
})();

angular
  .module('inspinia')
  .factory('$exceptionHandler', function() {
    return function(exception, cause) {        
      rg4js('send', { error: exception, customData: { cause: cause }, tags: ['Angular'] });
    };
  });
'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    });



angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/change-password/change-password.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\"><div><img id=\"logo\" class=\"img-responsive\" src=\"assets/images/logo-blue-bg.png\" alt=\"logo\"><form class=\"m-t\"><div class=\"form-group\"><input id=\"UserName\" type=\"text\" class=\"form-control\" placeholder=\"Username\" ng-model=\"cpc.userData.userName\"></div><div class=\"form-group\"><input id=\"newPassword\" type=\"password\" class=\"form-control\" placeholder=\"New Password\" ng-model=\"cpc.userData.newPassword\"></div><div class=\"form-group\"><input id=\"newPasswordConfirm\" type=\"password\" class=\"form-control\" placeholder=\"Confirm New Password\" ng-model=\"cpc.userData.newPasswordConfirm\"></div><button type=\"submit\" class=\"btn btn-light-green block full-width m-b login-button\" ng-click=\"cpc.changePassword()\" popover-placement=\"right\" uib-popover=\"{{cpc.error}}\" popover-trigger=\"none\" popover-is-open=\"cpc.showError\">Change Password</button> <button type=\"button\" class=\"btn btn-light-green block full-width m-b login-button\" ng-if=\"cpc.showGoToLoginButton\" ng-click=\"cpc.goToLogin()\">Go to Login</button></form></div></div>");
$templateCache.put("app/company-list/company-list.html","<div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><company-report></company-report></div></div></div>");
$templateCache.put("app/admin/admin.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div ui-view=\"\"></div></div></div></div><toolbox options=\"{show:false}\"></toolbox>");
$templateCache.put("app/admin/carrier-rating.html","<carrier-rating-files add-feature-edit=\"true\"></carrier-rating-files>");
$templateCache.put("app/admin/company.html","<company-report></company-report>");
$templateCache.put("app/admin/user-list.html","<user-list></user-list>");
$templateCache.put("app/document-management/document-management.html","<div class=\"documents wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><policy-status-disclaimer></policy-status-disclaimer></div></div><div class=\"row\"><div class=\"col-lg-8\"><div class=\"tabs-container\"><uib-tabset><uib-tab heading=\"Portfolio Documents\" select=\"dm.selectTab(\'portfolio\')\"><div class=\"panel-body\"><portfolio-documents ng-if=\"dm.selectedTab === \'portfolio\'\" client-documents=\"false\"></portfolio-documents></div></uib-tab><uib-tab heading=\"Client Documents\" select=\"dm.selectTab(\'client\')\"><div class=\"panel-body\"><portfolio-documents ng-if=\"dm.selectedTab === \'client\'\" client-documents=\"true\"></portfolio-documents></div></uib-tab><uib-tab heading=\"{{dm.getHeading(externalConfig)}}\" select=\"dm.selectTab(externalConfig.FolderId)\" ng-repeat=\"externalConfig in dm.listExternalConfig\"><div class=\"panel-body\"><box-folder ng-if=\"dm.selectedTab === externalConfig.FolderId\" config=\"externalConfig\" borrowerid=\"dm.borrowerID\"></box-folder></div></uib-tab></uib-tabset></div></div><div class=\"col-lg-4\"><download-documents client-documents=\"dm.selectedTab === \'client\'\" ng-if=\"(dm.selectedTab === \'portfolio\') || (dm.selectedTab === \'client\')\"></download-documents></div></div></div>");
$templateCache.put("app/error404/error404.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\"><h1>404</h1><h2 style=\"font-size: 40px;\">Page not found</h2><h3>Please try one of the following pages</h3><a style=\"color: white\" href=\"/#/portal/portfolio\" class=\"btn btn-light-green block full-width m-b\">Dashboard</a></div>");
$templateCache.put("app/insured/insured.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><policy-status-disclaimer></policy-status-disclaimer></div></div><div class=\"row\"><div class=\"col-lg-12\"><portfolio-policies-list></portfolio-policies-list></div></div><div class=\"row\"><div class=\"col-lg-4\"><insured-information></insured-information></div><div class=\"col-lg-8\"><life-expectancies></life-expectancies></div></div><div class=\"row\"><div class=\"col-lg-4\"><premium-history></premium-history></div><div class=\"col-lg-8\"><account-values></account-values></div></div></div>");
$templateCache.put("app/login/login.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\"><div><img id=\"logo\" class=\"img-responsive\" src=\"assets/images/logo-blue-bg.png\" alt=\"logo\"><form class=\"m-t\"><div class=\"form-group\"><input id=\"UserName\" type=\"text\" class=\"form-control\" placeholder=\"Username\" ng-model=\"lc.credentials.UserName\"></div><div class=\"form-group\"><input id=\"Password\" type=\"password\" class=\"form-control\" placeholder=\"Password\" ng-model=\"lc.credentials.Password\"></div><button type=\"submit\" class=\"btn btn-light-green block full-width m-b login-button\" ng-click=\"lc.doLogin()\" popover-placement=\"right\" uib-popover=\"{{lc.error}}\" popover-trigger=\"none\" popover-is-open=\"lc.showError\"><i class=\"fa fa-lock\"></i> Secure Login</button> <a href=\"/#/remember-password\"><small>Forgot password?</small></a></form><p class=\"m-t\"><small>Welcome to our secure client portal.</small></p><p class=\"m-t\"><small>If you have not already received your login credentials<br>please contact NorthStar Life Services<br>at 949.265.1616 or email: <a href=\"mailto:info@northstarlife.com\">info@northstarlife.com</a></small></p></div><br><script type=\"text/javascript\" src=\"https://cdn.ywxi.net/js/1.js\" async=\"\"></script><span id=\"siteseal\"><script async=\"\" type=\"text/javascript\" src=\"https://seal.godaddy.com/getSeal?sealID=BGNYOj4d9AuTpV0WX5c3wpX5bYdhNBVndMvjEZYPd1I2j6EZBMbm9HGoxjee\"></script></span></div>");
$templateCache.put("app/remember-password/remember-password.html","<div class=\"middle-box text-center loginscreen animated fadeInDown\"><div><img id=\"logo\" class=\"img-responsive\" src=\"assets/images/logo-blue-bg.png\" alt=\"logo\"><form class=\"m-t\"><div class=\"form-group\"><input id=\"UserName\" type=\"text\" class=\"form-control\" placeholder=\"Username or Email\" ng-model=\"rpc.userOrEmail\"></div><button type=\"submit\" class=\"btn btn-light-green block full-width m-b login-button\" ng-if=\"!rpc.showGoToLoginButton\" ng-click=\"rpc.rememberPassword()\">Reset Password</button> <button type=\"button\" class=\"btn btn-light-green block full-width m-b login-button\" ng-if=\"rpc.showGoToLoginButton\" ng-click=\"rpc.goToLogin()\">Go to Login</button></form></div></div>");
$templateCache.put("app/main/main.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><policy-status-disclaimer></policy-status-disclaimer></div></div><div class=\"row\"><div ng-class=\"{\'col-md-4 col-lg-6\': !main.showShareInfo, \'col-md-2 col-lg-4\': main.showShareInfo }\" style=\"min-height:410px\"><status-policies-list></status-policies-list></div><div ng-if=\"main.showShareInfo\" class=\"col-md-2 col-lg-2\" style=\"min-height:410px\"><policy-investor-share></policy-investor-share></div><div class=\"col-md-8 col-lg-6\"><stats-panels-list></stats-panels-list></div></div><div class=\"row\"><div class=\"col-lg-12\"><portfolio-policies-list></portfolio-policies-list></div></div><toolbox options=\"{show:false}\"></toolbox></div>");
$templateCache.put("app/reports/carrier.html","<carrier-rating-report></carrier-rating-report>");
$templateCache.put("app/reports/insured-tracking.html","<insured-tracking-report></insured-tracking-report>");
$templateCache.put("app/reports/le-history.html","<le-history-report></le-history-report>");
$templateCache.put("app/reports/le.html","<le-report></le-report>");
$templateCache.put("app/reports/policy.html","<policy-report></policy-report>");
$templateCache.put("app/reports/premium-payment.html","<premium-history-report></premium-history-report>");
$templateCache.put("app/reports/reports.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><policy-status-disclaimer></policy-status-disclaimer></div></div><div class=\"row\"><div class=\"col-lg-12\"><div ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/components/carrier-rating-delete/carrier-rating-delete.html","<div class=\"ibox float-e-margins ibox-report\"><div class=\"ibox-content\" spinner=\"crd.showSpinner\"><div class=\"form-group\"><div class=\"col-sm-12\"><div class=\"checkbox\"><label>Are you sure you want to delete this Carrier Rating File?</label></div></div></div><br><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" ng-click=\"crd.delete()\" class=\"btn btn-default\">Delete</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"crd.cancel()\">Cancel</button></div></div></div></div>");
$templateCache.put("app/components/account-values/account-values.html","<div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><span class=\"pull-right entries\" ng-show=\"av.data\">{{av.data._src.length}} entries</span><h3>Account Values</h3></div><div class=\"ibox-content\" spinner=\"av.showSpinner\"><wj-flex-grid items-source=\"av.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\"><wj-flex-grid-column header=\"Download\" align=\"center\" binding=\"Prem_Reqs_NewID\" width=\"80\"><wj-flex-grid-cell-template cell-type=\"Cell\"><a href=\"{{ av.getUrl($item.Prem_Reqs_NewID) }}\" ng-if=\"$root.pageLoaded\" class=\"download-file\" target=\"_blank\" onclick=\"javascript:void(0);\" ng-click=\"javascript:void(0);\"></a><div class=\"download-file icon-disabled\" ng-if=\"!$root.pageLoaded\"></div></wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"Inquiry Date\" min-width=\"100\" align=\"center\" binding=\"InquiryDate\" width=\"*\">{{$item.InquiryDate | date:\'MM/dd/yyyy\'}}</wj-flex-grid-column><wj-flex-grid-column header=\"Cash Value\" binding=\"CURRENT_CASH_VALUE\" width=\"120\">{{$item.CURRENT_CASH_VALUE | number:2}}</wj-flex-grid-column><wj-flex-grid-column header=\"Surrender Value\" binding=\"CURRENT_SURRENDER_VALUE\" width=\"120\"></wj-flex-grid-column><wj-flex-grid-column header=\"COI\" align=\"right\" width=\"100\">{{$item.LAST_COI | number:2 | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"COI Date\" binding=\"LAST_COI_DATE\" align=\"center\" width=\"100\">{{$item.LAST_COI_DATE | date:\'MM/dd/yyyy\'}}</wj-flex-grid-column><wj-flex-grid-column header=\"COI Year\" binding=\"CurrentYear\" align=\"center\" width=\"100\">{{$item.CurrentYear | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"COI Month\" binding=\"CurrentMonth\" align=\"center\" width=\"100\">{{$item.CurrentMonth | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Lapse Criteria\" binding=\"LAPSE_CRITERIA\" align=\"left\" width=\"100\"></wj-flex-grid-column></wj-flex-grid></div></div>");
$templateCache.put("app/components/carrier-rating-edit/carrier-rating-edit.html","<div class=\"ibox float-e-margins ibox-report\"><div class=\"ibox-content\" spinner=\"cre.showSpinner\"><form class=\"form-horizontal\"><div class=\"form-group\" ng-show=\"{{cre.newCarrierRating}}\"><label for=\"company\" class=\"col-sm-3 control-label\">Year / Quarter</label><div class=\"col-sm-9\"><select class=\"form-control\" ng-model=\"cre.yearQuarter\" ng-options=\"item.description group by item.year for item in cre.years\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label for=\"description\" class=\"col-sm-3 control-label\">Description</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"description\" ng-model=\"cre.selectedDescription\"></div></div><div class=\"form-group\"><label for=\"upload\" class=\"col-sm-3 control-label\">File</label><div class=\"col-sm-9\"><button id=\"upload\" type=\"file\" ng-model=\"cre.quarterFile\" multiple=\"multiple\" ngf-select=\"\">Year/Quarter File</button> <span ng-if=\"cre.quarterFile\">{{cre.quarterFile.name}}</span></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-9\"><button type=\"submit\" ng-click=\"cre.update()\" class=\"btn btn-default\">{{(cre.newCarrierRating) ? \'Add\' : \'Update\'}}</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"cre.cancel()\">Cancel</button></div></div></form></div></div>");
$templateCache.put("app/components/borrowers-selector/borrowers-selector.html","<li uib-dropdown=\"\"><a uib-dropdown-toggle=\"\">{{ brs.currentName }} <span class=\"caret\"></span></a><ul role=\"menu\" uib-dropdown-menu=\"\" class=\"borrower-list\"><li ng-repeat=\"borrower in brs.borrowers\"><a ng-click=\"brs.setBorrower(borrower)\">{{ borrower.BorrowerName }}</a></li></ul></li>");
$templateCache.put("app/components/company-report/company-report.html","<div class=\"ibox float-e-margins le-report\"><div class=\"ibox-title\"><h3>Company List</h3></div><div class=\"ibox-content\" spinner=\"cr.showSpinner\"><wj-flex-grid class=\"full-height\" items-source=\"cr.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" control=\"cr.flex\"><wj-flex-grid-column header=\"Company ID\" binding=\"CompanyID\" align=\"left\"></wj-flex-grid-column><wj-flex-grid-column header=\"Company Name\" binding=\"CompanyFullName\" min-width=\"180\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Short Name\" binding=\"CompanyShortName\"></wj-flex-grid-column><wj-flex-grid-column header=\"Created Date\" binding=\"CreatedDate\">{{$item.CreatedDate | date:\'MM/dd/yyyy mm:hh:ss\'}}</wj-flex-grid-column><wj-flex-grid-column header=\"Status\" binding=\"Status\" align=\"center\" data-type=\"Boolean\"></wj-flex-grid-column><wj-flex-grid-column header=\"Policies\" width=\"60\" binding=\"PoliciesCount\"></wj-flex-grid-column><wj-flex-grid-column header=\"View\" align=\"center\" binding=\"\"><a ng-click=\"cr.signInAsCompany($item.CompanyID)\"><i class=\"fa fa-eye\" aria-hidden=\"true\"></i></a></wj-flex-grid-column><wj-flex-grid-column header=\"Policies effective dates\" align=\"center\" binding=\"\" width=\"140\" visible=\"{{cr.isAdmin || cr.isEmployee}}\"><a ng-click=\"cr.policyList($item.CompanyID)\"><i class=\"fa fa-calendar\" aria-hidden=\"true\"></i></a></wj-flex-grid-column><wj-flex-grid-column header=\"Login History\" align=\"center\" binding=\"\" visible=\"{{cr.isAdmin || cr.isEmployee}}\"><a ng-click=\"cr.logList($item.CompanyID)\"><i class=\"fa fa-history\" aria-hidden=\"true\"></i></a></wj-flex-grid-column><wj-flex-grid-column header=\"Company Settings\" align=\"center\" binding=\"\" visible=\"{{cr.isAdmin || cr.isEmployee}}\"><a ng-click=\"cr.companySettings($item.CompanyID)\"><i class=\"fa fa-cog\" aria-hidden=\"true\"></i></a></wj-flex-grid-column></wj-flex-grid><div class=\"text-right pager-box\"><button type=\"button\" ng-click=\"cr.download()\" class=\"btn btn-w-m btn-primary\">Download Data</button> <span class=\"ng-binding\">{{cr.data._src.length}} entries</span></div></div></div>");
$templateCache.put("app/components/carrier-rating-report/carrier-rating-report.html","<carrier-rating-files add-feature-edit=\"false\"></carrier-rating-files>");
$templateCache.put("app/components/company-selector/company-selector.html","<div ng-if=\"cs.showSpinner\">Loading...</div><span ng-if=\"!cs.showSpinner && cs.showSingleCompany\">Viewing as the client <span class=\"client-name alt-gray\">{{ cs.clients[0].name }}</span></span><div ng-if=\"!cs.showSpinner && cs.showSeveralCompanies && cs.allowJoinCompanies\" isteven-multi-select=\"\" input-model=\"cs.clients\" output-model=\"cs.selectedClients\" button-label=\"name\" item-label=\"name\" tick-property=\"ticked\" max-labels=\"3\" selection-mode=\"multiple\" helper-elements=\"reset filter\" on-open=\"cs.onOpen()\" on-reset=\"cs.onReset()\" on-close=\"cs.onClientSelection(data)\"></div><div ng-if=\"!cs.showSpinner && cs.showSeveralCompanies && !cs.allowJoinCompanies\" isteven-multi-select=\"\" input-model=\"cs.clients\" output-model=\"cs.selectedClients\" button-label=\"name\" item-label=\"name\" tick-property=\"ticked\" max-labels=\"3\" selection-mode=\"single\" helper-elements=\"reset filter\" on-open=\"cs.onOpen()\" on-reset=\"cs.onReset()\" on-item-click=\"cs.onClientSelection(data)\"></div>");
$templateCache.put("app/components/carrier-rating-files/carrier-rating-files.html","<div class=\"ibox float-e-margins carrier-rating-report ibox-report\"><div class=\"ibox-title\"><h3>Carrier Rating Report</h3><div class=\"input-group\"><input type=\"text\" class=\"form-control pull-right\" ng-model=\"crf.filter\" ng-model-options=\"{debounce: {\'default\': 800, \'blur\': 0}}\" ng-disabled=\"crf.showSpinner\"> <span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span></div></div><div class=\"ibox-content\" spinner=\"crf.showSpinner\"><wj-flex-grid class=\"full-height\" items-source=\"crf.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" initialized=\"crf.initGrid(s,a)\" control=\"crf.flex\"><wj-flex-grid-column header=\"Year\" binding=\"Year\" min-width=\"200\" width=\"*\" visible=\"false\"></wj-flex-grid-column><wj-flex-grid-column header=\"Dowload\" binding=\"Prem_Reqs_NewID\" width=\"80\" align=\"left\"><wj-flex-grid-cell-template cell-type=\"Cell\"><a href=\"{{crf.getUrl($item)}}\" class=\"download-file\" target=\"_blank\" onclick=\"javascript:void(0);\" ng-click=\"void(0);\"></a></wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"Quarter\" binding=\"Quarter\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"Description\" binding=\"Description\" min-width=\"150\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"FileName\" binding=\"FileName\" min-width=\"150\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Delete File\" align=\"center\" binding=\"\" ng-if=\"crf.addFeatureEdit\"><a ng-if=\"true\" ng-click=\"crf.deleteFile($item)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a></wj-flex-grid-column></wj-flex-grid><div class=\"text-right pager-box\"><button ng-if=\"crf.addFeatureEdit\" type=\"button\" ng-click=\"crf.addQuarter()\" class=\"btn btn-w-m btn-primary\">Add Quarter</button> <span class=\"ng-binding\">{{crf.data._src.length}} entries</span></div></div></div>");
$templateCache.put("app/components/box-folder/box-folder.html","<div class=\"float-e-margins ibox-report\"><div class=\"ibox-content\" spinner=\"bf.showSpinner\"><div class=\"text-right\"><button type=\"button\" ng-click=\"bf.downloadAll()\" class=\"btn btn-w-m btn-primary\" ng-disabled=\"bf.itemSelected == null\">Download Folder <i class=\"fa fa-download\" aria-hidden=\"true\"></i></button><br><span>{{bf.getName()}}{{bf.getSize()}}</span></div><div id=\"box-content-explorer-{{bf.config.FolderId}}\" class=\"full-height\"></div></div></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/content_top_navigation.html","<div id=\"wrapper\" class=\"top-navigation\"><div ng-include=\"\'app/components/common/top_navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\"><strong>Client Portal</strong></div><div><strong>Copyright</strong> NorthStar Life Services &copy; <span id=\"year\"></span></div></div><script lang=\"javascript\">\r\n    document.getElementById(\"year\").innerHTML = new Date().getFullYear();\r\n</script>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" href=\"\"><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">{{main.userName}}</strong></span> <span class=\"text-muted text-xs block\">Example menu<b class=\"caret\"></b></span></span></a><ul uib-dropdown-menu=\"\" class=\"animated flipInX m-t-xs\"><li><a href=\"\">Logout</a></li></ul></div><div class=\"logo-element\">IN+</div></li><li ui-sref-active=\"active\"><a ui-sref=\"index.main\"><i class=\"fa fa-laptop\"></i> <span class=\"nav-label\">Main page</span></a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.minor\"><i class=\"fa fa-desktop\"></i> <span class=\"nav-label\">Minor page</span></a></li></ul></div></nav>");
$templateCache.put("app/components/common/top_navigation.html","<header-nscp></header-nscp>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span><form role=\"search\" class=\"navbar-form-custom\" method=\"post\" action=\"\"><div class=\"form-group\"><input type=\"text\" placeholder=\"Search for something...\" class=\"form-control\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right\"><li><a href=\"\"><i class=\"fa fa-sign-out\"></i> Log out</a></li></ul></nav></div>");
$templateCache.put("app/components/company-settings/company-settings.html","<div class=\"ibox-content\" spinner=\"cs.showSpinner\"><div class=\"row\"><div class=\"col-lg-6\"><h4 class=\"text-highlight\">Web Page Settings</h4><table class=\"table table-striped\"><tbody><tr><td><span class=\"title\">Show Life Expectancies:</span></td><td><input type=\"checkbox\" ng-model=\"cs.data.Company.ShowLEMenu\" disabled=\"disabled\"></td></tr><tr><td><span class=\"title\">Show Documents:</span></td><td><input type=\"checkbox\" ng-model=\"cs.data.Company.ShowDocumentLink\" disabled=\"disabled\"></td></tr><tr><td><span class=\"title\">Show Cash Value PDF Link:</span></td><td><input type=\"checkbox\" ng-model=\"cs.data.Company.CashValue_ShowPDFVersion\" disabled=\"disabled\"></td></tr><tr><td><span class=\"title\">Show COI Year and Month:</span></td><td><input type=\"checkbox\" ng-model=\"cs.data.Company.ShowCOIYearMonth\" disabled=\"disabled\"></td></tr></tbody></table></div><div class=\"col-lg-6 divider\"><h4 class=\"text-highlight\">Documents Synced</h4><table class=\"table table-striped\"><tbody><tr ng-repeat=\"doc in cs.data.DocTypes\"><td>{{doc}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/components/insured-information/insured-information.html","<div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h3>Insured Information</h3></div><div class=\"ibox-content\" spinner=\"ii.showSpinner\"><h4 class=\"text-highlight\">{{ii.data.InsuredNameLastFirst}}</h4><div class=\"row\"><div class=\"col-lg-6\"><table class=\"table table-striped\"><col width=\"100\"><tbody><tr><td><span class=\"title\">Gender:</span></td><td class=\"text-right\">{{ii.data.Gender}}</td></tr><tr><td><span class=\"title\">Age:</span></td><td class=\"text-right\">{{ii.data.Age}}</td></tr><tr><td><span class=\"title\">Date of Birth:</span></td><td class=\"text-right\">{{ii.data.DOB | date:\'MM/dd/yyyy\'}}</td></tr><tr><td><span class=\"title\">Date of Death:</span></td><td class=\"text-right\"><span ng-if=\"ii.data.DateOfDeath\">{{ii.data.DateOfDeath | date:\'MM/dd/yyyy\'}}</span> <span ng-if=\"!ii.data.DateOfDeath\">-</span></td></tr></tbody></table></div><div class=\"col-lg-6 divider\"><table class=\"table table-striped s30x70\"><tbody><tr><td><span class=\"title\">SSN:</span></td><td class=\"text-right\">{{ii.data.SSN}}</td></tr><tr><td><span class=\"title\">Address:</span></td><td rowspan=\"2\"><div class=\"address-box\" tooltip-text-overflow=\"ii.Address + \' \' + ii.Address2\" in-height=\"true\">{{ii.Address}}&nbsp;{{ii.Address2}}</div></td></tr><tr><td>&nbsp;</td></tr><tr><td><span class=\"title\">Phone:</span></td><td class=\"text-right\">{{ii.Phone | telephone}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/components/download-documents/download-documents.html","<div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h3>Download Multiple Documents</h3></div><div class=\"ibox-content\" spinner=\"dd.showSpinner\"><p>Please select the type and the date range of the documents you want to download, and click Download Files button to download the files as a zip file.</p><form class=\"form-horizontal\"><div class=\"form-group\"><p for=\"inputEmail3\" class=\"col-sm-3 control-label\">Document Type</p><div class=\"col-sm-9\"><select class=\"form-control\" ng-model=\"dd.selectedDocumentType\" ng-options=\"documentType for documentType in dd.documentTypes\"></select></div></div><div class=\"form-group\"><p for=\"inputEmail3\" class=\"col-sm-3 control-label\">Uploaded Date</p><div class=\"col-sm-9\"><div><input type=\"radio\" value=\"all\" ng-model=\"dd.uploadedDate\"> All</div><div><input type=\"radio\" value=\"range\" ng-model=\"dd.uploadedDate\"> Range</div><div class=\"date-range\" ng-show=\"dd.uploadedDate === \'range\'\"><span>From</span> <input class=\"form-control\" type=\"datetime\" date-time=\"\" min-view=\"date\" format=\"MM/DD/YYYY\" ng-model=\"dd.date.from\"> <span>To</span> <input class=\"form-control\" type=\"datetime\" date-time=\"\" min-view=\"date\" format=\"MM/DD/YYYY\" ng-model=\"dd.date.to\"></div></div></div><p class=\"text-danger\" ng-show=\"dd.date.from.toDate() > dd.date.to.toDate()\">End date must be greater than or equal to start date</p><button type=\"button\" ng-click=\"dd.download()\" class=\"btn btn-w-m btn-primary\" ng-class=\"{\'disabled\' : !dd.selectedDocumentType}\">Download Files</button></form></div></div>");
$templateCache.put("app/components/insured-tracking-report/insured-tracking-report.html","<div class=\"ibox float-e-margins ibox-report\"><div class=\"ibox-title\"><h3>Insured Tracking Report</h3><div class=\"input-group\"><input type=\"text\" class=\"form-control pull-right\" ng-model=\"ler.filter\"> <span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span></div></div><div class=\"ibox-content\" spinner=\"ler.showSpinner\"><wj-flex-grid class=\"full-height\" items-source=\"ler.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" initialized=\"ler.initGrid(s,a)\" control=\"ler.flex\"><wj-flex-grid-column header=\"Policy Number\" binding=\"PolicyNumber\"></wj-flex-grid-column><wj-flex-grid-column header=\"Insured\" binding=\"InsuredName\" min-width=\"200\"></wj-flex-grid-column><wj-flex-grid-column header=\"Additional Insured\" binding=\"AdditionalInsuredName\" min-width=\"200\"></wj-flex-grid-column><wj-flex-grid-column header=\"Carrier\" binding=\"CarrierName\" width=\"400\"></wj-flex-grid-column><wj-flex-grid-column header=\"Death Benefit\" binding=\"DeathBenefit\" data-type=\"Number\" min-width=\"120\" align=\"left\"></wj-flex-grid-column><wj-flex-grid-column header=\"Date Of Confirm\" binding=\"DateOfConfirm\" data-type=\"Date\" format=\"MM/dd/yyyy\" align=\"center\" width=\"130\"></wj-flex-grid-column><wj-flex-grid-column header=\"Method Of Confirm\" binding=\"MethodOfConfirm\"></wj-flex-grid-column><wj-flex-grid-column header=\"Relation To Insured\" binding=\"RelationToInsured\" min-width=\"250\"></wj-flex-grid-column></wj-flex-grid><div class=\"text-right pager-box\"><button type=\"button\" ng-click=\"ler.download()\" class=\"btn btn-w-m btn-primary\">Download Data</button> <span class=\"ng-binding\">{{ler.data._src.length}} entries</span></div></div></div>");
$templateCache.put("app/components/le-history-report/le-history-report.html","<div class=\"ibox float-e-margins ibox-report\"><div class=\"ibox-title\"><h3>LE History Report</h3><div class=\"input-group\"><input type=\"text\" class=\"form-control pull-right\" ng-model=\"lehr.filter\"> <span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span></div></div><div class=\"ibox-content\" spinner=\"lehr.showSpinner\"><wj-flex-grid class=\"full-height\" items-source=\"lehr.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" initialized=\"lehr.initGrid(s,a)\" control=\"lehr.flex\"><wj-flex-grid-column header=\"Policy ID\" binding=\"ExternalId\" min-width=\"120\" align=\"left\">{{$item.ExternalId | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Insured Id\" binding=\"ExternalClientId\">{{$item.ExternalClientId | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Insured Name\" binding=\"InsuredNameLastFirst\"></wj-flex-grid-column><wj-flex-grid-column header=\"Group\" binding=\"ExternalGroup\" min-width=\"120\" align=\"left\">{{$item.ExternalGroup | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Carrier\" binding=\"INSURANCECOMPANY\"></wj-flex-grid-column><wj-flex-grid-column header=\"Policy\" binding=\"POLICYNUMBER\"></wj-flex-grid-column><wj-flex-grid-column header=\"Death Benefit\" binding=\"DEATHBENEFIT\"></wj-flex-grid-column><wj-flex-grid-column header=\"LE Report Date\" binding=\"LEDate\" align=\"center\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"Company\" binding=\"Company\" width=\"100\"></wj-flex-grid-column><wj-flex-grid-column header=\"50% (Mean) LE\" binding=\"LIFEEXPECTANCY\" align=\"center\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"Median LE\" binding=\"MEDIANLE\" align=\"center\" width=\"100\"></wj-flex-grid-column><wj-flex-grid-column header=\"85% LE\" binding=\"LE85PERCENT\" align=\"center\" width=\"100\"></wj-flex-grid-column><wj-flex-grid-column header=\"Multiplier\" binding=\"COMPANYTABLE\" align=\"center\" width=\"100\"></wj-flex-grid-column><wj-flex-grid-column header=\"Primary Impairment\" binding=\"PRIMARYIMPAIRMENT\" align=\"center\" width=\"150\"></wj-flex-grid-column></wj-flex-grid><div class=\"text-right pager-box\"><button type=\"button\" ng-click=\"lehr.download()\" class=\"btn btn-w-m btn-primary\">Download Data</button> <span class=\"ng-binding\">{{lehr.data._src.length}} entries</span></div></div></div>");
$templateCache.put("app/components/login-history/login-history.html","<div class=\"ibox float-e-margins ibox-report\"><div class=\"ibox-content\" spinner=\"lh.showSpinner\"><wj-flex-grid items-source=\"lh.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" initialized=\"lh.initGrid(s,a)\" control=\"lh.flex\"><wj-flex-grid-column header=\"Date\" binding=\"LogDateLocalTime\" css-class=\"text-highlight\" data-type=\"date\" width=\"4*\"></wj-flex-grid-column><wj-flex-grid-column header=\"User\" binding=\"UserID\" width=\"6*\"></wj-flex-grid-column><wj-flex-grid-column header=\"IP Address\" binding=\"Hostname\" width=\"4*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Log Message\" binding=\"LogMessage\" width=\"8*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Status\" binding=\"FriendlyStatus\" width=\"4*\"></wj-flex-grid-column></wj-flex-grid></div></div>");
$templateCache.put("app/components/life-expectancies/life-expectancies.html","<div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><span class=\"pull-right entries\" ng-show=\"le.data\">{{le.data._src.length}} entries</span><h3>Life Expectancies</h3></div><div class=\"ibox-content\" spinner=\"le.showSpinner\"><wj-flex-grid items-source=\"le.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" initialized=\"le.initGrid(s,a)\"><wj-flex-grid-column header=\"Report Date\" align=\"center\" min-width=\"120\" binding=\"LEDate\" width=\"*\">{{$item.LEDate | date:\'MM/dd/yyyy\' | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Company\" binding=\"Company\" min-width=\"100\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"50% (Mean)\" align=\"center\" min-width=\"100\" width=\"*\">{{$item.LIFEEXPECTANCY | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Multiplier\" align=\"center\" min-width=\"80\" binding=\"COMPANYTABLE\" data-type=\"Number\" format=\"n2\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Primary Impairment\" align=\"center\" width=\"160\">{{$item.PRIMARYIMPAIRMENT | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Smoking Class\" align=\"center\" width=\"160\">{{$item.SMOKER | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Rolled\" binding=\"Rolled\" align=\"center\" data-type=\"Boolean\" min-width=\"80\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Tertiary\" binding=\"Tertiary\" align=\"center\" data-type=\"Boolean\" min-width=\"80\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Status\" binding=\"Status\" align=\"center\" min-width=\"80\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Document\" binding=\"\" align=\"center\" min-width=\"80\" width=\"*\"><a ng-if=\"$item.Document.ExistsFile\" ng-click=\"le.download($item.Document.DocumentID)\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i></a> <i ng-if=\"!$item.Document.ExistsFile\" class=\"fa fa-download disabled\" aria-hidden=\"true\"></i></wj-flex-grid-column></wj-flex-grid></div></div>");
$templateCache.put("app/components/policy-investor-share/policy-investor-share.html","<div class=\"ibox policy-investor-share float-e-margins\"><div class=\"ibox-title\"><h3>Share Register Breakdown</h3></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"pinvshare.graphData\"><div class=\"ibox-content\" spinner=\"pinvshare.showSpinner\"><div class=\"policy-investor-share-graph\"><stats-graph graph-data=\"pinvshare.graphData\" external-options=\"pinvshare.options\"></stats-graph></div></div></div></div></div></div></div>");
$templateCache.put("app/components/le-report/le-report.html","<div class=\"ibox float-e-margins ibox-report\"><div class=\"ibox-title\"><h3>LE Report by Policy</h3><div class=\"input-group\"><input type=\"text\" class=\"form-control pull-right\" ng-model=\"ler.filter\"> <span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span></div></div><div class=\"ibox-content\" spinner=\"ler.showSpinner\"><wj-flex-grid class=\"full-height\" items-source=\"ler.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" initialized=\"ler.initGrid(s,a)\" control=\"ler.flex\"><wj-flex-grid-column header=\"Policy ID\" binding=\"Policy.ExternalId\" min-width=\"120\" align=\"left\">{{$item.ExternalId | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Insured Id\" binding=\"Policy.ExternalClientId\">{{$item.Policy.ExternalClientId | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Insured Name\" binding=\"Policy.InsuredNameLastFirst\"></wj-flex-grid-column><wj-flex-grid-column header=\"Group\" binding=\"Policy.ExternalGroup\" min-width=\"120\" align=\"left\">{{$item.ExternalGroup | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"SSN\" binding=\"Policy.SSN\"></wj-flex-grid-column><wj-flex-grid-column header=\"Carrier\" binding=\"Policy.INSURANCECOMPANY\"></wj-flex-grid-column><wj-flex-grid-column header=\"Policy\" align=\"left\" binding=\"Policy.POLICYNUMBER\"></wj-flex-grid-column><wj-flex-grid-column header=\"Gender\" binding=\"Policy.GENDER\" width=\"80\"></wj-flex-grid-column><wj-flex-grid-column header=\"DOB\" binding=\"Policy.DOB\" align=\"center\" width=\"100\">{{$item.Policy.DOB | date:\'MM/dd/yyyy\' | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Current Age\" binding=\"Policy.Age\" align=\"center\" width=\"100\"></wj-flex-grid-column><wj-flex-grid-column ng-repeat=\"providerColumn in ler.providersColumns track by $index\" header=\"{{providerColumn}}\" align=\"center\" binding=\"{{providerColumn}}\"></wj-flex-grid-column></wj-flex-grid><div class=\"text-right pager-box\"><button type=\"button\" ng-click=\"ler.download()\" class=\"btn btn-w-m btn-primary\">Download Data</button> <span class=\"ng-binding\">{{ler.data._src.length}} entries</span></div></div></div>");
$templateCache.put("app/components/policy-report/policy-report.html","<div class=\"ibox float-e-margins ibox-report\"><div class=\"ibox-title\"><h3>Policy CV/CSV Report</h3><div class=\"input-group\"><input type=\"text\" class=\"form-control pull-right\" ng-model=\"pr.filter\"> <span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span></div></div><div class=\"ibox-content\" spinner=\"pr.showSpinner\"><wj-flex-grid class=\"full-height\" items-source=\"pr.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" initialized=\"pr.initGrid(s,a)\" control=\"pr.flex\"><wj-flex-grid-column header=\"Policy ID\" binding=\"ExternalId\" min-width=\"120\" align=\"left\"></wj-flex-grid-column><wj-flex-grid-column header=\"Insured Name\" binding=\"InsuredName\"></wj-flex-grid-column><wj-flex-grid-column header=\"Group\" binding=\"ExternalGroup\" min-width=\"120\" align=\"left\"></wj-flex-grid-column><wj-flex-grid-column header=\"Carrier\" binding=\"Carrier\" width=\"100\"></wj-flex-grid-column><wj-flex-grid-column header=\"Policy\" binding=\"PolicyNumber\" align=\"left\" width=\"100\"></wj-flex-grid-column><wj-flex-grid-column header=\"Policy DB\" binding=\"DeathBenefit\" width=\"140\">{{$item.DeathBenefit | number:0}}</wj-flex-grid-column><wj-flex-grid-column header=\"ROP\" binding=\"ROP\" align=\"center\" width=\"80\"></wj-flex-grid-column><wj-flex-grid-column header=\"Age\" binding=\"Age\" align=\"center\" width=\"80\"></wj-flex-grid-column><wj-flex-grid-column header=\"Anniversary Date\" binding=\"AniversaryDate\" data-type=\"date\" align=\"center\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"Revised Policy Date\" binding=\"RevisedPolicyDate\" align=\"center\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"Policy Status\" binding=\"PolicyStatus\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"Value As Of\" binding=\"SOURCE_OF_INFORMATION_D\" width=\"100\">{{$item.SOURCE_OF_INFORMATION_D | date: \'MM/dd/yyyy\' | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"CV\" binding=\"CURRENT_CASH_VALUE\" width=\"100\"></wj-flex-grid-column><wj-flex-grid-column header=\"CSV\" binding=\"CURRENT_SURRENDER_VALUE\" width=\"150\">{{$item.CURRENT_SURRENDER_VALUE | currency:\'$\':0}}</wj-flex-grid-column><wj-flex-grid-column header=\"Carrier Last COI\" binding=\"LAST_COI\" width=\"120\">{{$item.LAST_COI | number:0}}</wj-flex-grid-column><wj-flex-grid-column header=\"COI Estimated\" binding=\"COI_ESTIMATED\" align=\"center\" width=\"120\"></wj-flex-grid-column><wj-flex-grid-column header=\"Date Last COI Taken\" binding=\"LAST_COI_DATE\" width=\"140\">{{$item.LAST_COI_DATE | date: \'MM/dd/yyyy\' | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"COI Year\" binding=\"CurrentYear\" align=\"center\" width=\"80\"></wj-flex-grid-column><wj-flex-grid-column header=\"COI Month\" binding=\"CurrentMonth\" align=\"center\" width=\"100\"></wj-flex-grid-column><wj-flex-grid-column header=\"Guarantee Charge\" binding=\"GA_CHARGE\" align=\"{{ $item.GA_CHARGE ? \'right\' : \'center\' }}\" width=\"140\">{{($item.GA_CHARGE | number:0) || \'-\' }}</wj-flex-grid-column><wj-flex-grid-column header=\"Lapse Criteria\" binding=\"LapseCriteria\" align=\"center\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"Premium Due Date\" binding=\"PremiumDueDate\" align=\"center\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"Required Premium\" binding=\"RequiredPremium\" align=\"right\" width=\"150\">{{($item.RequiredPremium | number:0) || \'-\' }}</wj-flex-grid-column><wj-flex-grid-column header=\"Grace Beginning Date\" binding=\"GraceBeginDate\" align=\"center\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"Grace End Date\" binding=\"GraceEndDate\" align=\"center\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"Grace Amount (Min Due)\" binding=\"GraceAmount\" align=\"right\" width=\"180\"></wj-flex-grid-column><wj-flex-grid-column header=\"Lapse Date\" binding=\"LapseDate\" align=\"center\" width=\"150\">{{($item.GA_CHARGE | currency:\'$\':0) || \'-\' }}</wj-flex-grid-column><wj-flex-grid-column header=\"Amount Paid\" binding=\"AmountPaid\" align=\"right\" width=\"150\">{{($item.AmountPaid | number:0) || \'-\' }}</wj-flex-grid-column><wj-flex-grid-column header=\"Amount Paid Date\" binding=\"AmountPaidDate\" align=\"center\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"Reviewer\" binding=\"ReviewerName\" align=\"center\" width=\"150\"></wj-flex-grid-column></wj-flex-grid><div class=\"text-right pager-box\"><button type=\"button\" ng-click=\"pr.download()\" class=\"btn btn-w-m btn-primary\">Download Data</button> <span class=\"ng-binding\">{{pr.data._src.length}} entries</span></div></div></div>");
$templateCache.put("app/components/header/header.html","<div class=\"navbar-fixed-top\"><div class=\"border-bottom white-bg\"><nav id=\"main-nav\" class=\"navbar navbar-static-top shadow\" role=\"navigation\"><div class=\"navbar-header\"><button aria-controls=\"navbar\" aria-expanded=\"false\" data-target=\"#navbar\" data-toggle=\"collapse\" class=\"navbar-toggle collapsed\" type=\"button\"><i class=\"fa fa-reorder\"></i></button> <a href=\"#\" class=\"navbar-brand\"><img src=\"assets/images/logo.png\" alt=\"logo\"></a><ul class=\"nav navbar-top-links navbar-right hidden-xs visible-sm-block visible-md-block\"><li class=\"welcome\"><user-settings></user-settings></li><li class=\"logout\"><a ng-click=\"hd.signOut()\"><i class=\"fa fa-sign-out\"></i> Log out</a></li></ul></div><div class=\"navbar-collapse collapse\" id=\"navbar\"><menu-nscp></menu-nscp><ul class=\"nav navbar-top-links navbar-right visible-xs-block visible-lg-block\"><li class=\"welcome\"><user-settings></user-settings></li><li class=\"logout\"><a ng-click=\"hd.signOut()\"><i class=\"fa fa-sign-out\"></i> Log out</a></li><li class=\"welcome visible-xs-block\">Viewing as the client <span class=\"client-name alt-gray\">{{ hd.companyName }}</span></li></ul></div></nav></div><div class=\"border-bottom white-bg shadow\"><div class=\"row\"><div class=\"col-sm-8 offset-header\"><nav class=\"nav-client\" role=\"navigation\"><div id=\"navbar\"><span class=\"client-name dark-blue\">Portfolio</span><ul id=\"borrower-nav\" class=\"nav navbar-nav\"><borrowers-selector></borrowers-selector></ul><span class=\"client-name dark-blue\">Policy Status</span><ul id=\"policy-status-nav\" class=\"nav navbar-nav\"><policy-status-selector></policy-status-selector></ul></div></nav></div><div class=\"col-sm-4 text-right view-as-client hidden-xs\" ng-if=\"hd.isAdmin || hd.userHasMultipleClients || hd.isEmployee\"><company-selector></company-selector></div></div></div></div>");
$templateCache.put("app/components/policy-status-disclaimer/policy-status-disclaimer.html","<div ng-if=\"!psd.policyStatus.value\" class=\"alert alert-danger policy-status-disclaimer\"><span class=\"text-center\">You\'re filtering by inactive policies. <a href=\"\" ng-click=\"psd.togglePolicyStatus()\" class=\"alert-link\">Click here</a> to switch back to only active policies.</span></div>");
$templateCache.put("app/components/policy-status-selector/policy-status-selector.html","<li uib-dropdown=\"\"><a uib-dropdown-toggle=\"\">{{ psc.currentStatus }} <span class=\"caret\"></span></a><ul role=\"menu\" uib-dropdown-menu=\"\" class=\"policy-status-list\"><li ng-repeat=\"status in psc.statuses\"><a ng-click=\"psc.setStatus(status)\">{{ status.description }}</a></li></ul></li>");
$templateCache.put("app/components/portfolio-documents/portfolio-documents.html","<div class=\"float-e-margins ibox-report\"><div class=\"ibox-content\" spinner=\"pd.showSpinner\"><wj-flex-grid class=\"full-height\" items-source=\"pd.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" initialized=\"pd.initGrid(s,a)\" control=\"pd.flex\"><wj-flex-grid-column header=\"Policy ID\" ng-if=\"!pd.clientDocuments\" binding=\"ExternalId\" min-width=\"120\" align=\"left\">{{$item.ExternalId | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Insured Name\" ng-if=\"!pd.clientDocuments\" binding=\"InsuredNameLastFirst\" min-width=\"180\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Group\" ng-if=\"!pd.clientDocuments\" binding=\"ExternalGroup\" min-width=\"120\" align=\"left\">{{$item.ExternalGroup | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Carrier\" ng-if=\"!pd.clientDocuments\" binding=\"INSURANCECOMPANY\" min-width=\"150\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Policy\" ng-if=\"!pd.clientDocuments\" binding=\"POLICYNUMBER\" min-width=\"150\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"File Name\" ng-if=\"pd.clientDocuments\" binding=\"FileName\" min-width=\"350\" align=\"left\"></wj-flex-grid-column><wj-flex-grid-column header=\"Document Type\" binding=\"DocType\" min-width=\"100\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Doc Date\" binding=\"DocumentDate\" data-type=\"date\" format=\"MM/dd/yyyy\" min-width=\"150\" align=\"center\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Sync Date\" binding=\"SyncDate\" data-type=\"date\" format=\"MM/dd/yyyy\" min-width=\"150\" align=\"center\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Notes\" binding=\"Notes\" min-width=\"150\" align=\"left\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Download\" binding=\"\" align=\"center\" min-width=\"150\" width=\"*\"><a ng-if=\"$item.ExistsFile\" ng-click=\"pd.download($item.DocumentID)\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i></a> <i ng-if=\"!$item.ExistsFile\" class=\"fa fa-download disabled\" aria-hidden=\"true\"></i></wj-flex-grid-column></wj-flex-grid><div class=\"text-right pager-box\"><span class=\"ng-binding\">{{pd.data.totalItemCount}} entries</span></div></div></div>");
$templateCache.put("app/components/portfolio-policies-detail/portfolio-policies-detail.html","<div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h3>Policy Summary: <strong class=\"text-highlight\">{{ppd.policy.InsuredNameLastFirst}}</strong></h3></div><div class=\"ibox-content\" spinner=\"ppd.showSpinner\"><table class=\"table table-striped\"><tbody><tr><td class=\"text-highlight-blue\">Carrier Name:</td><td class=\"\" tooltip-text-overflow=\"ppd.policy.CarrierName\">{{ppd.policy.CarrierName | hyphen}}</td></tr><tr><td class=\"text-highlight-blue\">Policy Type:</td><td class=\"\">{{ppd.policy.PolicyType | hyphen}}</td></tr><tr><td class=\"text-highlight-blue\">Product Type:</td><td class=\"\">{{ppd.policy.ProductType | hyphen}}</td></tr><tr><td class=\"text-highlight-blue\">Product Name:</td><td class=\"\">{{ppd.policy.ProductName | hyphen}}</td></tr><tr><td class=\"text-highlight-blue\">State of Issue:</td><td class=\"\">{{ppd.policy.StateofIssue | hyphen}}</td></tr><tr><td class=\"text-highlight-blue\">Policy Date:</td><td class=\"\">{{ppd.policy.PolicyDate | date:\'MM/dd/yyyy\' | hyphen}}</td></tr><tr><td class=\"text-highlight-blue\">Call Date:</td><td class=\"\">{{ppd.policy.CallDate | date:\'MM/dd/yyyy\' | hyphen}}</td></tr><tr><td class=\"text-highlight-blue\">Policy Status:</td><td class=\"\">{{ppd.policy.PolicyStatus | hyphen}}</td></tr><tr><td class=\"text-highlight-blue\">Cash Value:</td><td class=\"\">{{ppd.policy.CashValue | number:2 | hyphen}}</td></tr><tr><td class=\"text-highlight-blue\">Cash Surrender Value:</td><td class=\"\">{{ppd.policy.CashSurrenderValue | number:2 | hyphen}}</td></tr><tr><td class=\"text-highlight-blue\">COI Deduction Date:</td><td class=\"\">{{ppd.policy.COI_DeductionDate | date:\'MM/dd/yyyy\' | hyphen}}</td></tr><tr><td class=\"text-highlight-blue\">COI Deduction Amount:</td><td class=\"\">{{ppd.policy.COI_DeductionAmount | number:2 | hyphen}}</td></tr><tr><td class=\"text-highlight-blue\">Maturity Extension (Age):</td><td class=\"\">{{ppd.policy.MaturityExtension | hyphen}}</td></tr><tr><td class=\"text-highlight-blue\">COI Cease Age:</td><td class=\"\">{{ppd.policy.CoiCeaseAge | number:0}}</td></tr><tr><td class=\"text-highlight-blue\">COI Cease Date:</td><td class=\"\">{{ppd.policy.CoiCeaseDate | date:\'MM/dd/yyyy\' | hyphen}}</td></tr></tbody></table><div class=\"action-buttons text-right\"><a ng-if=\"ppd.policy.Prem_Reqs_NewID && ppd.policy.PolicyStatus\" ng-click=\"ppd.values(ppd.policy.Prem_Reqs_NewID)\"><i class=\"fa fa-usd\" aria-hidden=\"true\"></i> Values</a> <a ng-click=\"ppd.stream(ppd.policy.Id, ppd.policy.Number)\"><i class=\"fa fa-align-right\" aria-hidden=\"true\"></i> Stream</a> <a ng-if=\"ppd.showShareInfo\" ng-click=\"ppd.register(ppd.policy.Id, ppd.policy.Number)\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Register</a></div></div></div>");
$templateCache.put("app/components/menu/menu.html","<ul class=\"nav navbar-nav\"><li ui-sref-active=\"active\"><a ui-sref=\"portal.portfolio\">Portfolio</a></li><li ui-sref-active=\"active\"><a ui-sref=\"portal.insured\">Insured</a></li><li uib-dropdown=\"\" class=\"dropdown\" ui-sref-active=\"active\"><a class=\"count-info dropdown-toggle\" uib-dropdown-toggle=\"\" aria-haspopup=\"true\" aria-expanded=\"false\">Reports</a><ul uib-dropdown-menu=\"\" class=\"m-t-xs ng-scope dropdown-menu\"><li><a ui-sref=\"portal.reports.carrier\">Carrier Rating Report</a></li><li><a ui-sref=\"portal.reports.policy\">Policy CV/CSV Report</a></li><li><a ui-sref=\"portal.reports.le\">LE Report by Policy</a></li><li><a ui-sref=\"portal.reports.le-history\">LE History Report</a></li><li><a ui-sref=\"portal.reports.premium\">Premium Payment History Report</a></li><li><a ui-sref=\"portal.reports.insured-tracking\">Insured Tracking Report</a></li></ul></li><li ui-sref-active=\"active\"><a ui-sref=\"portal.document-management\">Document Management</a></li><li ui-sref-active=\"active\" ng-if=\"mc.userHasMultipleClients\"><a ui-sref=\"portal.company\">Companies</a></li><li uib-dropdown=\"\" class=\"dropdown\" ui-sref-active=\"active\" ng-if=\"mc.isAdmin || mc.isEmployee || mc.isEditor\"><a class=\"count-info dropdown-toggle\" uib-dropdown-toggle=\"\" aria-haspopup=\"true\" aria-expanded=\"false\">Admin</a><ul uib-dropdown-menu=\"\" class=\"m-t-xs ng-scope dropdown-menu\"><li><a ui-sref=\"portal.admin.company\">Company List</a></li><li ng-if=\"mc.isAdmin\"><a ui-sref=\"portal.admin.user-list\">User List</a></li><li ng-if=\"mc.isAdmin || mc.isEditor\"><a ui-sref=\"portal.admin.carrier-rating\">Carrier Rating Files</a></li></ul></li></ul>");
$templateCache.put("app/components/premium-history/premium-history.html","<div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><span class=\"pull-right entries\" ng-show=\"ph.data\">{{ph.data._src.length}} entries</span><h3>Premium History</h3></div><div class=\"ibox-content\" spinner=\"ph.showSpinner\"><wj-flex-grid items-source=\"ph.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" initialized=\"ph.initGrid(s,a)\"><wj-flex-grid-column header=\"Date Paid\" binding=\"DATE_ADDL_PREM_PAID\" align=\"right\" width=\"*\">{{$item.DATE_ADDL_PREM_PAID | date:\'MM/dd/yyyy\'}}</wj-flex-grid-column><wj-flex-grid-column header=\"Amount Paid\" binding=\"AMOUNT_PAID\" data-type=\"Number\" aggregate=\"Sum\" align=\"right\" width=\"*\">{{$item.AMOUNT_PAID | number:2}}<wj-flex-grid-cell-template cell-type=\"ColumnFooter\">{{$value | number:2}}</wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"Confirm Date\" binding=\"DATE_CONFIRMED_PAYMENT\" align=\"right\" width=\"*\">{{$item.DATE_CONFIRMED_PAYMENT | date:\'MM/dd/yyyy\'}}</wj-flex-grid-column></wj-flex-grid></div></div>");
$templateCache.put("app/components/portfolio-policies-list/portfolio-policies-list.html","<div class=\"row\"><div class=\"col-lg-8 ibox-column-connector\"><div class=\"ibox float-e-margins ibox-report\"><div class=\"ibox-title\"><h3>Portfolio Policies</h3><div class=\"input-group\"><input type=\"text\" class=\"form-control pull-right\" ng-model=\"ppl.filter\" ng-model-options=\"{debounce: {\'default\': 800, \'blur\': 0}}\" ng-disabled=\"ppl.showSpinner\"> <span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span></div></div><div class=\"ibox-content\" spinner=\"ppl.showSpinner\"><wj-flex-grid items-source=\"ppl.data\" is-read-only=\"true\" selection-mode=\"Row\" headers-visibility=\"Column\" initialized=\"ppl.initGrid(s,a)\" control=\"ppl.flex\"><wj-flex-grid-column header=\"Policy ID\" binding=\"ExternalId\" css-class=\"text-highlight-blue\" width=\"6*\" align=\"left\">{{$item.ExternalId | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Insured Name\" binding=\"InsuredNameLastFirst\" css-class=\"text-highlight\" min-width=\"160\" width=\"10*\" align=\"left\"></wj-flex-grid-column><wj-flex-grid-column header=\"Group\" binding=\"ExternalGroup\" min-width=\"120\" width=\"5*\" align=\"left\">{{$item.ExternalGroup | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Carrier Full Name\" binding=\"CarrierFullName\" visible=\"false\"></wj-flex-grid-column><wj-flex-grid-column header=\"Carrier\" binding=\"INSURANCECOMPANY\" min-width=\"120\" width=\"5*\" align=\"left\"></wj-flex-grid-column><wj-flex-grid-column header=\"Policy\" binding=\"POLICYNUMBER\" min-width=\"100\" width=\"5*\" align=\"left\"></wj-flex-grid-column><wj-flex-grid-column header=\"DB\" binding=\"Total_Death_Benefit\" aggregate=\"Sum\" min-width=\"100\" width=\"5*\" align=\"right\"><wj-flex-grid-cell-template cell-type=\"ColumnFooter\">{{$value | number:2}}</wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"DB Type\" binding=\"DeathBenefitType\" min-width=\"100\" width=\"5*\" align=\"center\"></wj-flex-grid-column><wj-flex-grid-column header=\"PHT\" ng-if=\"ppl.showShareInfo\" binding=\"PHTAmount\" aggregate=\"Sum\" min-width=\"100\" width=\"5*\" data-type=\"Number\" format=\"n2\" align=\"right\"><wj-flex-grid-cell-template cell-type=\"ColumnFooter\">{{$value | number:2}}</wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"CFH\" ng-if=\"ppl.showShareInfo\" binding=\"CFHAmount\" aggregate=\"Sum\" min-width=\"100\" width=\"5*\" data-type=\"Number\" format=\"n2\" align=\"right\"><wj-flex-grid-cell-template cell-type=\"ColumnFooter\">{{$value | number:2}}</wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"ABD\" ng-if=\"ppl.showShareInfo\" binding=\"ABDAmount\" aggregate=\"Sum\" min-width=\"100\" width=\"5*\" data-type=\"Number\" format=\"n2\" align=\"right\"><wj-flex-grid-cell-template cell-type=\"ColumnFooter\">{{$value | number:2}}</wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"Niran\" ng-if=\"ppl.showShareInfo\" binding=\"NiranAmount\" aggregate=\"Sum\" min-width=\"100\" width=\"5*\" data-type=\"Number\" format=\"n2\" align=\"right\"><wj-flex-grid-cell-template cell-type=\"ColumnFooter\">{{$value | number:2}}</wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"PHT %\" ng-if=\"ppl.showShareInfo\" binding=\"PHTPercent\" min-width=\"100\" width=\"5*\" data-type=\"Number\" format=\"n2\" align=\"right\">{{ $item.PHTPercent | number:2 }} %</wj-flex-grid-column><wj-flex-grid-column header=\"CFH %\" ng-if=\"ppl.showShareInfo\" binding=\"CFHPercent\" min-width=\"100\" width=\"5*\" data-type=\"Number\" format=\"n2\" align=\"right\">{{ $item.CFHPercent | number:2 }} %</wj-flex-grid-column><wj-flex-grid-column header=\"ABD %\" ng-if=\"ppl.showShareInfo\" binding=\"ABDPercent\" min-width=\"100\" width=\"5*\" data-type=\"Number\" format=\"n2\" align=\"right\">{{ $item.ABDPercent | number:2 }} %</wj-flex-grid-column><wj-flex-grid-column header=\"Niran %\" ng-if=\"ppl.showShareInfo\" binding=\"NiranPercent\" min-width=\"100\" width=\"5*\" data-type=\"Number\" format=\"n2\" align=\"right\">{{ $item.NiranPercent | number:2 }} %</wj-flex-grid-column><wj-flex-grid-column header=\"Policy Date\" data-type=\"date\" min-width=\"100\" binding=\"PolicyDate\" width=\"6*\" align=\"center\"></wj-flex-grid-column><wj-flex-grid-column header=\"Policy Type\" binding=\"PolicyType\" visible=\"false\"></wj-flex-grid-column><wj-flex-grid-column header=\"Product Type\" binding=\"ProductType\" visible=\"false\"></wj-flex-grid-column><wj-flex-grid-column header=\"Product Name\" binding=\"ProductName\" visible=\"false\"></wj-flex-grid-column><wj-flex-grid-column header=\"State of Issue\" binding=\"StateofIssue\" visible=\"false\"></wj-flex-grid-column><wj-flex-grid-column header=\"Call Date\" binding=\"CallDate\" visible=\"false\" align=\"center\"></wj-flex-grid-column><wj-flex-grid-column header=\"Status\" binding=\"Policy_Status\" min-width=\"150\" width=\"8*\" align=\"center\">{{ $item.Policy_Status | hyphen }}</wj-flex-grid-column><wj-flex-grid-column header=\"CV\" binding=\"CashValue\" visible=\"false\" align=\"right\"></wj-flex-grid-column><wj-flex-grid-column header=\"CSV\" binding=\"CashSurrenderValue\" visible=\"false\" align=\"right\"></wj-flex-grid-column><wj-flex-grid-column header=\"COI Deduction Date\" binding=\"COI_DeductionDate\" visible=\"false\" align=\"center\"></wj-flex-grid-column><wj-flex-grid-column header=\"COI Deduction Amount\" binding=\"COI_DeductionAmount\" visible=\"false\" align=\"right\"></wj-flex-grid-column><wj-flex-grid-column header=\"Maturity Extension (Age)\" binding=\"MaturityExtension\" visible=\"false\" align=\"center\"></wj-flex-grid-column><wj-flex-grid-column header=\"DOB\" data-type=\"date\" binding=\"DOB\" min-width=\"100\" width=\"5*\" align=\"center\"></wj-flex-grid-column><wj-flex-grid-column header=\"Age\" binding=\"Age\" format=\"n0\" align=\"center\" min-width=\"80\" width=\"4*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Gender\" binding=\"GENDER\" min-width=\"80\" width=\"4*\" align=\"left\"></wj-flex-grid-column><wj-flex-grid-column header=\"COI Cease Age\" binding=\"CoiCeaseAge\" format=\"n0\" min-width=\"120\" width=\"4*\" align=\"center\"></wj-flex-grid-column><wj-flex-grid-column header=\"COI Cease Date\" binding=\"CoiCeaseDate\" data-type=\"date\" format=\"MM/dd/yyyy\" min-width=\"120\" width=\"*\" align=\"center\"></wj-flex-grid-column></wj-flex-grid><div class=\"text-right pager-box\"><button type=\"button\" ng-click=\"ppl.download()\" class=\"btn btn-w-m btn-primary\">Download Data</button> <span ng-show=\"ppl.data\">{{ppl.data.totalItemCount}} entries</span></div></div></div></div><div class=\"col-lg-4\"><portfolio-policies-detail></portfolio-policies-detail></div></div>");
$templateCache.put("app/components/premium-history-report/premium-history-report.html","<div class=\"ibox float-e-margins ibox-report\"><div class=\"ibox-title\"><h3>Premium Payment History Report</h3><div class=\"input-group\"><input type=\"text\" class=\"form-control pull-right\" ng-model=\"phr.filter\"> <span class=\"input-group-addon\"><i class=\"fa fa-search\"></i></span></div></div><div class=\"ibox-content\" spinner=\"phr.showSpinner\"><wj-flex-grid class=\"full-height\" items-source=\"phr.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" initialized=\"phr.initGrid(s,a)\" control=\"phr.flex\"><wj-flex-grid-column header=\"Policy ID\" binding=\"ExternalId\" min-width=\"120\" align=\"left\">{{$item.ExternalId | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Insured Name\" binding=\"InsuredNameLastFirst\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Group\" binding=\"ExternalGroup\" min-width=\"120\" align=\"left\">{{$item.ExternalGroup | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"Carrier\" binding=\"INSURANCECOMPANY\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"Policy\" binding=\"POLICYNUMBER\" align=\"left\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"DB\" binding=\"DEATHBENEFIT\" width=\"100\"></wj-flex-grid-column><wj-flex-grid-column header=\"Date Paid\" binding=\"DATE_ADDL_PREM_PAID\" align=\"center\" width=\"150\"></wj-flex-grid-column><wj-flex-grid-column header=\"Amount Paid\" binding=\"AMOUNT_PAID\" width=\"150\"></wj-flex-grid-column></wj-flex-grid><div class=\"text-right pager-box\"><button type=\"button\" ng-click=\"phr.download()\" class=\"btn btn-w-m btn-primary\">Download Data</button> <span class=\"ng-binding\">{{phr.data._src.length}} entries</span></div></div></div>");
$templateCache.put("app/components/status-policies-detail/status-policies-detail.html","<div class=\"ibox-content\" spinner=\"spd.showSpinner\"><div class=\"row\"><div class=\"col-lg-12\"><wj-flex-grid items-source=\"spd.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" initialized=\"spd.initGrid(s,a)\" control=\"spd.flex\"><wj-flex-grid-filter></wj-flex-grid-filter><wj-flex-grid-column header=\"Insured\" binding=\"InsuredNameLastFirst\" css-class=\"text-highlight\" width=\"*\" min-width=\"150\"><wj-flex-grid-cell-template cell-type=\"ColumnFooter\">Total</wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"Carrier\" binding=\"INSURANCECOMPANY\"></wj-flex-grid-column><wj-flex-grid-column header=\"Policy Number\" binding=\"POLICYNUMBER\"></wj-flex-grid-column><wj-flex-grid-column header=\"Grace Date\" binding=\"GraceStartDate\" ng-if=\"spd.status === spd.statusTypes[\'grace\']\">{{ $item.GraceStartDate | date: \"MM/dd/yyyy\" }}</wj-flex-grid-column><wj-flex-grid-column header=\"Lapse Date\" binding=\"GraceEndDate\" ng-if=\"spd.status === spd.statusTypes[\'grace\']\">{{ $item.GraceEndDate | date: \"MM/dd/yyyy\" }}</wj-flex-grid-column><wj-flex-grid-column header=\"Grace Amount\" binding=\"GraceAmount\" align=\"left\" width=\"150\" ng-if=\"spd.status === spd.statusTypes[\'grace\']\" data-type=\"Number\" aggregate=\"Sum\"><div style=\"text-align:right\">{{ $item.GraceAmount | number: 2 }}</div><wj-flex-grid-cell-template cell-type=\"ColumnFooter\"><div style=\"text-align:right\">{{ $value | number }}</div></wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"Death Benefit\" binding=\"Total_Death_Benefit\" align=\"left\" width=\"150\" ng-if=\"spd.status === spd.statusTypes[\'pendingClaim\']\" aggregate=\"Sum\"><div style=\"text-align:right\">{{ $item.Total_Death_Benefit | number }}</div><wj-flex-grid-cell-template cell-type=\"ColumnFooter\"><div style=\"text-align:right\">{{ $value | number }}</div></wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"Date of Death\" binding=\"DateOfDeath\" align=\"center\" ng-if=\"spd.status === spd.statusTypes[\'pendingClaim\']\">{{ $item.DateOfDeath | date: \"MM/dd/yyyy\" }}</wj-flex-grid-column><wj-flex-grid-column header=\"Death Certificate Obtained\" binding=\"DEATH_CERT_STATUS_DATE\" ng-if=\"spd.status === spd.statusTypes[\'pendingClaim\']\">{{ $item.DEATH_CERT_STATUS_DATE | date: \"MM/dd/yyyy\" }}</wj-flex-grid-column><wj-flex-grid-column header=\"Claim Submitted to Carrier\" binding=\"DEATH_CLAIM_PCKG_TOCARRIER_SUB\" ng-if=\"spd.status === spd.statusTypes[\'pendingClaim\']\">{{ $item.DEATH_CLAIM_PCKG_TOCARRIER_SUB | date: \"MM/dd/yyyy\" }}</wj-flex-grid-column><wj-flex-grid-column header=\"Death Benefit\" binding=\"Total_Death_Benefit\" ng-if=\"spd.status === spd.statusTypes[\'dbReceived\']\" aggregate=\"Sum\"><wj-flex-grid-cell-template cell-type=\"ColumnFooter\">{{ $value | number }}</wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"Death Claim Paid\" binding=\"DEATH_CLAIM_PAID_AS_OF\" ng-if=\"spd.status === spd.statusTypes[\'dbReceived\']\">{{ $item.DEATH_CLAIM_PAID_AS_OF | date: \"MM/dd/yyyy\" }}</wj-flex-grid-column><wj-flex-grid-column header=\"Claim Amount Paid\" binding=\"DEATH_CLAIM_PAID_AMOUNT\" ng-if=\"spd.status === spd.statusTypes[\'dbReceived\']\" aggregate=\"Sum\"><wj-flex-grid-cell-template cell-type=\"ColumnFooter\">{{ $value | number }}</wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"Death Benefit\" binding=\"Total_Death_Benefit\" align=\"left\" width=\"150\" ng-if=\"spd.status === spd.statusTypes[\'sold\']\" aggregate=\"Sum\"><div style=\"text-align:right\">{{ $item.Total_Death_Benefit | number }}</div><wj-flex-grid-cell-template cell-type=\"ColumnFooter\"><div style=\"text-align:right\">{{ $value | number }}</div></wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"Date Sold\" binding=\"ENDDATE\" align=\"center\" ng-if=\"spd.status === spd.statusTypes[\'sold\']\">{{ $item.ENDDATE | date: \"MM/dd/yyyy\" }}</wj-flex-grid-column><wj-flex-grid-column header=\"Death Benefit\" binding=\"Total_Death_Benefit\" ng-if=\"spd.status === spd.statusTypes[\'lapsed\']\" aggregate=\"Sum\" align=\"center\" width=\"150\" data-type=\"Number\"><div style=\"text-align:right\">{{ $item.Total_Death_Benefit | number }}</div><wj-flex-grid-cell-template cell-type=\"ColumnFooter\"><div style=\"text-align:right\">{{ $value | number }}</div></wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"Date Lapsed\" binding=\"ENDDATE\" align=\"center\" ng-if=\"spd.status === spd.statusTypes[\'lapsed\']\">{{ $item.ENDDATE | date: \"MM/dd/yyyy\" }}</wj-flex-grid-column><wj-flex-grid-column header=\"Death Benefit\" binding=\"Total_Death_Benefit\" width=\"150\" align=\"left\" ng-if=\"spd.status === spd.statusTypes[\'inForce\']\" aggregate=\"Sum\"><div style=\"text-align:right\">{{ $item.Total_Death_Benefit | number }}</div><wj-flex-grid-cell-template cell-type=\"ColumnFooter\"><div style=\"text-align:right\">{{ $value | number }}</div></wj-flex-grid-cell-template></wj-flex-grid-column></wj-flex-grid><div class=\"text-right pager-box\"><span>{{ spd.data.totalItemCount }} entries</span></div></div></div></div>");
$templateCache.put("app/components/stats-panels-list/stats-panels-list.html","<div class=\"stats-panels-list\"><div class=\"row\"><div class=\"col-lg-6\"><stats-panel title=\"{{ panels.policyCount.title }}\" total=\"{{ panels.policyCount.total }}\" total-type=\"{{ panels.policyCount.totalType }}\" total-caption=\"{{ panels.policyCount.totalCaption }}\" graph-data=\"panels.policyCount.graphData\" show-spinner=\"panels.showSpinner\"></stats-panel></div><div class=\"col-lg-6 single-pie-chart\"><stats-panel title=\"{{ panels.deathBenefit.title }}\" total=\"{{ panels.deathBenefit.total }}\" total-type=\"{{ panels.deathBenefit.totalType }}\" total-caption=\"{{ panels.deathBenefit.totalCaption }}\" graph-data=\"panels.showShareInfo ? panels.deathBenefit.graphData : null\" show-spinner=\"panels.showSpinner\" external-options=\"panels.deathBenefitChartOptions\"></stats-panel></div></div><div class=\"row\"><div class=\"col-lg-6\"><total-premium-due></total-premium-due></div><div class=\"col-lg-6 single-pie-chart\"><stats-panel title=\"{{ panels.pendingClaims.title }}\" as-of-date=\"panels.pendingClaims.asOfDate\" total=\"{{ panels.pendingClaims.total }}\" total-type=\"{{ panels.pendingClaims.totalType }}\" total-caption=\"{{ panels.pendingClaims.totalCaption }}\" graph-data=\"panels.showShareInfo ? panels.pendingClaims.graphData : null\" show-spinner=\"panels.showSpinner\" external-options=\"panels.pendingClaimsChartOptions\"></stats-panel></div></div></div>");
$templateCache.put("app/components/status-policies-list/status-policies-list.html","<div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><span class=\"pull-right dark-blue as-of-date\" ng-if=\"spl.data.asOfDate\">As of: {{spl.data.asOfDate | date:\'MM/dd/yyyy\'}}</span><h3>Policy Status</h3></div><div class=\"ibox-content\" spinner=\"spl.showSpinner\"><wj-flex-grid items-source=\"spl.data\" is-read-only=\"true\" selection-mode=\"Row\" allow-sorting=\"false\" headers-visibility=\"Column\" initialized=\"spl.initGrid(s,a)\" control=\"spl.flex\" loaded-rows=\"spl.onLoadedRows(s)\"><wj-flex-grid-column header=\"Policy Status\" binding=\"Status\" css-class=\"text-highlight\" min-width=\"180\" width=\"*\"><wj-flex-grid-cell-template cell-type=\"Cell\"><div ng-click=\"spl.cellClick($item)\">​{{$item.Status}}</div></wj-flex-grid-cell-template><wj-flex-grid-cell-template cell-type=\"ColumnFooter\">Total</wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"Policy Count\" binding=\"Count\" aggregate=\"Sum\" min-width=\"150\" width=\"*\"><wj-flex-grid-cell-template cell-type=\"Cell\"><div ng-click=\"spl.cellClick($item)\">​{{$item.Count}}</div></wj-flex-grid-cell-template><wj-flex-grid-cell-template cell-type=\"ColumnFooter\">{{$value | number:0}}</wj-flex-grid-cell-template></wj-flex-grid-column><wj-flex-grid-column header=\"Death Benefit\" binding=\"SumTotalDeathBenefit\" aggregate=\"Sum\" min-width=\"150\" width=\"*\"><wj-flex-grid-cell-template cell-type=\"Cell\"><div ng-click=\"spl.cellClick($item)\">​{{$item.SumTotalDeathBenefit | number:2}}</div></wj-flex-grid-cell-template><wj-flex-grid-cell-template cell-type=\"ColumnFooter\">{{$value | number:2}}</wj-flex-grid-cell-template></wj-flex-grid-column></wj-flex-grid><div class=\"text-left\"><span>* Select status to view details</span></div></div></div>");
$templateCache.put("app/components/spinner/spinner.html","<div class=\"sk-spinner sk-spinner-fading-circle\"><div class=\"sk-circle1 sk-circle\"></div><div class=\"sk-circle2 sk-circle\"></div><div class=\"sk-circle3 sk-circle\"></div><div class=\"sk-circle4 sk-circle\"></div><div class=\"sk-circle5 sk-circle\"></div><div class=\"sk-circle6 sk-circle\"></div><div class=\"sk-circle7 sk-circle\"></div><div class=\"sk-circle8 sk-circle\"></div><div class=\"sk-circle9 sk-circle\"></div><div class=\"sk-circle10 sk-circle\"></div><div class=\"sk-circle11 sk-circle\"></div><div class=\"sk-circle12 sk-circle\"></div></div>");
$templateCache.put("app/components/total-premium-due/total-premium-due.html","<div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><span class=\"pull-right dark-blue as-of-date\" ng-if=\"tpd.asOfDate\">As of: {{ tpd.asOfDate | date: \"MM/dd/yyyy\" }}</span><h3>{{ tpd.title }}</h3></div><div class=\"ibox-content\" spinner=\"tpd.showSpinner\"><div class=\"row\"><div ng-class=\"\'col-xs-12\'\"><h1>{{ tpd.total | currency: $:2 }}<div ng-if=\"tpd.showShareInfo\" class=\"tp-fractionality\"></div></h1><ul class=\"timeline\" id=\"timeline\"><li ng-repeat=\"x in tpd.graphData\" id=\"{{$index}}\" class=\"event\" ng-class=\"{active: x.isActive}\" ng-click=\"tpd.toggleActive($event)\" tooltip-placement=\"bottom\" uib-tooltip=\"{{ x.tooltip }}\"><label for=\"{{$index}}\" class=\"timestamp\">{{x.month}}</label><div class=\"status\"></div></li></ul></div></div></div></div>");
$templateCache.put("app/components/stats-panel/stats-panel.html","<div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><span class=\"pull-right dark-blue as-of-date\" ng-if=\"panel.asOfDate\">As of: {{ panel.asOfDate | date: \"MM/dd/yyyy\" }}</span><h3>{{ panel.title }}</h3></div><div class=\"ibox-content\" spinner=\"panel.showSpinner\"><div class=\"row\"><div ng-class=\"panel.graphData ? \'col-xs-6\' : \'col-xs-12\'\"><h1 ng-if=\"panel.totalType === \'number\'\">Total {{ panel.total | number }}</h1><h1 ng-if=\"panel.totalType === \'currency\'\">{{ panel.total | currency: $:2 }}</h1><h3>{{ panel.totalCaption }}</h3></div><div class=\"col-xs-6\" ng-if=\"panel.graphData\"><stats-graph graph-data=\"panel.graphData\" external-options=\"panel.externalOptions\"></stats-graph></div></div></div></div>");
$templateCache.put("app/components/stats-graph/stats-graph.html","<div class=\"row\"><div class=\"col-xs-{{12/sg.graphData.length}} graphs\" ng-repeat=\"graph in sg.graphData\"><div class=\"graph\" ng-class=\"{\'graph-big\': sg.externalOptions && sg.externalOptions.fullHeight }\"><span ng-if=\"graph.data.length <= 2\" class=\"percentage\">{{graph.data[0] * 100 | number : 0}}%</span><canvas id=\"doughnut\" class=\"chart chart-doughnut\" ng-class=\"{\'chart-doughnut-big\': sg.externalOptions && sg.externalOptions.fullHeight }\" chart-data=\"graph.data\" chart-labels=\"graph.labels\" chart-colors=\"graph.colors\" chart-options=\"(sg.externalOptions) ? sg.externalOptions : sg.options\"></canvas></div><h3 class=\"text-center no-margins\">{{graph.title}}</h3></div></div>");
$templateCache.put("app/components/toolbox/toolbox.html","<div class=\"toolbox-box\" ng-class=\"[localOptions.wrapperClass,{show:localOptions.show}]\"><div class=\"ibox float-e-margins\" style=\"height:100%\"><div class=\"ibox-title\"><h3 class=\"text-highlight\">{{localOptions.title}}</h3></div><dynamic-content></dynamic-content><a class=\"carousel-control\" role=\"button\" data-slide=\"next\" ng-click=\"toolbox.hide()\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\"></span><span class=\"sr-only\">Next</span></a></div></div>");
$templateCache.put("app/components/user-delete/user-delete.html","<div class=\"ibox float-e-margins ibox-report\"><div class=\"ibox-content\" spinner=\"ue.showSpinner\"><div class=\"form-group\"><div class=\"col-sm-12\"><div class=\"checkbox\"><label>Are you sure you want to delete this user account?<br>All data related to the user will be lost.</label></div></div></div><br><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" ng-click=\"ud.delete()\" class=\"btn btn-default\">Delete</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"ud.cancel()\">Cancel</button></div></div></div></div>");
$templateCache.put("app/components/user/user.html","<span>Welcome</span> <span class=\"alt-gray\">{{uc.name}}</span>");
$templateCache.put("app/components/user-edit/user-edit.html","<div class=\"ibox float-e-margins ibox-report\"><div class=\"ibox-content\" spinner=\"ue.showSpinner\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"company\" class=\"col-sm-3 control-label\">Company</label><div class=\"col-sm-9\"><select class=\"form-control\" ng-change=\"ue.changeCompany(ue.selectedCompany);\" ng-model=\"ue.selectedCompany\" ng-options=\"company as company.CompanyShortName for company in ue.companyList track by company.CompanyID\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label for=\"company\" class=\"col-sm-3 control-label\">Additional Companies</label><div class=\"col-sm-9\"><select style=\"height:auto;\" class=\"form-control\" multiple=\"\" ng-model=\"ue.additionalCompanies\" ng-options=\"company as company.CompanyShortName for company in ue.additionalCompanyList track by company.CompanyID\"><option value=\"\"></option></select></div></div><div class=\"form-group\"><label for=\"login-name\" class=\"col-sm-3 control-label\">Login Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"login-name\" ng-model=\"ue.user.UserName\"></div></div><div class=\"form-group\"><label for=\"last-name\" class=\"col-sm-3 control-label\">Last Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"last-name\" ng-model=\"ue.user.LastName\"></div></div><div class=\"form-group\"><label for=\"first-name\" class=\"col-sm-3 control-label\">First Name</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"first-name\" ng-model=\"ue.user.FirstName\"></div></div><div class=\"form-group\"><label for=\"email\" class=\"col-sm-3 control-label\">E-mail</label><div class=\"col-sm-9\"><input type=\"text\" class=\"form-control\" id=\"email\" ng-model=\"ue.user.Email\"></div></div><div class=\"form-group\"><label for=\"role\" class=\"col-sm-3 control-label\">Role</label><div class=\"col-sm-9\"><select class=\"form-control\" ng-model=\"ue.user.Role\" ng-options=\"role as role for role in ue.roles\"><option value=\"\"></option></select></div></div><div class=\"form-group\" ng-show=\"{{ue.newUser}}\"><label for=\"email\" class=\"col-sm-3 control-label\">Password</label><div class=\"col-sm-9\"><input type=\"password\" class=\"form-control\" id=\"email\" ng-model=\"ue.user.NewPassword\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-9\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"ue.user.RedactName\"> Redact Insured Name</label></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-9\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"ue.user.RedactPolicyNumber\"> Redact Policy Number</label></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-9\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"ue.user.RedactSSN\"> Redact SSN</label></div></div></div><div ng-if=\"ue.isSuperAdmin\" class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-9\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"ue.user.AllowJoinCompanies\"> Allow to merge/combine companies</label></div></div></div><div class=\"col-sm-offset-3 col-sm-9\"><div class=\"separator\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-9\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"ue.user.IsLockedOut\"> Locked Out</label></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-9\"><div class=\"checkbox\"><label><input type=\"checkbox\" ng-model=\"ue.user.Disabled\"> Disabled</label></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-3 col-sm-9\"><button type=\"submit\" ng-click=\"ue.update()\" class=\"btn btn-default\">{{(ue.newUser) ? \'Add\' : \'Update\'}}</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"ue.cancel()\">Cancel</button></div></div></form></div></div>");
$templateCache.put("app/components/user-password/user-password.html","<div class=\"ibox float-e-margins ibox-report\"><div class=\"ibox-content\"><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"new-password\" class=\"col-sm-4 control-label\">New Password</label><div class=\"col-sm-8\"><input type=\"password\" class=\"form-control\" id=\"new-password\" ng-model=\"up.user.NewPassword\"></div></div><div class=\"form-group\"><label for=\"confirm-password\" class=\"col-sm-4 control-label\">Confirm Password</label><div class=\"col-sm-8\"><input type=\"password\" class=\"form-control\" id=\"confirm-password\" ng-model=\"up.confirmPassword\"></div></div><br><div class=\"form-group\"><div class=\"col-sm-offset-4 col-sm-8\"><button type=\"submit\" ng-click=\"up.update()\" class=\"btn btn-default\" ng-class=\"{\'disabled\': up.user.NewPassword !== up.confirmPassword || !up.user.NewPassword}\">Update</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"up.cancel()\">Cancel</button></div></div></form></div></div>");
$templateCache.put("app/components/user-list/user-list.html","<div class=\"ibox float-e-margins le-report\"><div class=\"ibox-title\"><h3>User List</h3></div><div class=\"ibox-content\" spinner=\"ul.showSpinner\"><wj-flex-grid class=\"full-height\" items-source=\"ul.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" initialized=\"ul.initGrid(s,a)\" control=\"ul.flex\"><wj-flex-grid-column header=\"Edit\" binding=\"\" align=\"center\" width=\"50\"><a ng-if=\"$item.Role !== \'SuperAdmin\' || ul.isSuperAdmin\" ng-click=\"ul.editUser($item)\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i></a></wj-flex-grid-column><wj-flex-grid-column header=\"Company\" binding=\"Companies\" min-width=\"180\" width=\"*\"></wj-flex-grid-column><wj-flex-grid-column header=\"UserName\" binding=\"UserName\"></wj-flex-grid-column><wj-flex-grid-column header=\"Last Name\" binding=\"LastName\"></wj-flex-grid-column><wj-flex-grid-column header=\"First Name\" binding=\"FirstName\"></wj-flex-grid-column><wj-flex-grid-column header=\"Created Date\" binding=\"CreateDate\">{{$item.CreateDate | date:\'MM/dd/yyyy\'}}</wj-flex-grid-column><wj-flex-grid-column header=\"Last Login\" binding=\"LastLogindate\">{{$item.LastLogindate | date:\'MM/dd/yyyy\'}}</wj-flex-grid-column><wj-flex-grid-column header=\"Locked Out\" binding=\"IsLockedOut\" align=\"center\" data-type=\"Boolean\"></wj-flex-grid-column><wj-flex-grid-column header=\"Disabled\" binding=\"Disabled\" align=\"center\" data-type=\"Boolean\"></wj-flex-grid-column><wj-flex-grid-column header=\"Policies\" binding=\"PoliciesCompanyCount\"></wj-flex-grid-column><wj-flex-grid-column header=\"Change Password\" align=\"center\" binding=\"\"><a ng-if=\"$item.Role !== \'SuperAdmin\' || ul.isSuperAdmin\" ng-click=\"ul.changePassword($item)\"><i class=\"fa fa-key\" aria-hidden=\"true\"></i></a></wj-flex-grid-column><wj-flex-grid-column header=\"Delete User\" align=\"center\" binding=\"\"><a ng-if=\"$item.Role !== \'SuperAdmin\' || ul.isSuperAdmin\" ng-click=\"ul.deleteUser($item)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></a></wj-flex-grid-column><wj-flex-grid-column header=\"Login History\" align=\"center\" binding=\"\"><a ng-click=\"ul.loginHistory($item.CompanyID, $item.UserName)\"><i class=\"fa fa-history\" aria-hidden=\"true\"></i></a></wj-flex-grid-column></wj-flex-grid><div class=\"text-right pager-box\"><button type=\"button\" ng-click=\"ul.addUser()\" class=\"btn btn-w-m btn-primary\">Add User</button> <button type=\"button\" ng-click=\"ul.download()\" class=\"btn btn-w-m btn-primary download-data\">Download Data</button> <span class=\"ng-binding\">{{ul.data._src.length}} entries</span></div></div></div>");
$templateCache.put("app/components/view-detail/view-detail.html","<div class=\"row\"><div class=\"col-lg-{{vd.currentColumns}} animated slideInRight\"><ng-transclude ng-transclude-slot=\"parent\"></ng-transclude><a class=\"right carousel-control\" role=\"button\" data-slide=\"next\" ng-click=\"vd.toggleView($event)\"><span class=\"glyphicon glyphicon-chevron-right\" aria-hidden=\"true\" ng-class=\"{\'fa-rotate-180\': vd.showDetail}\"></span><span class=\"sr-only\">Next</span></a></div><div class=\"col-lg-{{vd.childColumns}} animated slideInRight\" ng-class=\"{\'hidden\': !vd.showDetail}\" ng-transclude=\"child\"></div></div>");
$templateCache.put("app/components/policies-list/policies-list.html","<div class=\"ibox float-e-margins ibox-report\"><div class=\"ibox-content\" spinner=\"plc.showSpinner\"><wj-flex-grid items-source=\"plc.data\" is-read-only=\"true\" selection-mode=\"None\" headers-visibility=\"Column\" initialized=\"plc.initGrid(s,a)\" control=\"plc.flex\"><wj-flex-grid-column header=\"Insured Name\" binding=\"InsuredNameLastFirst\" css-class=\"text-highlight\" width=\"10*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Carrier\" binding=\"INSURANCECOMPANY\" width=\"5*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Policy\" binding=\"POLICYNUMBER\" width=\"5*\"></wj-flex-grid-column><wj-flex-grid-column header=\"DB\" binding=\"DEATHBENEFIT\" width=\"5*\"></wj-flex-grid-column><wj-flex-grid-column header=\"Effective Date\" width=\"4*\" align=\"center\">{{$item.ServiceStartDate | date:\'MM/dd/yyyy\' | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"End Date\" width=\"4*\" align=\"center\">{{$item.ServiceEndDate | date:\'MM/dd/yyyy\' | hyphen}}</wj-flex-grid-column><wj-flex-grid-column header=\"End Reason\" binding=\"EndReason\" width=\"5*\" align=\"center\">{{$item.EndReason | hyphen}}</wj-flex-grid-column></wj-flex-grid></div></div>");}]);